(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9782],{

/***/ 62953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies",
      function () {
        return __webpack_require__(15314);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ A; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: ",
        ";\n          text-decoration: ",
        ";\n          &:hover {\n            text-decoration: underline;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var A = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Anchor(props, ref) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), props.color || plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, props.decoration || "underline"),
        ref: ref,
        "data-test-id": props.dataTestId
    }, props));
});


/***/ }),

/***/ 56894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);








var Breadcrumb = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? "light-bg" : _theme, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme"
    ]);
    var textColor = theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.text */ .O9.text : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ol", {
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0;padding:0;display:flex;align-items:center;color:", textColor, ";font-size:11px;line-height:1.45;li:not(:last-child)::after{content:'/';margin:0 5px;color:", theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray70 */ .O9.gray70 : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";font-size:11px;line-height:1.45;}a{transition:text-decoration 0.2s ease;text-decoration:underline solid transparent;:hover{text-decoration:underline solid ", textColor, ";}}a:visited,a:link{color:", textColor, ";}"),
        className: props.className,
        children: props.children.map(function(component, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("li", {
                    itemProp: "itemListElement",
                    itemScope: true,
                    itemType: "https://schema.org/ListItem",
                    children: [
                        component,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                            itemProp: "position",
                            content: i + 1 + ""
                        })
                    ]
                })
            }, i);
        })
    });
};
var BreadcrumbLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
            itemProp: "item",
            className: props.className,
            target: props.external ? "_blank" : "_top",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                itemProp: "name",
                children: props.children
            })
        })
    }));
};
var BreadcrumbItem = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
        itemProp: "name",
        className: props.className,
        children: props.children
    });
};


/***/ }),

/***/ 67910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ EnterpriseGuide; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48261);







var EnterpriseGuide = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 auto;display:flex;flex-direction:column;align-items:center;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";padding:56px 64px;justify-content:center;max-width:1120px;"),
        className: "enterprise-guide " + props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("p", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0;margin-block-start:36px;font-size:16px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";text-align:center;"),
                children: [
                    "有料契約限定のコンテンツです。",
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
                    "無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:40px;width:100%;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
                    src: "/static/images/enterprise/paywall.png"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:56px;display:flex;flex-direction:column;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .trialRequestUrl */ .d1,
                        passHref: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "normal",
                                children: "無料トライアルに申し込む"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:16px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                            href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .loginPath */ .Qv,
                            decoration: "none",
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:16px;"),
                            children: "契約済みの方はログインしてください"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 82786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LoadingOverlay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react_loading_overlay_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45414);




var LoadingOverlay = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_loading_overlay_ts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        spinner: true,
        fadeSpeed: 100,
        styles: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            spinner: function(base) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, base), {
                    width: "100px",
                    "& svg circle": {
                        stroke: "rgba(210, 214, 219, 0.5)"
                    }
                });
            }
        }, props.styles)
    }));
};


/***/ }),

/***/ 93536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ DatePicker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95570);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78966);
/* harmony import */ var date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40944);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96747);











var DatePicker = function(props) {
    var ref;
    var onDelete = props.onDelete;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("box-shadow:0px 0px 10px rgba(0,0,0,0.1);> div{", ((ref = props.className) === null || ref === void 0 ? void 0 : ref.includes("first-interview-calender")) && " background: white;", "}// Override react-datepicker's style\n        .react-datepicker{font-family:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.family */ .LZ.family, ";border:none;}.react-datepicker__month-container{padding:10px 0px 5px;}.react-datepicker__header{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";border-bottom:none;margin-bottom:-8px;}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{line-height:28px;width:28px;margin:5px;}.react-datepicker__day{border-radius:50%;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.text */ .O9.text, ";transition:background-color 0.3s;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";}&:focus{outline:none;}}.react-datepicker__day--outside-month{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60, ";}.react-datepicker__day--selected{border-radius:50%;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, ";}}div.react-datepicker__day--today{font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";border:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, " !important;width:30px;}.react-datepicker__day--today.react-datepicker__day--selected{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, " !important;}.react-datepicker__day-name{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:12px;}.react-datepicker__day--disabled{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60, ";&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";}}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((react_datepicker__WEBPACK_IMPORTED_MODULE_6___default()), {
                dateFormat: "yyyy-MM-dd",
                showMonthDropdown: true,
                showYearDropdown: true,
                dropdownMode: "select",
                inline: true,
                disabledKeyboardNavigation: true,
                locale: date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                selected: props.selected,
                maxDate: props.maxDate,
                minDate: props.minDate,
                onChange: props.onChange,
                renderCustomHeader: function(args) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CustomHeader, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, args), {
                        minDate: props.minDate,
                        maxDate: props.maxDate
                    }));
                }
            }),
            onDelete && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;justify-content:flex-end;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                    className: "clear-date-button",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";margin-right:16px;margin-bottom:16px;font-size:12px;cursor:pointer;:hover{text-decoration:underline;}"),
                    onClick: function() {
                        return onDelete();
                    },
                    children: "選択内容をクリア"
                })
            })
        ]
    });
};
var CustomHeader = function(props) {
    var minYear = props.minDate ? (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.minDate) : (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(new Date()) - 30;
    var maxYear = props.maxDate ? (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate) : (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(new Date()) + 10;
    var years = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(minYear, maxYear + 1);
    var months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, 13);
    var handlePrevMonthClick = function() {
        if (!props.prevMonthButtonDisabled) {
            props.decreaseMonth();
        }
    };
    var handleNextMonthClick = function() {
        if (!props.nextMonthButtonDisabled) {
            props.increaseMonth();
        }
    };
    var handleChangeYear = function(year) {
        if (props.maxDate && year === (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate)) {
            // 今日の日付が渡された場合、表示する月を今月に制限する
            months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, (0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.maxDate) + 2);
        } else {
            months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, 13);
        }
        props.changeYear(year);
    };
    var handleChangeMonth = function(month) {
        if (props.maxDate && (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.date) === (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate) && month > (0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.maxDate)) {
            return; // 今日の日付が渡された場合、maxDateの月を超える月の選択は許可しない
        }
        props.changeMonth(months.indexOf(month));
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;justify-content:space-between;padding:5px 10px;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                onClick: handlePrevMonthClick,
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;color:", props.prevMonthButtonDisabled ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60 : plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";transition:background-color 0.3s;", !props.prevMonthButtonDisabled && "\n            &:hover {\n              cursor: pointer;\n              background-color: ".concat(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";\n          ")),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
                    name: "arrow4-left"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Select, {
                        value: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.date),
                        onChange: function(param) {
                            var target = param.target;
                            return handleChangeYear(parseInt(target.value));
                        },
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:85px;margin-right:3px;"),
                        children: years.map(function(option) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("option", {
                                value: option,
                                children: "".concat(option, "年")
                            }, option);
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Select, {
                        value: months[(0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.date)],
                        onChange: function(param) {
                            var target = param.target;
                            handleChangeMonth(parseInt(target.value));
                        },
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:65px;"),
                        children: months.map(function(option) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("option", {
                                value: option,
                                children: "".concat(option, "月")
                            }, option);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                className: "next-month-button",
                onClick: handleNextMonthClick,
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;color:", props.nextMonthButtonDisabled ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60 : plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";transition:background-color 0.3s;", !props.nextMonthButtonDisabled && "\n            &:hover {\n              cursor: pointer;\n              background-color: ".concat(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";\n          ")),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
                    name: "arrow4-right"
                })
            })
        ]
    });
};
var Select = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("select", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border:none;font-size:14px;padding:5px 6px;border-radius:2px;transition:background-color 0.3s;&:focus{outline:none;}&:hover{cursor:pointer;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";}")
    }));
};


/***/ }),

/***/ 33869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Help; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var Help = function(props) {
    var ref;
    if (props.linkTo) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                label: props.children ? (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
                id: "help",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: props.linkTo,
                    target: "_blank",
                    rel: "noopener",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";vertical-align:middle;&:active,&:visited{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                        text: props.children,
                        className: props.className,
                        size: props.size,
                        offset: props.offset
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: props.children ? (ref = props.children) === null || ref === void 0 ? void 0 : ref.toString() : "",
            id: "help",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                text: props.children,
                className: props.className,
                size: props.size,
                offset: props.offset
            })
        })
    });
};
var Icon = function(props) {
    var ref;
    var offset = "{'top': ".concat(((ref = props.offset) === null || ref === void 0 ? void 0 : ref.top) || 0, "}");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        "data-for": "help",
        "data-offset": offset,
        "data-tip": props.text,
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "question-circle-fill",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", props.size === "large" ? "20px" : "14px", ";")
        })
    });
};


/***/ }),

/***/ 30291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EnterpriseGuideTemplate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _common_Head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12912);
/* harmony import */ var _common_Template__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33431);
/* harmony import */ var _atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67910);





var EnterpriseGuideTemplate = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Head__WEBPACK_IMPORTED_MODULE_1__/* .DefaultHead */ .UJ, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Template__WEBPACK_IMPORTED_MODULE_2__/* .Template */ .Y, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__/* .EnterpriseGuide */ .w, {})
            })
        ]
    });
};


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useDebounce = function(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};


/***/ }),

/***/ 39250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ toLowerCase; },
/* harmony export */   "e": function() { return /* binding */ formatLastFundingType; }
/* harmony export */ });
var formatLastFundingType = function(roundType) {
    return roundType.replace("post_ipo", "Post-IPO").replace("pre_seed", "Pre-Seed").replace("non_equity", "Non-equity").split("_").map(function(it) {
        return it.charAt(0).toUpperCase() + it.slice(1);
    }).join(" ");
};
var toLowerCase = function(roundType) {
    return roundType.replace("Post-IPO", "post_ipo").replace("Pre-Seed", "pre_seed").replace("Non-equity", "non_equity").split(" ").map(function(it) {
        return it.charAt(0).toLowerCase() + it.slice(1);
    }).join("_");
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 15314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ companies; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./components/atoms/Breadcrumb.tsx
var Breadcrumb = __webpack_require__(56894);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./components/view/EnterpriseGuide.tsx
var EnterpriseGuide = __webpack_require__(30291);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/pages/companies/constants/conditions.ts
var constants_conditions = __webpack_require__(96001);
;// CONCATENATED MODULE: ./components/pages/companies/actions/type.ts

// https://github.com/Microsoft/TypeScript/issues/24243
var getKeys = function(o) {
    return Object.keys(o);
};
var RADIO_CONDITION_NAMES = getKeys(constants_conditions/* RADIO_CONDITION_ITEMS */.P7);
var CHECK_CONDITION_NAMES = getKeys(constants_conditions/* CHECK_CONDITION_ITEMS */.hy);
var AMOUNT_RANGE_CONDITION_NAMES = getKeys(constants_conditions/* AMOUNT_RANGE_CONDITION_ITEMS */.Ox);
var PEOPLE_RANGE_CONDITION_NAMES = getKeys(constants_conditions/* PEOPLE_RANGE_CONDITION_ITEMS */.WK);
var PERIOD_CONDITION_NAMES = getKeys(constants_conditions/* PERIOD_CONDITION_ITEMS */.Wz);

;// CONCATENATED MODULE: ./components/pages/companies/actions/search.ts
// @flow
var REQUEST_SEARCH = "REQUEST_SEARCH";
function requestSearch() {
    return {
        type: REQUEST_SEARCH
    };
}
var SUCCESS_SEARCH = "SUCCESS_SEARCH";
function successSearch(data) {
    return {
        type: SUCCESS_SEARCH,
        payload: data
    };
}
var FAILURE_SEARCH = "FAILURE_SEARCH";
function failureSearch(e) {
    console.log("Error: FAILURE_SEARCH", e);
    return {
        type: FAILURE_SEARCH
    };
}
var REQUEST_DOWNLOAD = "REQUEST_DOWNLOAD";
function requestDownload() {
    return {
        type: REQUEST_DOWNLOAD
    };
}
var SUCCESS_DOWNLOAD = "SUCCESS_DOWNLOAD";
function successDownload() {
    return {
        type: SUCCESS_DOWNLOAD
    };
}
var FAILURE_DOWNLOAD = "FAILURE_DOWNLOAD";
function failureDownload(e) {
    console.log("Error: FAILURE_DOWNLOAD", e);
    return {
        type: FAILURE_DOWNLOAD
    };
}
var FETCH_COMPANIES = "FETCH_COMPANY";
function fetchCompanies() {
    return {
        type: FETCH_COMPANIES
    };
}
var CHANGE_STATUS = "CHANGE_STATUS";
function changeStatus(payload) {
    return {
        type: CHANGE_STATUS,
        payload: payload
    };
}
var DELETE_COMPANY_STATUS = "DELETE_COMPANY_STATUS";
function deleteCompanyStatus(payload) {
    return {
        type: DELETE_COMPANY_STATUS,
        payload: payload
    };
}
var CHANGE_CONTACT_PERSON = "CHANGE_CONTACT_PERSON";
function changeContactPerson(payload) {
    return {
        type: CHANGE_CONTACT_PERSON,
        payload: payload
    };
}
var DELETE_COMPANY_CONTACT_PERSON = "DELETE_COMPANY_CONTACT_PERSON";
function deleteCompanyContactPerson(payload) {
    return {
        type: DELETE_COMPANY_CONTACT_PERSON,
        payload: payload
    };
}
var UPDATE_COMPANY_MEMO = "UPDATE_COMPANY_MEMO";
function updateCompanyMemo(payload) {
    return {
        type: UPDATE_COMPANY_MEMO,
        payload: payload
    };
}
var UPDATE_COMPANY_FIRST_INTERVIEW_DATE = "UPDATE_COMPANY_FIRST_INTERVIEW_DATE";
function updateCompanyFirstInterviewDate(payload) {
    return {
        type: UPDATE_COMPANY_FIRST_INTERVIEW_DATE,
        payload: payload
    };
}
var DELETE_COMPANY_FIRST_INTERVIEW_DATE = "DELETE_COMPANY_FIRST_INTERVIEW_DATE";
function deleteCompanyFirstInterviewDate(payload) {
    return {
        type: DELETE_COMPANY_FIRST_INTERVIEW_DATE,
        payload: payload
    };
}
var SUCCESS_CHANGE_STATUS = "SUCCESS_CHANGE_STATUS";
function successChangeStatus(payload) {
    return {
        type: SUCCESS_CHANGE_STATUS,
        payload: payload
    };
}
var FAILED_CHANGE_STATUS = "FAILED_CHANGE_STATUS";
function faildChangeStatus(message) {
    console.log("Error:  FAILED_CHANGE_STATUS", message);
    return {
        type: FAILED_CHANGE_STATUS
    };
}
var SUCCESS_CHANGE_CONTACT_PERSON = "SUCCESS_CHANGE_CONTACT_PERSON";
function successChangeContactPerson(payload) {
    return {
        type: SUCCESS_CHANGE_CONTACT_PERSON,
        payload: payload
    };
}
var FAILED_CHANGE_CONTACT_PERSON = "FAILED_CHANGE_CONTACT_PERSON";
function faildChangeContactPerson(message) {
    console.log("Error:  FAILED_CHANGE_STATUS", message);
    return {
        type: FAILED_CHANGE_CONTACT_PERSON
    };
}
var SUCCESS_DELETE_COMPANY_STATUS = "SUCCESS_DELETE_COMPANY_STATUS";
function successDeleteCompanyStatus(payload) {
    return {
        type: SUCCESS_DELETE_COMPANY_STATUS,
        payload: payload
    };
}
var FAILED_DELETE_COMPANY_STATUS = "FAILED_DELETE_COMPANY_STATUS";
function faildDeleteCompanyStatus(message) {
    console.log("Error:  FAILED_DELETE_COMPANY_STATUS", message);
    return {
        type: FAILED_DELETE_COMPANY_STATUS
    };
}
var SUCCESS_DELETE_COMPANY_CONTACT_PERSON = "SUCCESS_DELETE_COMPANY_CONTACT_PERSON";
function successDeleteCompanyContactPerson(payload) {
    return {
        type: SUCCESS_DELETE_COMPANY_CONTACT_PERSON,
        payload: payload
    };
}
var FAILED_DELETE_COMPANY_CONTACT_PERSON = "FAILED_DELETE_COMPANY_CONTACT_PERSON";
function faildDeleteCompanyContactPerson(message) {
    console.log("Error:  FAILED_DELETE_COMPANY_CONTACT_PERSON", message);
    return {
        type: FAILED_DELETE_COMPANY_CONTACT_PERSON
    };
}
var SUCCESS_UPDATE_COMPANY_MEMO = "SUCCESS_UPDATE_COMPANY_MEMO";
function successUpdateCompanyMemo(payload) {
    return {
        type: SUCCESS_UPDATE_COMPANY_MEMO,
        payload: payload
    };
}
var SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE = "SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE";
function successUpdateCompanyFirstInterviewDate(payload) {
    return {
        type: SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE,
        payload: payload
    };
}
var SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE = "SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE";
function successDeleteCompanyFirstInterviewDate(payload) {
    return {
        type: SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE,
        payload: payload
    };
}
var SUCCESS_UPDATE_COMPANY_MY_LABELS = "SUCCESS_UPDATE_COMPANY_MY_LABELS";
function successUpdateCompanyMyLabels(payload) {
    return {
        type: SUCCESS_UPDATE_COMPANY_MY_LABELS,
        payload: payload
    };
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/condition.ts
// @flow
var CHANGE_KEYWORDS = "CHANGE_KEYWORDS";
function changeKeywords(keywords) {
    return {
        type: CHANGE_KEYWORDS,
        payload: keywords
    };
}
var SET_PAGE = "SET_PAGE";
function setPage(page) {
    return {
        type: SET_PAGE,
        payload: page
    };
}
var RESET_OFFSET = "RESET_OFFSET";
function resetOffset() {
    return {
        type: RESET_OFFSET,
        payload: 1
    };
}
var SET_TAGS = "SET_TAGS";
function setTags(tags) {
    return {
        type: SET_TAGS,
        payload: tags
    };
}
var ADD_TAGS_TO_KEYWORDS = "ADD_TAGS_TO_KEYWORDS";
function addTagsToKeywords(tags) {
    return {
        type: ADD_TAGS_TO_KEYWORDS,
        payload: tags
    };
}
var CHANGE_PAGE = "CHANGE_PAGE";
function changePage(param) {
    var offset = param.offset, page = param.page;
    return {
        type: CHANGE_PAGE,
        payload: {
            offset: offset,
            page: page
        }
    };
}
var ADD_CONDITION = "ADD_CONDITION";
function addCondition(name) {
    return {
        type: ADD_CONDITION,
        payload: name
    };
}
var REMOVE_CONDITION = "REMOVE_CONDITION";
function removeCondition(name) {
    return {
        type: REMOVE_CONDITION,
        payload: name
    };
}
var TOGGLE_SORT = "TOGGLE_SORT";
function toggleSort(name) {
    return {
        type: TOGGLE_SORT,
        payload: name
    };
}
var TOGGLE_OPTION = "TOGGLE_OPTION";
function toggleOption(name, value) {
    return {
        type: TOGGLE_OPTION,
        payload: {
            name: name,
            value: value
        }
    };
}
var SET_OPTIONS = "SET_OPTIONS";
function setOptions(name, values, setType) {
    return {
        type: SET_OPTIONS,
        payload: {
            name: name,
            values: values,
            setType: setType
        }
    };
}
var SET_RANGE = "SET_RANGE";
function setRange(name, range) {
    return {
        type: SET_RANGE,
        payload: {
            name: name,
            range: range
        }
    };
}
var SET_PERIOD = "SET_PERIOD";
function setPeriod(name, period) {
    return {
        type: SET_PERIOD,
        payload: {
            name: name,
            period: period
        }
    };
}
var SYNC_SELECTED_CONDITION = "SYNC_SELECTED_CONDITION";
function syncSelectedCondition(conditions) {
    return {
        type: SYNC_SELECTED_CONDITION,
        payload: conditions
    };
}
var SYNC_SORT_ORDER = "SYNC_SORT_ORDER";
function syncSortOrder(param) {
    var offset = param.offset, order = param.order, sort = param.sort;
    return {
        type: SYNC_SORT_ORDER,
        payload: {
            offset: offset,
            order: order,
            sort: sort
        }
    };
}
var SET_STATUS_CONDITION = "SET_STATUS_CONDITION";
function setStatus(statusId) {
    return {
        type: SET_STATUS_CONDITION,
        payload: {
            statusId: statusId
        }
    };
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/app.ts
// @flow
var TOGGLE_SELECTOR = "TOGGLE_SELECTOR";
function toggleSelector() {
    return {
        type: TOGGLE_SELECTOR
    };
}
var TOGGLE_CONDITION = "TOGGLE_CONDITION";
function toggleCondition(name) {
    return {
        type: TOGGLE_CONDITION,
        payload: name
    };
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/error.ts
// @flow
var SET_ERROR = "SET_ERROR";
var setError = function(name) {
    return {
        type: SET_ERROR,
        payload: name
    };
};
var CLEAR_ERROR = "CLEAR_ERROR";
var clearError = function() {
    return {
        type: CLEAR_ERROR
    };
};

;// CONCATENATED MODULE: ./components/pages/companies/actions/permission.ts
// @flow
var REQUEST_PERMISSION = "REQUEST_PERMISSION";
var requestPermission = function() {
    return {
        type: REQUEST_PERMISSION
    };
};
var SUCCESS_FETCH_PERMISSION = "SUCCESS_FETCH_PERMISSION";
var successFetchPermission = function(role, latestPlan, restricted, allowed, earlyAccess) {
    return {
        type: SUCCESS_FETCH_PERMISSION,
        payload: {
            role: role,
            latestPlan: latestPlan,
            restricted: restricted,
            allowed: allowed,
            earlyAccess: earlyAccess
        }
    };
};
var FAIL_FETCH_PERMISSION = "FAIL_FETCH_PERMISSION";
var failFetchPermission = function(err) {
    return {
        type: FAIL_FETCH_PERMISSION,
        payload: err
    };
};

;// CONCATENATED MODULE: ./components/pages/companies/actions/column.ts
var TOGGLE_COLUMN = "TOGGLE_COLUMN";
function toggleColumn(name) {
    return {
        type: TOGGLE_COLUMN,
        payload: name
    };
}
var UPDATE_COLUMNS = "UPDATE_COLUMNS";
var updateColumns = function(names) {
    return {
        type: UPDATE_COLUMNS,
        payload: names
    };
};
var CLEAR_ALL = "CLEAR_ALL";
function clearAll() {
    return {
        type: CLEAR_ALL
    };
}
var RESET = "RESET";
function column_reset(initialColumnNames) {
    return {
        type: RESET,
        payload: initialColumnNames
    };
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/statusCondition.ts
var OPEN_STATUS_CONDITION = "OPEN_STATUS_CONDITION";
function openStatusCondition(payload) {
    return {
        type: OPEN_STATUS_CONDITION,
        payload: payload
    };
}
var SELECT_FILTER_STATUS_CONDITION = "SELECT_FILTER_STATUS_CONDITION";
function selectFilterStatusCondition(payload) {
    return {
        type: SELECT_FILTER_STATUS_CONDITION,
        payload: payload
    };
}
var SELECT_FILTER_STATUS_UPDATED = "SELECT_FILTER_STATUS_UPDATED";
function selectFilterStatusUpdated(payload) {
    return {
        type: SELECT_FILTER_STATUS_UPDATED,
        payload: payload
    };
}
var SELECT_FILTER_FIRST_INTERVIEW_DATE = "SELECT_FILTER_FIRST_INTERVIEW_DATE";
function selectFilterFirstInterviewDate(payload) {
    return {
        type: SELECT_FILTER_FIRST_INTERVIEW_DATE,
        payload: payload
    };
}
var SELECT_FILTER_SOURCING_ROUTE = "SELECT_FILTER_SOURCING_ROUTE";
function selectFilterSourcingRoute(payload) {
    return {
        type: SELECT_FILTER_SOURCING_ROUTE,
        payload: payload
    };
}
var SELECT_FILTER_MY_LABEL = "SELECT_FILTER_MY_LABEL";
function selectFilterMyLabel(payload) {
    return {
        type: SELECT_FILTER_MY_LABEL,
        payload: payload
    };
}
var SET_INIT_STATUS_CONDITION = "SET_INIT_STATUS_CONDITION";
function setInitStatusCondition(conditions) {
    return {
        type: SET_INIT_STATUS_CONDITION,
        payload: conditions
    };
}
var SET_INIT_STATUS_UPDATED_AT = "SET_INIT_STATUS_UPDATED_AT";
function setInitStatusUpdatedAt(condition) {
    return {
        type: SET_INIT_STATUS_UPDATED_AT,
        payload: condition
    };
}
var SET_INIT_FIRST_INTERVIEW_DATE = "SET_INIT_FIRST_INTERVIEW_DATE";
function setInitFirstInterviewDate(condition) {
    return {
        type: SET_INIT_FIRST_INTERVIEW_DATE,
        payload: condition
    };
}
var SET_INIT_CONTACT_PERSON_CONDITION = "SET_INIT_CONTACT_PERSON_CONDITION";
function setInitContactPersonCondition(conditions) {
    return {
        type: SET_INIT_CONTACT_PERSON_CONDITION,
        payload: conditions
    };
}
var SET_INIT_SOURCING_ROUTE_CONDITION = "SET_INIT_SOURCING_ROUTE_CONDITION";
function setInitSourcingRoutesCondition(conditions) {
    return {
        type: SET_INIT_SOURCING_ROUTE_CONDITION,
        payload: conditions
    };
}
var SET_INIT_MY_LABEL_CONDITION = "SET_INIT_MY_LABEL_CONDITION";
function setInitMyLabelCondition(conditions) {
    return {
        type: SET_INIT_MY_LABEL_CONDITION,
        payload: conditions
    };
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/statusPanel.ts
var OPEN_STATUS_PANEL = "OPEN_STATUS_PANEL";
var CLOSE_STATUS_PANEL = "CLOSE_STATUS_PANEL";
var STORE_STATUS_PANEL_PAYLOAD = "STORE_STATUS_PANEL_PAYLOAD";
function openStatusPanel() {
    return {
        type: OPEN_STATUS_PANEL
    };
}
function closeStatusPanel() {
    return {
        type: CLOSE_STATUS_PANEL
    };
}
function storeStatusPanelPayload(companyId, companyMemo, contractPerson, status) {
    return {
        type: STORE_STATUS_PANEL_PAYLOAD,
        payload: {
            companyId: companyId,
            companyMemo: companyMemo,
            contractPerson: contractPerson,
            status: status
        }
    };
}
var statusPanelActions = {
    openStatusPanel: openStatusPanel,
    closeStatusPanel: closeStatusPanel,
    storeStatusPanelPayload: storeStatusPanelPayload
};

;// CONCATENATED MODULE: ./components/pages/companies/actions/index.ts










// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(91224);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
;// CONCATENATED MODULE: ./components/pages/companies/components/condition/RangeConditionLabel.tsx






var RangeConditionLabel = function(param) {
    var name = param.name, annotation = param.annotation, error = param.error, from = param.from, to = param.to, onRemove = param.onRemove, onToggle = param.onToggle;
    var labelName = constants_conditions/* CONDITION_ITEMS */.GO[name].label;
    var an = annotation ? " (".concat(annotation, ")") : "";
    var prepend = from ? "".concat(from).concat(an, " ≦ ") : undefined;
    var append = to ? " ≦ ".concat(to).concat(an) : undefined;
    var s = prepend ? prepend + labelName : labelName;
    var text = append ? s + append : s;
    var icon = from || to ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        onClick: function() {
            return onRemove(name);
        },
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:5px;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
            className: "icomoon icon-close1 right",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, "            &:before{font-size:0.65rem;margin-left:5px;}")
        })
    }) : // <i className="icomoon icon--arrow3-down right" />
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
        name: "arrow8-down",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
    });
    var content = error ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                className: "icomoon icon-alert-fill left",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:before{margin-right:3px;}")
            }),
            labelName
        ]
    }) : text;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
        className: "condition-label",
        onClick: function() {
            return onToggle(name);
        },
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:5px 10px 5px 15px;cursor:pointer;"),
        children: [
            content,
            icon
        ]
    });
};
/* harmony default export */ var condition_RangeConditionLabel = (RangeConditionLabel);

// EXTERNAL MODULE: ./components/view/OptionDropdown.tsx
var OptionDropdown = __webpack_require__(96507);
// EXTERNAL MODULE: ./components/view/OptionDropdownItem.tsx
var OptionDropdownItem = __webpack_require__(51868);
;// CONCATENATED MODULE: ./components/pages/companies/components/condition/RangeCondition.tsx
// @flow











var MAX_DIGIT = 7;
var RangeCondition = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(RangeCondition, _Component);
    var _super = (0,_create_super/* default */.Z)(RangeCondition);
    function RangeCondition() {
        (0,_class_call_check/* default */.Z)(this, RangeCondition);
        return _super.apply(this, arguments);
    }
    var _proto = RangeCondition.prototype;
    _proto.handleSet = function handleSet(range) {
        this.props.onSet(this.props.name, range);
    };
    _proto.handleChange = function handleChange(v, end) {
        var n = parseInt(v);
        if (!Number.isNaN(n) && !Number.isInteger(n) || n.toString().length > MAX_DIGIT) {
            return;
        }
        var from = this.props.from;
        var to = this.props.to;
        var range;
        if (end === "from") {
            range = Number.isNaN(n) ? {
                from: null,
                to: to
            } : {
                from: n,
                to: to
            };
        } else {
            range = Number.isNaN(n) ? {
                from: from,
                to: null
            } : {
                from: from,
                to: n
            };
        }
        this.props.onSet(this.props.name, range);
    };
    _proto.handleClickOutside = function handleClickOutside(_e) {
        if (this.props.open) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, name = _props.name, annotation = _props.annotation, useLabelAnnotation = _props.useLabelAnnotation, from = _props.from, to = _props.to, hasError = _props.hasError, onRemove = _props.onRemove, onToggle = _props.onToggle;
        var options = constants_conditions/* CONDITION_ITEMS */.GO[name].options;
        var errorClass = function() {
            var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            return hasError ? "".concat(c, " error") : c;
        };
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: errorClass("condition"),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&:last-child{margin-right:5px;}&.error{background-color:", dist/* colors.red50 */.O9.red50, ";}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_RangeConditionLabel, {
                    name: name,
                    annotation: useLabelAnnotation ? annotation : null,
                    error: hasError,
                    from: from,
                    to: to,
                    onRemove: onRemove,
                    onToggle: onToggle
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionDropdown/* OptionDropdown */.b, {
                    open: this.props.open,
                    children: [
                        options.map(function(option, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                                idx: i,
                                condition: from == option.range.from && to == option.range.to,
                                label: option.label,
                                handleSet: function() {
                                    return _this.handleSet(option.range);
                                }
                            }, i);
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:2px solid ", dist/* colors.gray30 */.O9.gray30, ";margin:0;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "condition-range",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:15px 10px 0;color:#999;input.error{border:1px solid ", dist/* colors.red50 */.O9.red50, ";color:", dist/* colors.red50 */.O9.red50, ";}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "field",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;position:relative;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                            value: from ? from : "",
                                            onChange: function(e) {
                                                return _this.handleChange(e.target.value, "from");
                                            },
                                            className: errorClass(),
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:80px;border:1px solid #999;border-radius:2px;padding:3px 5px;margin:0;")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            className: "annotation",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:right;color:#999;font-size:12px;"),
                                            children: [
                                                "(",
                                                annotation,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "divider",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:5px 5px 0 5px;display:inline-block;vertical-align:top;"),
                                    children: "−"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "field",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;position:relative;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                            value: to ? to : "",
                                            onChange: function(e) {
                                                return _this.handleChange(e.target.value, "to");
                                            },
                                            className: errorClass(),
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:80px;border:1px solid #999;border-radius:2px;padding:3px 5px;margin:0;")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            className: "annotation",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:right;color:#999;font-size:12px;"),
                                            children: [
                                                "(",
                                                annotation,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return RangeCondition;
}(react.Component);


// EXTERNAL MODULE: ./components/pages/companies/utils.ts
var utils = __webpack_require__(78331);
// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
;// CONCATENATED MODULE: ./components/pages/companies/components/condition/AmountRangeCondition.tsx
// @flow







var renderAmountRangeCondition = function(RangeCondition) {
    var amountRangeCondition = function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeCondition, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            annotation: "百万円",
            useLabelAnnotation: true,
            from: (0,utils/* cutDigit */._e)(props.from),
            to: (0,utils/* cutDigit */._e)(props.to),
            onSet: function(name, range) {
                return props.onSet(name, {
                    from: multiplyDigit(range.from),
                    to: multiplyDigit(range.to)
                });
            }
        }));
    };
    return amountRangeCondition;
};
var multiplyDigit = function(n) {
    return n != null ? n * 1000 : null;
};
// @ts-ignore
var AmountRangeCondition = renderAmountRangeCondition((0,react_onclickoutside_es["default"])(RangeCondition));
// @ts-ignore
AmountRangeCondition.displayName = "AmountRangeCondition";
/* harmony default export */ var condition_AmountRangeCondition = (AmountRangeCondition);

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/Condition.tsx














function isListItem(el) {
    var cls = el.getAttribute("class");
    return el.tagName === "LI" && (cls === "item" || cls === "item is-selected");
}
var Button = function(param) {
    var selected = param.selected, onClick = param.onClick;
    if (selected.length > 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            onClick: onClick,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:5px;"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                className: "icomoon icon-close1 right",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
            })
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
            name: "arrow8-down",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
        });
    }
};
var Error = function(param) {
    var hasError = param.hasError;
    return hasError ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
        className: "icomoon icon--warning2 left"
    }) : null;
};
var Condition = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Condition, _Component);
    var _super = (0,_create_super/* default */.Z)(Condition);
    function Condition() {
        (0,_class_call_check/* default */.Z)(this, Condition);
        return _super.apply(this, arguments);
    }
    var _proto = Condition.prototype;
    _proto.handleSelect = function handleSelect(option) {
        this.props.onSelect(this.props.name, option);
    };
    _proto.handleToggle = function handleToggle(target) {
        if (!isListItem(target)) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.handleClickOutside = function handleClickOutside() {
        if (this.props.open) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, name = _props.name, selected = _props.selected, hasError = _props.hasError;
        var conditionClass = "condition ".concat(hasError ? "error" : "");
        var options = (0,constants_conditions/* getSelectCondtionOptions */.N5)(name);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: conditionClass,
            css: hasError ? /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&:last-child{margin-right:5px;}/* background-color:$error */") : /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&:last-child{margin-right:5px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                    className: "condition-label",
                    onClick: function(e) {
                        return _this.handleToggle(e.target);
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:5px 10px 5px 15px;cursor:pointer;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
                            hasError: hasError
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:5px;"),
                            children: (0,utils/* formatCondition */.sy)(name, selected)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                            selected: selected,
                            onClick: function() {
                                return _this.props.onRemove(_this.props.name);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                    open: this.props.open,
                    _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:500px;max-width:256px;overflow-y:auto;"),
                    children: options.map(function(param, i) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), option = _param[0], value = _param[1];
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                            idx: i,
                            condition: selected.includes(option),
                            handleSet: function() {
                                return _this.handleSelect(option);
                            },
                            label: value.label
                        }, i);
                    })
                })
            ]
        });
    };
    return Condition;
}(react.Component);
// @ts-ignore
/* harmony default export */ var condition_Condition = ((0,react_onclickoutside_es["default"])(Condition));

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/PeopleRangeCondition.tsx






var renderPeopleRangeCondition = function(RangeCondition) {
    var peopleRangeConfition = function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RangeCondition, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            annotation: "人"
        }));
    };
    return peopleRangeConfition;
};
// @ts-ignore
var PeopleRangeCondition = renderPeopleRangeCondition((0,react_onclickoutside_es["default"])(RangeCondition));
// @ts-ignore
PeopleRangeCondition.displayName = "PeopleRangeCondition";
/* harmony default export */ var condition_PeopleRangeCondition = (PeopleRangeCondition);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/pages/companies/components/date-picker-wrapper.tsx










var DatePickerWrapper = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DatePickerWrapper, _Component);
    var _super = (0,_create_super/* default */.Z)(DatePickerWrapper);
    function DatePickerWrapper(props) {
        (0,_class_call_check/* default */.Z)(this, DatePickerWrapper);
        var _this = _super.call(this, props);
        moment_default().locale("ja", {
            months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdaysMin: "日_月_火_水_木_金_土".split("_"),
            week: {
                dow: 1
            }
        });
        return _this;
    }
    var _proto = DatePickerWrapper.prototype;
    _proto.render = function render() {
        var errorCls = this.props.error ? "error" : "";
        var selectedCls = this.props.selected ? "selected" : "";
        var tenYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 10));
        var thirtyYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 30));
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_datepicker_min_default()), (0,_object_spread/* default */.Z)({
            customInput: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputButton, {}),
            dateFormat: "yyyy-MM-dd",
            placeholderText: this.props.placeholder,
            className: "".concat(errorCls, " ").concat(selectedCls),
            showMonthDropdown: true,
            showYearDropdown: true,
            maxDate: tenYearsFromNow,
            minDate: thirtyYearsAgo,
            dropdownMode: "select"
        }, this.props));
    };
    return DatePickerWrapper;
}(react.Component);

var InputButton = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(InputButton, _Component);
    var _super = (0,_create_super/* default */.Z)(InputButton);
    function InputButton() {
        (0,_class_call_check/* default */.Z)(this, InputButton);
        return _super.apply(this, arguments);
    }
    var _proto = InputButton.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
            className: "input-button ".concat(this.props.className),
            onClick: this.props.onClick,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;background-color:", dist/* colors.white00 */.O9.white00, ";border:1px solid ", dist/* colors.gray90 */.O9.gray90, ";border-radius:2px;color:", this.props.value ? dist/* colors.black10 */.O9.black10 : dist/* colors.gray60 */.O9.gray60, ";padding:2px 5px;width:100px;transition:0.3s;margin-top:2px;text-align:left;cursor:pointer;&:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}&:focus{border-color:", dist/* colors.gray90 */.O9.gray90, ";box-shadow:none;-webkit-box-shadow:none;}"),
            children: [
                this.props.value ? this.props.value : this.props.placeholder,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                    className: "icomoon icon-calendar"
                })
            ]
        });
    };
    return InputButton;
}(react.Component);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 48 modules
var parse = __webpack_require__(81294);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
;// CONCATENATED MODULE: ./components/pages/companies/components/condition/PeriodCondition.tsx
















function PeriodCondition_isListItem(el) {
    var cls = el.getAttribute("class");
    return el.tagName === "LI" && (cls === "item" || cls === "item is-selected");
}
var PeriodCondition = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PeriodCondition, _Component);
    var _super = (0,_create_super/* default */.Z)(PeriodCondition);
    function PeriodCondition() {
        (0,_class_call_check/* default */.Z)(this, PeriodCondition);
        return _super.apply(this, arguments);
    }
    var _proto = PeriodCondition.prototype;
    _proto.handleSet = function handleSet(period) {
        this.props.onSet(this.props.name, period);
    };
    _proto.handleChange = function handleChange(value, end) {
        var _selected = this.props.selected, from = _selected.from, to = _selected.to;
        var v = value ? (0,date/* formatDate */.p6)(value.toISOString()) : null;
        var period = end == "from" ? {
            from: v,
            to: to
        } : {
            from: from,
            to: v
        };
        this.props.onSet(this.props.name, period);
    };
    _proto.handleToggle = function handleToggle(target) {
        if (!PeriodCondition_isListItem(target)) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.handleClickOutside = function handleClickOutside() {
        if (this.props.open) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.renderButton = function renderButton() {
        var _this = this;
        if (this.props.selected.from || this.props.selected.to) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                onClick: function() {
                    return _this.props.onRemove(_this.props.name);
                },
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:5px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                    className: "icomoon icon-close1 right",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
                })
            });
        } else {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                name: "arrow8-down",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
            });
        }
    };
    _proto.renderError = function renderError() {
        return this.props.hasError ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
            className: "icomoon icon-alert-fill left",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:before{margin-right:3px;}")
        }) : null;
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, name = _props.name, selected = _props.selected, hasError = _props.hasError;
        var options = constants_conditions/* CONDITION_ITEMS */.GO[name].options;
        var label = constants_conditions/* CONDITION_ITEMS */.GO[name].label;
        var errorClass = function() {
            var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            return hasError ? "".concat(c, " error") : c;
        };
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: errorClass("condition"),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&.error{background-color:", dist/* colors.red50 */.O9.red50, ";}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                    className: "condition-label",
                    onClick: function(e) {
                        return _this.handleToggle(e.target);
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:5px 10px 5px 15px;cursor:pointer;"),
                    children: [
                        this.renderError(),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: hasError ? label : (0,utils/* formatPeriodCondition */.FF)(label, selected)
                        }),
                        this.renderButton()
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionDropdown/* OptionDropdown */.b, {
                    open: this.props.open,
                    children: [
                        options.map(function(option, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                                idx: i,
                                condition: selected.from === option.period.from && selected.to === option.period.to,
                                label: option.label,
                                handleSet: function() {
                                    return _this.handleSet(option.period);
                                }
                            }, i);
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:2px solid ", dist/* colors.gray30 */.O9.gray30, ";margin:0;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "condition-period",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:55px;padding:5px 10px;button.error{border:1px solid ", dist/* colors.red50 */.O9.red50, ";color:", dist/* colors.red50 */.O9.red50, ";}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "field",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;position:relative;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "annotation",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:left;color:#999;font-size:12px;"),
                                            children: "(開始)"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerWrapper, {
                                            placeholder: "2017-01-01",
                                            onChange: function(v) {
                                                return _this.handleChange(v, "from");
                                            },
                                            selected: this.props.selected.from ? (0,parse["default"])(this.props.selected.from, "yyyy-MM-dd", new Date()) : null,
                                            error: this.props.hasError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "divider",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:25px 5px 5px;display:inline-block;vertical-align:baseline;color:#999;"),
                                    children: "−"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "field",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;position:relative;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            className: "annotation",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:left;color:#999;font-size:12px;"),
                                            children: "(終了)"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerWrapper, {
                                            placeholder: "2017-01-31",
                                            onChange: function(v) {
                                                _this.handleChange(v, "to");
                                            },
                                            selected: this.props.selected.to ? (0,parse["default"])(this.props.selected.to, "yyyy-MM-dd", new Date()) : null,
                                            error: this.props.hasError
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return PeriodCondition;
}(react.Component);
// @ts-ignore
/* harmony default export */ var condition_PeriodCondition = ((0,react_onclickoutside_es["default"])(PeriodCondition));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./components/pages/companies/constants/options.ts
var options = __webpack_require__(42335);
;// CONCATENATED MODULE: ./components/pages/companies/components/condition/PrefectureCondition.tsx















function PrefectureCondition_isListItem(el) {
    var cls = el.getAttribute("class");
    return el.tagName === "LI" && (cls === "item" || cls === "item is-selected");
}
var PrefectureCondition_Button = function(param) {
    var selected = param.selected, onClick = param.onClick;
    if (selected.length > 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            onClick: onClick,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:5px;"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                className: "icomoon icon-close1 right",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
            })
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
            name: "arrow8-down",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
        });
    }
};
var DropdownItem = function(param) {
    var children = param.children, selected = param.selected, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
        className: selected ? "item is-selected" : "item",
        onClick: onClick,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;cursor:pointer;color:", dist/* colors.gray90 */.O9.gray90, ";line-height:20px;padding:3px 10px 4px 25px;:hover{background-color:#f1f1f1;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                className: selected && "icomoon icon-check1",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;display:inline-block;min-width:2em;width:13px;height:13px;&:before{margin-left:5px;color:", dist/* colors.text */.O9.text, ";}")
            }),
            children
        ]
    });
};
var GroupDropdownItem = function(param) {
    var children = param.children, selected = param.selected, _indeterminate = param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, onLabelClick = param.onLabelClick, onIconClick = param.onIconClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "area-item",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;padding:2px 0 !important;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                className: selected ? "is-selected icomoon icon-check1 area-icon" : "area-icon",
                onClick: function() {
                    onIconClick();
                },
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;display:inline-block;min-width:2em;width:13px;height:13px;&:before{margin-left:5px;color:", indeterminate ? dist/* colors.gray60 */.O9.gray60 : dist/* colors.text */.O9.text, ";}")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                onClick: onLabelClick,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;cursor:pointer;display:inline-block;"),
                children: children
            })
        ]
    });
};
var DropdownRow = function(param) {
    var values = param.values, selected = param.selected, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("dd", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:0;"),
        children: values.map(function(value, i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownItem, {
                selected: selected.includes(value),
                onClick: function() {
                    return onClick(value);
                },
                children: value
            }, "".concat(i));
        })
    });
};
var AreaList = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AreaList, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(AreaList);
    function AreaList() {
        (0,_class_call_check/* default */.Z)(this, AreaList);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleIconClick = function() {
            if (_this.isAllSelected()) {
                _this.props.onIconClick(_this.props.prefs, "remove");
            } else {
                _this.props.onIconClick(_this.props.prefs, "add");
            }
        };
        return _this;
    }
    var _proto = AreaList.prototype;
    _proto.isAllSelected = function isAllSelected() {
        var _props = this.props, selected = _props.selected, prefs = _props.prefs;
        // ちょっと荒業だが文字列結合で検索する
        var sl = selected.join("");
        var includes = prefs.map(function(p) {
            return sl.indexOf(p) > -1;
        });
        return includes.every(function(i) {
            return !!i;
        });
    };
    _proto.isPartialSelected = function isPartialSelected() {
        var _props = this.props, selected = _props.selected, prefs = _props.prefs;
        // ちょっと荒業だが文字列結合で検索する
        var sl = selected.join("");
        var includes = prefs.map(function(p) {
            return sl.indexOf(p) > -1;
        });
        return includes.some(function(i) {
            return !!i;
        });
    };
    _proto.getAreaLabelSelected = function getAreaLabelSelected() {
        if (this.isAllSelected()) {
            return {
                selected: true,
                indeterminate: false
            };
        }
        if (this.isPartialSelected()) {
            return {
                selected: true,
                indeterminate: true
            };
        }
        return {
            selected: false
        };
    };
    _proto.render = function render() {
        var _props = this.props, label = _props.label, prefs = _props.prefs, expanded = _props.expanded, selected = _props.selected, onLabelClick = _props.onLabelClick, onPrefClick = _props.onPrefClick;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("dl", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0 !important;padding-left:0;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("dt", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;padding:2px 0 !important;color:", dist/* colors.gray90 */.O9.gray90, ";line-height:20px;:hover{background-color:#f1f1f1;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupDropdownItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        onIconClick: this.handleIconClick,
                        onLabelClick: onLabelClick
                    }, this.getAreaLabelSelected()), {
                        children: label
                    }))
                }),
                expanded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownRow, {
                    values: prefs,
                    selected: selected,
                    onClick: onPrefClick
                })
            ]
        });
    };
    return AreaList;
}(react.PureComponent);
var PrefectureConditionInternal = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PrefectureConditionInternal, _Component);
    var _super = (0,_create_super/* default */.Z)(PrefectureConditionInternal);
    function PrefectureConditionInternal(props) {
        (0,_class_call_check/* default */.Z)(this, PrefectureConditionInternal);
        var _this;
        _this = _super.call(this, props);
        _this.handleGroupLabelClick = function(label) {
            var newState = {
                expands: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.expands), (0,_define_property/* default */.Z)({}, label, !_this.state.expands[label]))
            };
            _this.setState(newState);
        };
        _this.handleGroupIconClick = function(prefs, setType) {
            _this.props.onSelectList(_this.props.name, prefs, setType);
        };
        _this.state = {
            expands: {}
        };
        return _this;
    }
    var _proto = PrefectureConditionInternal.prototype;
    _proto.handleSelect = function handleSelect(option) {
        this.props.onSelect(this.props.name, option);
    };
    _proto.handleToggle = function handleToggle(target) {
        if (!PrefectureCondition_isListItem(target)) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.handleClickOutside = function handleClickOutside() {
        if (this.props.open) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, name = _props.name, selected = _props.selected;
        var expands = this.state.expands;
        var ref = this, handleGroupLabelClick = ref.handleGroupLabelClick, handleGroupIconClick = ref.handleGroupIconClick;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "condition",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&:last-child{margin-right:5px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                    className: "condition-label",
                    onClick: function(e) {
                        return _this.handleToggle(e.target);
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:5px 10px 5px 15px;cursor:pointer;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: (0,utils/* formatCondition */.sy)(name, selected)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefectureCondition_Button, {
                            selected: selected,
                            onClick: function() {
                                return _this.props.onRemove(_this.props.name);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                    open: this.props.open,
                    children: options/* AREA_STATES.map */.t8.map(function(param, i) {
                        var label = param.label, prefs = param.prefs;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AreaList, {
                            label: label,
                            prefs: prefs,
                            selected: selected,
                            onIconClick: function(prefs, toogle) {
                                return handleGroupIconClick(prefs, toogle);
                            },
                            onLabelClick: function() {
                                return handleGroupLabelClick(label);
                            },
                            expanded: expands[label],
                            onPrefClick: function(e) {
                                return _this.handleSelect(e);
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return PrefectureConditionInternal;
}(react.Component);
/* harmony default export */ var PrefectureCondition = ((0,react_onclickoutside_es["default"])(PrefectureConditionInternal));

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/CrunchbaseLatestRoundTypeCondition.tsx













var ListItem = function(param) {
    var option = param.option, onSelect = param.onSelect, label = param.label, selected = param.selected;
    var isSelected = selected.includes(option);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:30px;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            onClick: onSelect,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;display:flex;gap:10px;height:100%;align-items:center;font-size:14px;line-height:18px;padding:0 10px;cursor:pointer;"),
            children: [
                isSelected ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                    className: "icomoon icon-check1",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:1;min-width:14px;")
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:1;min-width:14px;")
                }),
                label
            ]
        }, option)
    });
};
var CrunchbaseLatestRoundTypeCondition = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CrunchbaseLatestRoundTypeCondition, _Component);
    var _super = (0,_create_super/* default */.Z)(CrunchbaseLatestRoundTypeCondition);
    function CrunchbaseLatestRoundTypeCondition() {
        (0,_class_call_check/* default */.Z)(this, CrunchbaseLatestRoundTypeCondition);
        return _super.apply(this, arguments);
    }
    var _proto = CrunchbaseLatestRoundTypeCondition.prototype;
    _proto.handleClickOutside = function handleClickOutside() {
        if (this.props.open) {
            this.props.onToggle(this.props.name);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, selected = _props.selected, onSelectOption = _props.onSelectOption, open = _props.open, name = _props.name;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "condition",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";display:inline-block;font-size:13px;position:relative;&:last-child{margin-right:5px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                    className: "condition-label",
                    onClick: function() {
                        return _this.props.onToggle(_this.props.name);
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:inherit;background:transparent;color:inherit;padding:5px 10px 5px 15px;cursor:pointer;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:5px;"),
                            children: (0,utils/* formatCondition */.sy)(name, selected)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                            selected: selected,
                            onClick: function() {
                                return _this.props.onRemove(_this.props.name);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                    open: open,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:0;list-style:none;"),
                        children: [
                            Object.entries(options/* CB_LATEST_ROUND_TYPE_OPTIONS */.vm).filter(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
                                return !value.isOther;
                            }).map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], option = _param[1];
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                                    option: key,
                                    onSelect: function() {
                                        return onSelectOption("cbLatestRoundType", key);
                                    },
                                    selected: selected,
                                    label: option.label
                                }, key);
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;&:hover{background-color:", dist/* colors.backgroundGray */.O9.backgroundGray, ";div.dropdown{visibility:visible;opacity:1;}}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;height:30px;list-style:none;display:flex;gap:10px;width:100%;align-items:center;font-size:14px;line-height:18px;padding:0 34px;"),
                                        children: [
                                            "その他",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                                                className: "icon-arrow7-right",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;left:86%;top:30%;")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "dropdown",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:5px 0;bottom:-50px;left:204px;position:absolute;visibility:hidden;opacity:0;background:", dist/* colors.white00 */.O9.white00, ";color:", dist/* colors.text */.O9.text, ";box-shadow:0px 0px 10px rgba(0,0,0,0.1);transition:opacity 0.3s ease;"),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;margin:0;list-style:none;"),
                                            children: Object.entries(options/* CB_LATEST_ROUND_TYPE_OPTIONS */.vm).filter(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
                                                return value.isOther;
                                            }).map(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], option = _param[1];
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                                                    option: key,
                                                    onSelect: function() {
                                                        return onSelectOption("cbLatestRoundType", key);
                                                    },
                                                    selected: selected,
                                                    label: option.label
                                                }, key);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    return CrunchbaseLatestRoundTypeCondition;
}(react.Component);
/* harmony default export */ var condition_CrunchbaseLatestRoundTypeCondition = ((0,react_onclickoutside_es["default"])(CrunchbaseLatestRoundTypeCondition));

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/ConditionItem.tsx












var AmountConditionItem = function(props) {
    var selectorProps = {
        onSet: props.onSelectRange,
        from: props.selected.from,
        to: props.selected.to
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_AmountRangeCondition, (0,_object_spread/* default */.Z)({}, props, selectorProps));
};
var PeopleConditionItem = function(props) {
    var selectorProps = {
        onSet: props.onSelectRange,
        from: props.selected.from,
        to: props.selected.to
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_PeopleRangeCondition, (0,_object_spread/* default */.Z)({}, props, selectorProps));
};
var PeriodConditionItem = function(props) {
    var selectorProps = {
        onSet: props.onSelectPeriod,
        outsideClickIgnoreClass: "react-datepicker",
        selected: props.selected
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_PeriodCondition, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        name: props.name
    }), selectorProps));
};
var StateConditionItem = function(props) {
    var selectorProps = {
        onSelect: props.onSelectOption,
        onSelectList: props.onSelectOptionList,
        selected: props.selected
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrefectureCondition, (0,_object_spread/* default */.Z)({}, props, selectorProps));
};
var CrunchbaseLatestRoundTypeConditionItem = function(props) {
    var selectorProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        name: props.name
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_CrunchbaseLatestRoundTypeCondition, (0,_object_spread/* default */.Z)({}, selectorProps));
};
var DefaultConditionItem = function(props) {
    var selectorProps = {
        onSelect: props.onSelectOption,
        selected: props.selected
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_Condition, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        name: props.name
    }), selectorProps));
};
var ConditionItem = function(_param) {
    var name = _param.name, selected = _param.selected, opening = _param.opening, errors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "selected",
        "opening",
        "errors"
    ]);
    var open = name === opening;
    var hasError = errors.includes(name);
    var commonProps = (0,_object_spread/* default */.Z)({
        selected: selected,
        open: open,
        hasError: hasError,
        name: name
    }, props);
    if (AMOUNT_RANGE_CONDITION_NAMES.includes(name)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AmountConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
    }
    if (PEOPLE_RANGE_CONDITION_NAMES.includes(name)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PeopleConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
    }
    if (PERIOD_CONDITION_NAMES.includes(name)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PeriodConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
    }
    if (name === "state") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
    }
    if (name === "cbLatestRoundType") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CrunchbaseLatestRoundTypeConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultConditionItem, (0,_object_spread/* default */.Z)({}, commonProps));
};

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/ConditionList.tsx







var ConditionList = function(_param) /*#__PURE__*/ {
    var conditions = _param.conditions, props = (0,_object_without_properties/* default */.Z)(_param, [
        "conditions"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        className: "condition-list",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:contents;"),
        children: Object.keys(conditions)// @ts-ignore
        .map(function(n) {
            return [
                n,
                conditions[n]
            ];
        }).map(function(param, i) {
            var _$_param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _$_param[0], selected = _$_param[1];
            var key = "".concat(i, "-").concat(name);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConditionItem, (0,_object_spread/* default */.Z)({
                name: name,
                selected: selected
            }, props), key);
        })
    });
};
/* harmony default export */ var condition_ConditionList = (ConditionList);

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/ConditionCircle.tsx




var ConditionCircleWrapper = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;display:inline-block;position:relative;vertical-align:middle;"),
        children: props.children
    });
};
var ConditionIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
        name: "plus",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.cyan50 */.O9.cyan50, ";font-size:20px;")
    });
};
var ConditionCircle = function(props) {
    return /*#__PURE__*/ _jsx("div", {
        css: /*#__PURE__*/ css("box-sizing:border-box;background-color:#ffffff;border:2px solid ", colors.cyan50, ";border-radius:50%;padding:8px 8.5px 8px 9px;width:42px;height:42px;line-height:1;transition:0.15s;:hover{background-color:", colors.cyan50, ";border:2px solid ", colors.cyan50, ";/* あまり良くないselectorだが、この要素自体の利用scopeを狭めたい */\n          *{transition:0.15s;color:#fff;}}"),
        children: props.children
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/condition/ConditionSelector.tsx
// @flow




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  position: relative;\n                  color: #666;\n                  font-size: 14px;\n                  padding: 3px 10px 4px 25px;\n                  rgin: 0;\n                  line-height: 20px;\n                  &.is-selected:before {\n                    content: '\\A';\n                    background: ",
        ";\n                    display: inline-block;\n                    left: 10px;\n                    width: 6px;\n                    border-radius: 50%;\n                    height: 6px;\n                    position: absolute;\n                    top: 8px;\n                  }\n                  :hover {\n                    background-color: #f1f1f1;\n                  }\n                "
    ], [
        "\n                  position: relative;\n                  color: #666;\n                  font-size: 14px;\n                  padding: 3px 10px 4px 25px;\n                  rgin: 0;\n                  line-height: 20px;\n                  &.is-selected:before {\n                    content: '\\\\A';\n                    background: ",
        ";\n                    display: inline-block;\n                    left: 10px;\n                    width: 6px;\n                    border-radius: 50%;\n                    height: 6px;\n                    position: absolute;\n                    top: 8px;\n                  }\n                  :hover {\n                    background-color: #f1f1f1;\n                  }\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      color: #333;\n                      position: absolute;\n                      right: 5px;\n                      font-size: 17px;\n                      transition: 0.2s;\n                      opacity: 0.2;\n                      :hover {\n                        text-decoration: none;\n                        cursor: pointer;\n                        opacity: 0.4;\n                      }\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConditionSelector = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ConditionSelector, _Component);
    var _super = (0,_create_super/* default */.Z)(ConditionSelector);
    function ConditionSelector() {
        (0,_class_call_check/* default */.Z)(this, ConditionSelector);
        return _super.apply(this, arguments);
    }
    var _proto = ConditionSelector.prototype;
    _proto.handleClickOutside = function handleClickOutside() {
        if (this.props.open) {
            this.props.onToggle();
        }
    };
    _proto.handleOnRemove = function handleOnRemove(e, name) {
        e.stopPropagation();
        this.props.onRemove(name);
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ConditionCircleWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                    label: "フィルタを追加",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        onClick: this.props.onToggle,
                        className: "add-filter-btn",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:center;box-sizing:border-box;background-color:#ffffff;border:2px solid ", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50%;margin-block:-12px;width:42px;height:42px;line-height:1;transition:0.15s;:hover{background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border:2px solid ", dist/* colors.cyan50 */.O9.cyan50, ";/* あまり良くないselectorだが、この要素自体の利用scopeを狭めたい */\n                *{transition:0.15s;color:#fff;}}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConditionIcon, {})
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    className: this.props.open ? "condition-dropdown is-opening" : "condition-dropdown",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:#fff;border:1px solid #d9d9d9;box-shadow:1px 1px 1px #d9d9d9;opacity:", this.props.open ? 1 : 0, ";visibility:", this.props.open ? "visible" : "hidden", ";padding:5px 0;position:absolute;list-style:none;min-width:272px;white-space:nowrap;transition:0.2s;z-index:1;left:-66px;margin-top:5px;&.condition-dropdown:before{border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fff;border-bottom-color:#d9d9d9;content:' ';height:0;position:absolute;width:0;top:-10px;left:28.5%;}&.condition-dropdown:after{border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fff;top:-9px;content:' ';height:0;position:absolute;width:0;left:28.5%;}"),
                    children: Object.keys(constants_conditions/* CONDITION_ITEMS_FOR_CONDITION_SELECTOR */.Kn).map(function(name, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            className: _this.props.selected.includes(name) ? "is-selected" : "",
                            onClick: function() {
                                return _this.props.onSelect(name);
                            },
                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), dist/* colors.cyan50 */.O9.cyan50),
                            children: [
                                constants_conditions/* CONDITION_ITEMS_FOR_CONDITION_SELECTOR */.Kn[name].label,
                                _this.props.selected.includes(name) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                                    className: "icomoon icon-close2 close",
                                    onClick: function(e) {
                                        return _this.handleOnRemove(e, name);
                                    },
                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1())
                                }) : null
                            ]
                        }, "".concat(i, "-").concat(name));
                    })
                })
            ]
        });
    };
    return ConditionSelector;
}(react.Component);
/* harmony default export */ var condition_ConditionSelector = ((0,react_onclickoutside_es["default"])(ConditionSelector));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./components/pages/companies/reducers/condition.ts








var statusConditionItems = {
    status: "status",
    contactPeople: "contactPeople",
    statusUpdated: "statusUpdated",
    firstInterviewDate: "firstInterviewDate",
    sourcingRoute: "sourcingRoute"
};
var init = {
    keywords: "",
    tags: "",
    limit: 50,
    offset: 0,
    page: 1,
    sort: null,
    order: null,
    selected: {
        type: [],
        latestInitialSeries: [],
        cbLatestRoundType: [],
        totalFunding: {
            from: null,
            to: null
        },
        valuation: {
            from: null,
            to: null
        },
        lastFundraised: {
            from: null,
            to: null
        },
        country: []
    },
    openingItem: undefined,
    filterItems: [],
    statusUpdated: {
        from: null,
        to: null
    },
    firstInterviewDate: {
        from: null,
        to: null
    },
    sourcingRouteIds: [],
    myLabelIds: []
};
function add(selected, name) {
    if (!Object.keys(selected).includes(name.toString())) {
        selected = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), (0,_define_property/* default */.Z)({}, name, []));
    }
    return selected;
}
function remove(selected, name) {
    if (!Object.keys(selected).includes(name.toString())) return selected;
    return Object.keys(selected).filter(function(n) {
        return n !== name;
    }).reduce(function(p, n) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), (0,_define_property/* default */.Z)({}, n, selected[n]));
    }, {});
}
function setMultiple(selected, name, values, setType) {
    var current = selected[name];
    var next = values.reduce(function(list, value) {
        if (setType === "add") {
            // @ts-ignore
            return (0,_to_consumable_array/* default */.Z)(list).concat([
                value
            ]);
        } else {
            // @ts-ignore
            return list.filter(function(v) {
                return v !== value;
            });
        }
    }, current);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), (0,_define_property/* default */.Z)({}, name, lodash_default().uniq(next)));
}
function toggle(selected, name, value) {
    if (typeof selected[name] === "undefined") {
        selected = add(selected, name);
    }
    var list = selected[name];
    if (Array.isArray(list) && list.includes(value)) {
        list = list.filter(function(v) {
            return v !== value;
        });
    } else {
        list = (0,_to_consumable_array/* default */.Z)(list).concat([
            value
        ]);
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), (0,_define_property/* default */.Z)({}, name, list));
}
function condition_select(selected, name, value) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), (0,_define_property/* default */.Z)({}, name, [
        value
    ]));
}
function set(selected, name, updated) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected), (0,_define_property/* default */.Z)({}, name, updated));
}
function nextOrder(order) {
    switch(order){
        case "DESC":
            return "ASC";
        case "ASC":
            return null;
    }
    return "DESC";
}
function sort(param, name) {
    var sort = param.sort, order = param.order;
    if (sort === name) {
        var next = nextOrder(order);
        return next === null ? {
            sort: null,
            order: null
        } : {
            sort: sort,
            order: next
        };
    } else {
        return {
            sort: name,
            order: "DESC"
        };
    }
}
var convertTagKeywords = function(tagsStr) {
    return tagsStr.split(",").map(function(t) {
        return "#" + t;
    }).join(" ");
};
function condition() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case CHANGE_KEYWORDS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                keywords: action.payload
            });
        case SET_TAGS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                tags: action.payload
            });
        case SET_PAGE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                page: action.payload
            });
        case RESET_OFFSET:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offset: 0,
                page: 1
            });
        case ADD_TAGS_TO_KEYWORDS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                keywords: state.keywords ? "".concat(state.keywords, " ").concat(convertTagKeywords(action.payload)) : convertTagKeywords(action.payload)
            });
        case CHANGE_PAGE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offset: action.payload.offset,
                page: action.payload.page
            });
        case ADD_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: add(state.selected, action.payload)
            });
        case REMOVE_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: remove(state.selected, action.payload)
            });
        case TOGGLE_OPTION:
            var op = RADIO_CONDITION_NAMES.includes(action.payload.name) ? condition_select : toggle;
            var selected = op(state.selected, action.payload.name, action.payload.value);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: selected
            });
        case SET_RANGE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: set(state.selected, action.payload.name, action.payload.range)
            });
        case SET_OPTIONS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offset: 0,
                selected: setMultiple(state.selected, action.payload.name, action.payload.values, action.payload.setType)
            });
        case SET_PERIOD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: set(state.selected, action.payload.name, action.payload.period)
            });
        case TOGGLE_SORT:
            return (0,_object_spread/* default */.Z)({}, state, sort({
                sort: state.sort,
                order: state.order
            }, action.payload));
        case SYNC_SORT_ORDER:
            return (0,_object_spread/* default */.Z)({}, state, action.payload);
        case SYNC_SELECTED_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selected: (0,_object_spread/* default */.Z)({}, state.selected, action.payload)
            });
        case OPEN_STATUS_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                openingItem: action.payload
            });
        case SELECT_FILTER_STATUS_CONDITION:
            var onlyStatus = state.filterItems.filter(function(i) {
                return i.itemName === action.payload.itemName;
            });
            var exceptStatus = state.filterItems.filter(function(i) {
                return i.itemName !== action.payload.itemName;
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offset: 0,
                filterItems: exceptStatus.concat(onlyStatus.length === 0 ? {
                    itemName: action.payload.itemName,
                    conditions: [
                        action.payload.conditions
                    ]
                } : onlyStatus.map(function(i) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, i), {
                        conditions: i.conditions.some(function(c) {
                            return JSON.stringify(c) === JSON.stringify(action.payload.conditions);
                        }) ? i.conditions.filter(function(c) {
                            return JSON.stringify(c) !== JSON.stringify(action.payload.conditions);
                        }) : i.conditions.concat(action.payload.conditions)
                    });
                }).filter(function(s) {
                    return s.conditions.length > 0;
                }))
            });
        case SELECT_FILTER_STATUS_UPDATED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                statusUpdated: action.payload
            });
        case SELECT_FILTER_FIRST_INTERVIEW_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                firstInterviewDate: action.payload
            });
        case SELECT_FILTER_SOURCING_ROUTE:
            var isAlreadySelected = state.sourcingRouteIds.find(function(sr) {
                return sr.id === action.payload.id;
            });
            var sourcingRouteIds = isAlreadySelected ? state.sourcingRouteIds.filter(function(sr) {
                return sr.id !== action.payload.id;
            }) : state.sourcingRouteIds.concat({
                id: action.payload.id
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                sourcingRouteIds: sourcingRouteIds
            });
        case SELECT_FILTER_MY_LABEL:
            var myLabelIds = state.myLabelIds.find(function(it) {
                return it === action.payload;
            }) ? state.myLabelIds.filter(function(it) {
                return it !== action.payload;
            }) : (0,_to_consumable_array/* default */.Z)(state.myLabelIds).concat([
                action.payload
            ]);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                myLabelIds: myLabelIds
            });
        case SET_INIT_STATUS_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filterItems: state.filterItems.concat({
                    itemName: statusConditionItems.status,
                    conditions: action.payload
                })
            });
        case SET_INIT_STATUS_UPDATED_AT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                statusUpdated: action.payload
            });
        case SET_INIT_FIRST_INTERVIEW_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                firstInterviewDate: action.payload
            });
        case SET_INIT_CONTACT_PERSON_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filterItems: state.filterItems.concat({
                    itemName: statusConditionItems.contactPeople,
                    conditions: action.payload
                })
            });
        case SET_INIT_SOURCING_ROUTE_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                sourcingRouteIds: action.payload
            });
        case SET_INIT_MY_LABEL_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                myLabelIds: action.payload
            });
    }
    return state;
}

// EXTERNAL MODULE: ./components/common/Cover.tsx
var Cover = __webpack_require__(89543);
;// CONCATENATED MODULE: ./components/view/ConditionTitle.tsx



var ConditionTitle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        className: "conditions-label",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;margin-block-start:4px;color:", dist/* colors.textLight */.O9.textLight, ";font-size:12px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.25;letter-spacing:0.02em;"),
        children: props.title
    });
};

// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
;// CONCATENATED MODULE: ./components/pages/companies/components/help-indicator.tsx





var HelpIndicator = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: props.className ? [
            "help-indicator",
            props.className
        ].join(" ") : "help-indicatior",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:right;display:block;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("*,*::after{transition:all 0.2s ease 0s;}> a,i{color:", dist/* colors.textLight */.O9.textLight, ";}:hover{> *{color:", dist/* colors.blue50 */.O9.blue50, ";}}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                href: "https://help.initial.inc/ja/articles/7434600",
                target: "_blank",
                rel: "noopener noreferrer",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";line-height:100%;font-size:11px;letter-spacing:0.02em;text-decoration:none;> span{position:relative;}> span::after{position:absolute;content:'';width:100%;height:1px;bottom:1px;left:0;background-color:", dist/* colors.link */.O9.link, ";opacity:0;}:hover{> i{color:", dist/* colors.link */.O9.link, ";}> span::after{opacity:1;}}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "question-circle-fill",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("line-height:100%;font-size:14px;margin-right:2px;vertical-align:text-bottom;")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: "キーワード検索について"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/search-keywords.tsx







var SearchKeywords = function(props) {
    var ref = (0,react.useState)(props.conditionKeywords), keywords = ref[0], setKeywords = ref[1];
    var ref1 = (0,react.useState)(false), isComposing = ref1[0], setIsComposing = ref1[1];
    var ref2 = (0,react.useState)(false), isSearchInputFocused = ref2[0], setIsSearchInputFocused = ref2[1];
    var debouncedKeywords = (0,useDebounce/* useDebounce */.N)(keywords, 500);
    var didMountRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!didMountRef.current) {
            didMountRef.current = true;
        } else {
            onChangeDebouceKeywords();
        }
    }, [
        debouncedKeywords
    ]);
    var onChangeDebouceKeywords = function() {
        if (!isComposing) props.onChange(debouncedKeywords);
    };
    var onKeyDownEnter = function() {
        props.onChange(keywords);
    };
    (0,react.useEffect)(function() {
        setKeywords(props.conditionKeywords);
    }, [
        props.conditionKeywords
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: props.className ? "search-keywords ".concat(props.className) : "search-keywords",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpIndicator, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:opacity 0.2s ease 0s;opacity:", isSearchInputFocused ? 1 : 0, ";margin-bottom:4px;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "search",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;font-size:20px;top:15px;left:12px;")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        placeholder: "企業名、事業内容、タグ、代表者名、地名、法人番号などを検索",
                        type: "text",
                        value: keywords,
                        onChange: function(e) {
                            setKeywords(e.target.value);
                        },
                        onCompositionStart: function() {
                            return setIsComposing(true);
                        },
                        onCompositionEnd: function() {
                            setIsComposing(false);
                            onKeyDownEnter();
                        },
                        className: "pl-text-field pl-input-fluid",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;background-color:", dist/* colors.gray40 */.O9.gray40, ";color:", dist/* colors.text */.O9.text, ";font-size:14px;height:50px;border:0;border-radius:0;box-shadow:none;padding-left:38px;&::placeholder{color:", dist/* colors.textLight */.O9.textLight, ";}&:focus{box-shadow:none;}"),
                        onFocus: function() {
                            return setIsSearchInputFocused(true);
                        },
                        onBlur: function() {
                            return setIsSearchInputFocused(false);
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/conditionItems/sourcingRouteCondition.tsx

function sourcingRouteCondition_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              max-width: 300px;\n              text-overflow: ellipsis;\n            "
    ]);
    sourcingRouteCondition_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var SourcingRouteCondition = function(param) {
    var sourcingRoutes = param.sourcingRoutes, sourcingRouteIds = param.sourcingRouteIds, onResetOffset = param.onResetOffset, onSelectSourcingRoute = param.onSelectSourcingRoute;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var handleSelectSourcingRoute = function(id) {
        onResetOffset();
        onSelectSourcingRoute({
            id: id
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                className: "condition-label",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;max-width:300px;align-items:center;background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";font-size:13px;position:relative;margin-right:5px;border:none;cursor:pointer;outline:none;padding:5px 10px 5px 15px;"),
                onClick: function() {
                    setIsOpen(function(prev) {
                        return !prev;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"),
                        children: [
                            "ソーシングルート",
                            (0,utils/* formatConditionSourcingRouteDisplay */.u5)(sourcingRoutes, sourcingRouteIds)
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "arrow8-down",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* Cover */.Y, {
                handleClick: function() {
                    return setIsOpen(function(prev) {
                        return !prev;
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                open: isOpen,
                _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:265px;overflow-y:auto;"),
                children: sourcingRoutes.map(function(sr, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                        condition: sourcingRouteIds.map(function(selected) {
                            return selected.id;
                        }).includes(sr.id),
                        idx: idx,
                        handleSet: function() {
                            handleSelectSourcingRoute(sr.id);
                        },
                        label: sr.name,
                        _css: (0,emotion_react_browser_esm/* css */.iv)(sourcingRouteCondition_templateObject())
                    }, idx);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(24211);
;// CONCATENATED MODULE: ./components/pages/companies/components/conditionItems/MyLabelSearchCondition.tsx

function MyLabelSearchCondition_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      max-width: 300px;\n                      text-overflow: ellipsis;\n                    "
    ]);
    MyLabelSearchCondition_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function selectedMyLabels(selectedMyLabelIds, candidates) {
    var selectedMyLabels = candidates.filter(function(item) {
        return selectedMyLabelIds.includes(item.id);
    });
    switch(selectedMyLabels.length){
        case 0:
            return "";
        case 1:
            return " = ".concat(selectedMyLabels[0].name);
        default:
            return " = ".concat(selectedMyLabels[0].name, ", ...");
    }
}
var MyLabelSearchCondition = function(param) {
    var candidates = param.candidates, selectedMyLabelIds = param.selectedMyLabelIds, onSelect = param.onSelect;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var cellRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        cellRef
    ], function() {
        if (isOpen) {
            setIsOpen(!isOpen);
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                className: "condition-label",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;max-width:300px;align-items:center;background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";font-size:13px;position:relative;border:none;cursor:pointer;outline:none;padding:5px 10px 5px 15px;"),
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"),
                        children: [
                            "マイラベル",
                            selectedMyLabels(selectedMyLabelIds, candidates)
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "arrow8-down",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: cellRef,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                    open: isOpen,
                    _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:265px;overflow-y:auto;width:214px;"),
                    children: candidates.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;padding:7px 12px 7px 12px;font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";"),
                        children: "まだマイラベルはありません"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: candidates.map(function(item, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                                idx: i,
                                condition: selectedMyLabelIds.includes(item.id),
                                handleSet: function() {
                                    return onSelect(item.id);
                                },
                                label: item.name,
                                _css: (0,emotion_react_browser_esm/* css */.iv)(MyLabelSearchCondition_templateObject())
                            }, item.id);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/containers/search-condition.tsx
/* global Period: true  */ 
function search_condition_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        max-width: 320px;\n                        overflow: hidden;\n                        white-space: nowrap;\n                        text-overflow: ellipsis;\n                      "
    ]);
    search_condition_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var SearchCondition = function(props) {
    // @ts-ignore 事実上あっているはずだが、本当はもう少し考えないといけない
    var selected = Object.keys(props.conditions);
    var user = (0,AuthContext/* useUser */.a)();
    var handleOnKeywordChange = function(keywords) {
        props.onResetOffset();
        props.onKeywordsChange(keywords);
    };
    var handleSelectOption = function(name, value) {
        props.onResetOffset();
        props.onToggleOption(name, value);
    };
    var handleSelectOptionList = function(name, values, setType) {
        props.onResetOffset();
        props.onSetOptions(name, values, setType);
    };
    var handleSetRange = function(name, range) {
        props.onResetOffset();
        props.onSetRange(name, range);
    };
    var handleSetPeriod = function(name, period) {
        props.onResetOffset();
        props.onSetPeriod(name, period);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchKeywords, {
                conditionKeywords: props.keywords,
                onChange: handleOnKeywordChange,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:16px;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:grid;grid-template-columns:auto 1fr;gap:16px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConditionTitle, {
                        title: "企業情報"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "conditions-row",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;flex-wrap:wrap;column-gap:8px;row-gap:12px;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_ConditionList, {
                                conditions: props.conditions,
                                opening: props.opening,
                                onToggle: props.onToggleCondition,
                                onRemove: props.onRemoveCondition,
                                onSelectOption: handleSelectOption,
                                onSelectRange: handleSetRange,
                                onSelectPeriod: handleSetPeriod,
                                onSelectOptionList: handleSelectOptionList,
                                errors: props.errors
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_ConditionSelector, {
                                selected: selected,
                                open: props.open,
                                onToggle: props.onToggleSelector,
                                onSelect: props.onAddCondition,
                                onRemove: props.onRemoveCondition
                            })
                        ]
                    }),
                    (0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConditionTitle, {
                                title: "ステータス"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;flex-wrap:wrap;column-gap:8px;row-gap:12px;"),
                                className: "sourcing-annotations-filter-conditions-row",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";font-size:13px;position:relative;"),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                                className: "condition-label",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;max-width:300px;align-items:center;padding:5px 10px 5px 15px;cursor:pointer;"),
                                                onClick: function() {
                                                    if (props.statusCondition.openingItem === statusConditionItems.status) {
                                                        props.openStatusCondition(null);
                                                    } else {
                                                        props.openStatusCondition(statusConditionItems.status);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"),
                                                        children: [
                                                            "ステータス",
                                                            (0,utils/* formatConditionDisplay */.Yd)(props.statusCondition.filterItems, statusConditionItems.status, props.investingStatuses, function(ip) {
                                                                return ip.name;
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                        name: "arrow8-down",
                                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
                                                    })
                                                ]
                                            }),
                                            props.statusCondition.openingItem === statusConditionItems.status && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* Cover */.Y, {
                                                handleClick: function() {
                                                    return props.openStatusCondition(null);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                                                open: props.statusCondition.openingItem === statusConditionItems.status,
                                                children: props.investingStatuses.map(function(s, idx) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                                                        condition: lodash_default().flatten(props.statusCondition.filterItems.filter(function(i) {
                                                            return i.itemName === statusConditionItems.status;
                                                        }).map(function(i) {
                                                            return i.conditions.map(function(c) {
                                                                return c.id;
                                                            });
                                                        })).includes(s.id),
                                                        idx: idx,
                                                        handleSet: function() {
                                                            props.onResetOffset();
                                                            props.selectFilterStatusCondition(statusConditionItems.status, {
                                                                id: s.id
                                                            });
                                                        },
                                                        label: s.name,
                                                        _css: (0,emotion_react_browser_esm/* css */.iv)(search_condition_templateObject())
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_PeriodCondition, {
                                        name: "statusUpdated",
                                        open: props.statusCondition.openingItem === statusConditionItems.statusUpdated,
                                        selected: props.statusCondition.statusUpdated,
                                        hasError: props.errors.includes("statusUpdated"),
                                        onToggle: function() {
                                            if (props.statusCondition.openingItem === statusConditionItems.statusUpdated) {
                                                props.openStatusCondition(null);
                                            } else {
                                                props.openStatusCondition(statusConditionItems.statusUpdated);
                                            }
                                        },
                                        onRemove: function() {
                                            props.onResetOffset();
                                            props.selectFilterStatusUpdated({
                                                from: null,
                                                to: null
                                            });
                                        },
                                        onSet: function(_, period) {
                                            props.onResetOffset();
                                            var _from, _to;
                                            props.selectFilterStatusUpdated({
                                                from: (_from = period.from) !== null && _from !== void 0 ? _from : null,
                                                to: (_to = period.to) !== null && _to !== void 0 ? _to : null
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.cyan50 */.O9.cyan50, ";border-radius:50px;color:", dist/* colors.white10 */.O9.white10, ";font-size:13px;position:relative;"),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                                className: "condition-label",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;max-width:300px;align-items:center;padding:5px 10px 5px 15px;cursor:pointer;"),
                                                onClick: function() {
                                                    if (props.statusCondition.openingItem === statusConditionItems.contactPeople) {
                                                        props.openStatusCondition(null);
                                                    } else {
                                                        props.openStatusCondition(statusConditionItems.contactPeople);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"),
                                                        children: [
                                                            "担当者",
                                                            (0,utils/* formatConditionDisplay */.Yd)(props.statusCondition.filterItems, statusConditionItems.contactPeople, props.contactPersonsFilterList, function(cp) {
                                                                return "".concat(cp.lastName, " ").concat(cp.firstName);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                                        name: "arrow8-down",
                                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;color:", dist/* colors.white10 */.O9.white10, ";&:before{font-size:0.65rem;margin-left:5px;}")
                                                    })
                                                ]
                                            }),
                                            props.statusCondition.openingItem === statusConditionItems.contactPeople && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* Cover */.Y, {
                                                handleClick: function() {
                                                    return props.openStatusCondition(null);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdown/* OptionDropdown */.b, {
                                                open: props.statusCondition.openingItem === statusConditionItems.contactPeople,
                                                _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-height:265px;overflow-y:auto;"),
                                                children: props.contactPersonsFilterList.map(function(cp, idx) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                                                        condition: lodash_default().flatten(props.statusCondition.filterItems.filter(function(i) {
                                                            return i.itemName === statusConditionItems.contactPeople;
                                                        }).map(function(i) {
                                                            return i.conditions.map(function(c) {
                                                                return c.id;
                                                            });
                                                        })).includes(cp.id),
                                                        idx: idx,
                                                        handleSet: function() {
                                                            props.onResetOffset();
                                                            props.selectFilterStatusCondition(statusConditionItems.contactPeople, {
                                                                id: cp.id
                                                            });
                                                        },
                                                        label: "".concat(cp.lastName, " ").concat(cp.firstName)
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelSearchCondition, {
                                        candidates: props.myLabels,
                                        selectedMyLabelIds: props.statusCondition.myLabelIds,
                                        onSelect: props.onSelectMyLabel
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(condition_PeriodCondition, {
                                        name: "firstInterviewDate",
                                        open: props.statusCondition.openingItem === statusConditionItems.firstInterviewDate,
                                        selected: props.statusCondition.firstInterviewDate,
                                        hasError: props.errors.includes("firstInterviewDate"),
                                        onToggle: function() {
                                            if (props.statusCondition.openingItem === statusConditionItems.firstInterviewDate) {
                                                props.openStatusCondition(null);
                                            } else {
                                                props.openStatusCondition(statusConditionItems.firstInterviewDate);
                                            }
                                        },
                                        onRemove: function() {
                                            props.onResetOffset();
                                            props.selectFilterFirstInterviewDate({
                                                from: null,
                                                to: null
                                            });
                                        },
                                        onSet: function(_, period) {
                                            props.onResetOffset();
                                            var _from, _to;
                                            props.selectFilterFirstInterviewDate({
                                                from: (_from = period.from) !== null && _from !== void 0 ? _from : null,
                                                to: (_to = period.to) !== null && _to !== void 0 ? _to : null
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingRouteCondition, {
                                        sourcingRoutes: props.sourcingRoutes,
                                        sourcingRouteIds: props.statusCondition.sourcingRouteIds,
                                        onResetOffset: props.onResetOffset,
                                        onSelectSourcingRoute: props.onSelectSourcingRoute
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SearchCondition.displayName = "SearchCondition";
var mapStateToProps = function(state) {
    return {
        keywords: state.condition.keywords,
        tags: state.condition.tags,
        open: state.app.open,
        conditions: state.condition.selected,
        opening: state.app.openingCondition,
        errors: state.error.errors,
        investingStatuses: state.statuses.data,
        contactPersons: state.contactPersons.data,
        statusCondition: state.statusCondition,
        contactPersonsFilterList: state.contactPersonsFilterList.data,
        sourcingRoutes: state.sourcingAnnotationsCandidates.sourcingRoutes,
        myLabels: state.sourcingAnnotationsCandidates.myLabels
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        onKeywordsChange: function(keywords) {
            dispatch(changeKeywords(keywords));
        },
        onResetOffset: function() {
            dispatch(resetOffset());
        },
        onToggleSelector: function() {
            dispatch(toggleSelector());
        },
        onAddCondition: function(name) {
            dispatch(addCondition(name));
        },
        onRemoveCondition: function(name) {
            dispatch(removeCondition(name));
        },
        onToggleCondition: function(name) {
            dispatch(toggleCondition(name));
        },
        onToggleOption: function(name, value) {
            dispatch(toggleOption(name, value));
        },
        onSetOptions: function(name, values, setType) {
            dispatch(setOptions(name, values, setType));
        },
        onSetRange: function(name, range) {
            dispatch(setRange(name, range));
        },
        onSetPeriod: function(name, period) {
            dispatch(setPeriod(name, period));
        },
        onSelectStatus: function(statusId) {
            dispatch(setStatus(statusId));
        },
        openStatusCondition: function(item) {
            dispatch(openStatusCondition(item));
        },
        selectFilterStatusCondition: function(itemName, conditions) {
            dispatch(selectFilterStatusCondition({
                itemName: itemName,
                conditions: conditions
            }));
        },
        selectFilterStatusUpdated: function(payload) {
            dispatch(selectFilterStatusUpdated(payload));
        },
        selectFilterFirstInterviewDate: function(payload) {
            dispatch(selectFilterFirstInterviewDate(payload));
        },
        onSelectSourcingRoute: function(payload) {
            dispatch(selectFilterSourcingRoute(payload));
        },
        onSelectMyLabel: function(payload) {
            dispatch(selectFilterMyLabel(payload));
        }
    };
};
/* harmony default export */ var search_condition = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(SearchCondition));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
;// CONCATENATED MODULE: ./components/atoms/Snackbar.tsx






var Snackbar = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), timer = ref[0], setTimer = ref[1];
    var cancel = function() {
        props.setIsShow(false);
        clearTimeout(timer || undefined);
    };
    (0,react.useEffect)(function() {
        if (props.isShow) {
            var t = window.setTimeout(function() {
                props.setIsShow(false);
            }, 5000);
            setTimer(t);
        }
    }, [
        props.isShow
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: props.isShow ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "snackbar",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:fit-content;padding:12px 8px 12px 24px;gap:8px;height:56px;background:rgba(0,0,0,0.85);box-shadow:0px 4px 16px rgba(0,0,0,0.04);border-radius:8px;display:flex;flex-direction:row;align-items:center;z-index:1000;position:absolute;bottom:0%;left:40%;animation:bound 5s forwards;@keyframes bound{0%{transform:translateY(60px);}1%{transform:translateY(40px);}2%{transform:translateY(20px);}3%{transform:translateY(0px);}4%{transform:translateY(-15px);}5%{transform:translateY(-25px);}6%{transform:translateY(-32px);}7%{transform:translateY(-28px);}8%{transform:translateY(-24px);}9%{transform:translateY(-24px);}10%{transform:translateY(-24px);}25%{transform:translateY(-24px);}30%{transform:translateY(-24px);}40%{transform:translateY(-24px);}50%{transform:translateY(-24px);}60%{transform:translateY(-24px);}70%{transform:translateY(-24px);}80%{transform:translateY(-24px);}95%{transform:translateY(-24px);}96%{transform:translateY(-18px);}97%{transform:translateY(-12px);}98%{transform:translateY(-6px);}100%{transform:translateY(100px);}}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "snackbar-message",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:280px;height:32px;font-size:14px;color:", dist/* colors.white00 */.O9.white00, ";font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:14px;line-height:150%;letter-spacing:0.02em;display:flex;align-items:center;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        children: props.text
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;cursor:pointer;&:hover .hover-circle{opacity:1;}"),
                    onClick: function() {
                        cancel();
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            src: "static/images/default/hover_circle.png",
                            className: "hover-circle",
                            alt: "hover circle",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("opacity:0;display:flex;align-items:center;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;position:absolute;top:35%;left:35%;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                src: "static/images/default/close.svg",
                                alt: "close icon",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:10px;height:10px;")
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {})
    });
};

// EXTERNAL MODULE: ./components/atoms/Modal.tsx
var Modal = __webpack_require__(99338);
;// CONCATENATED MODULE: ./components/pages/companies/reducers/column.ts




var getColumnNames = function(latestPlan, earlyAccess) {
    if (earlyAccess && latestPlan) {
        return COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS;
    } else {
        return COLUMN_NAMES_WITH_STATUS;
    }
};
var COLUMN_NAMES_WITH_STATUS = {
    name: {
        label: "企業名",
        displayOrder: 0,
        selected: true,
        width: 240
    },
    description: {
        label: "事業内容",
        displayOrder: 1,
        selected: true,
        width: 360
    },
    tags: {
        label: "タグ",
        displayOrder: 2,
        selected: true,
        width: 360
    },
    type: {
        label: "タイプ",
        displayOrder: 3,
        selected: true,
        width: 120
    },
    country: {
        label: "国・地域",
        displayOrder: 4,
        selected: true,
        width: 128
    },
    established: {
        label: "設立年月日",
        displayOrder: 5,
        selected: true,
        width: 104
    },
    representativeName: {
        label: "代表者名",
        displayOrder: 6,
        selected: true,
        width: 160
    },
    employees: {
        label: "従業員数",
        displayOrder: 7,
        selected: true,
        width: 96
    },
    state: {
        label: "都道府県",
        displayOrder: 8,
        selected: false,
        width: 96
    },
    address: {
        label: "住所",
        displayOrder: 9,
        selected: false,
        width: 256
    },
    telephone: {
        label: "電話番号",
        displayOrder: 10,
        selected: false,
        width: 128
    },
    industry: {
        label: "業種",
        displayOrder: 11,
        selected: false,
        width: 216
    },
    origin: {
        label: "起源",
        displayOrder: 12,
        selected: false,
        width: 160
    },
    institute: {
        label: "大学・研究機関",
        displayOrder: 13,
        selected: false,
        width: 176
    },
    website: {
        label: "ウェブサイト",
        displayOrder: 14,
        selected: false,
        width: 200
    },
    corporateNumber: {
        label: "法人番号",
        displayOrder: 15,
        selected: false,
        width: 136
    },
    latestInitialSeries: {
        label: "スピーダ\n調達シリーズ",
        displayOrder: 16,
        selected: true,
        width: 128
    },
    cbLatestRoundType: {
        label: "Crunchbase\n最新ラウンドタイプ",
        displayOrder: 17,
        selected: true,
        width: 160
    },
    lastFundraised: {
        label: "最新ラウンド調達日",
        displayOrder: 18,
        selected: true,
        width: 152
    },
    totalFunding: {
        label: "総調達額",
        displayOrder: 19,
        selected: true,
        width: 112
    },
    valuation: {
        label: "調達後評価額",
        displayOrder: 20,
        selected: true,
        width: 120
    },
    lastValuationDate: {
        label: "評価額算出ラウンド実施日",
        displayOrder: 21,
        selected: false,
        width: 168
    },
    shareholderStatus: {
        label: "株主状況",
        displayOrder: 22,
        selected: true,
        width: 200
    },
    investingStatus: {
        label: "ステータス",
        displayOrder: 23,
        selected: true,
        width: 224
    },
    investingStatusUpdated: {
        label: "ステータス更新日",
        displayOrder: 24,
        selected: true,
        width: 144
    },
    contactPerson: {
        label: "担当者",
        displayOrder: 25,
        selected: true,
        width: 144
    },
    myLabels: {
        label: "マイラベル",
        displayOrder: 26,
        selected: true,
        width: 340
    },
    firstInterviewDate: {
        label: "初回面談日",
        displayOrder: 27,
        selected: true,
        width: 144
    },
    sourcingRoute: {
        label: "ソーシングルート",
        displayOrder: 28,
        selected: true,
        width: 224
    },
    memo: {
        label: "メモ",
        displayOrder: 29,
        selected: true,
        width: 336
    },
    ipoCategory: {
        label: "IPO区分",
        displayOrder: 30,
        selected: false,
        width: 120
    },
    ipoJikasougaku: {
        label: "IPO時 時価総額（初値）",
        displayOrder: 31,
        selected: false,
        width: 160
    },
    // ipoJikasougakuPublicPrice: {
    //   label: 'IPO時 時価総額（公開価格）',
    //   displayOrder: 32,
    //   selected: false,
    //   width: 176,
    // },
    ipoed: {
        label: "IPO年月日",
        displayOrder: 33,
        selected: false,
        width: 104
    },
    market: {
        label: "IPO市場",
        displayOrder: 34,
        selected: false,
        width: 160
    },
    researchStatus: {
        label: "調査状況",
        displayOrder: 35,
        selected: false,
        width: 160
    },
    updated: {
        label: "更新日",
        displayOrder: 36,
        selected: true,
        width: 96
    },
    created: {
        label: "登録日",
        displayOrder: 37,
        selected: true,
        width: 96
    }
};
var COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS = (0,_object_spread/* default */.Z)({}, COLUMN_NAMES_WITH_STATUS);
var UNREMOVABLE_NAMES = [
    "name"
];
// NOTE: この初期値は COLUMN_NAMES_WITH_STATUS から生成した方がよい
var initialColumns = [
    "name",
    "description",
    "tags",
    "latestInitialSeries",
    "investingStatus",
    "investingStatusUpdated",
    "firstInterviewDate",
    "contactPerson",
    "memo",
    "representativeName",
    "totalFunding",
    "valuation",
    "state",
    "established",
    "lastFundraised",
    "type",
    "created",
    "updated", 
];
var column_init = {
    setting: initialColumns
};
var column_toggle = function(selected, name) {
    return selected.includes(name) ? selected.filter(function(n) {
        return n !== name;
    }) : (0,_to_consumable_array/* default */.Z)(selected).concat([
        name
    ]);
};
var column_add = function(selected, name) {
    return selected.includes(name) ? selected : (0,_to_consumable_array/* default */.Z)(selected).concat([
        name
    ]);
};
function column() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : column_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case ADD_CONDITION:
            // researchStatusCategoryはDBには値を持っておらず、ロジック側でまとめているので、選択レコードとしては代替としてresearchStatusを利用する
            if (action.payload === "researchStatusCategory") {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    setting: column_add(state.setting, "researchStatus")
                });
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                setting: column_add(state.setting, action.payload)
            });
        case TOGGLE_COLUMN:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                setting: column_toggle(state.setting, action.payload)
            });
        case UPDATE_COLUMNS:
            // validate column names.
            var columnNames = action.payload;
            var validColumnNames = Object.keys(COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS);
            var validatedColumnNames = columnNames.filter(function(name) {
                return validColumnNames.includes(name);
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                setting: validatedColumnNames
            });
        case CLEAR_ALL:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                setting: UNREMOVABLE_NAMES
            });
        case RESET:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                setting: action.payload
            });
    }
    return state;
}

// EXTERNAL MODULE: ./node_modules/@dnd-kit/core/dist/core.esm.js + 1 modules
var core_esm = __webpack_require__(60887);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/sortable/dist/sortable.esm.js
var sortable_esm = __webpack_require__(45587);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/modifiers/dist/modifiers.esm.js
var modifiers_esm = __webpack_require__(32339);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/utilities/dist/utilities.esm.js
var utilities_esm = __webpack_require__(24285);
// EXTERNAL MODULE: ./node_modules/array-move/index.js
var array_move = __webpack_require__(62748);
;// CONCATENATED MODULE: ./components/pages/companies/components/column-sort.tsx











var ColumnSort = function(param) {
    var selected = param.selected, onRemove = param.onRemove, onSort = param.onSort;
    var onSortEnd = function(oldIndex, newIndex) {
        onSort((0,array_move/* arrayMoveImmutable */.q)(selected, oldIndex, newIndex));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "body column-sort",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("float:right;padding:15px 0 0 15px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "description",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#666;font-size:13px;"),
                children: "並べ替え"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "annotation",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#999;float:right;font-size:13px;"),
                children: "ドラッグ＆ドロップで並べ替え"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortableList, {
                selected: selected,
                onRemove: onRemove,
                onSortEnd: onSortEnd
            })
        ]
    });
};
var SortableList = function(param) {
    var selected = param.selected, onRemove = param.onRemove, onSortEnd = param.onSortEnd;
    var getIndex = function(name) {
        return selected.findIndex(function(item) {
            return item === name;
        });
    };
    var handleDragEnd = function(param) {
        var active = param.active, over = param.over;
        if (over) {
            onSortEnd(getIndex(active.id), getIndex(over.id));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_esm/* DndContext */.LB, {
        modifiers: [
            modifiers_esm/* restrictToVerticalAxis */.DL
        ],
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sortable_esm/* SortableContext */.Fo, {
            items: selected,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                className: "options",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;overflow-y:auto;margin-top:6px;width:400px;height:345px;padding:0;"),
                children: selected.map(function(name, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortableItem, {
                        name: name,
                        isUnremoval: UNREMOVABLE_NAMES.includes(name),
                        onRemove: function(name) {
                            return onRemove(name);
                        }
                    }, "".concat(i, "-").concat(name));
                })
            })
        })
    });
};
var SortableItem = function(param) {
    var name = param.name, isUnremoval = param.isUnremoval, onRemove = param.onRemove;
    var // @ts-ignore
    ref;
    var ref1 = (0,sortable_esm/* useSortable */.nB)({
        id: name
    }), attributes = ref1.attributes, listeners = ref1.listeners, setNodeRef = ref1.setNodeRef, transform = ref1.transform, transition = ref1.transition;
    var style = {
        transform: utilities_esm/* CSS.Transform.toString */.ux.Transform.toString(transform),
        transition: transition
    };
    var ref2;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "sortable-item",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:#fff;border-bottom:1px solid #d9d9d9;padding-top:7px;padding-bottom:7px;position:relative;z-index:1000;font-size:14px;padding-left:10px;list-style:none;text-align:left;"),
        ref: setNodeRef
    }, attributes), {
        style: style,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.red50 */.O9.red50, ";cursor:pointer;font-size:16px;margin-right:6px;vertical-align:middle;&.disabled{color:", dist/* colors.gray50 */.O9.gray50, ";cursor:default;}"),
                className: isUnremoval ? "icon-remove icomoon icon-remove-fill disabled" : "icon-remove icomoon icon-remove-fill",
                onClick: function() {
                    return isUnremoval ? null : onRemove(name);
                }
            }),
            (ref2 = (ref = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref === void 0 ? void 0 : ref.label.replace("\n", "")) !== null && ref2 !== void 0 ? ref2 : "",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandle, {
                listeners: listeners
            })
        ]
    }));
};
var DragHandle = function(param) {
    var listeners = param.listeners;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", (0,_object_spread/* default */.Z)({
        className: "icon-sort icomoon icon-sort1",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#d9d9d9;cursor:pointer;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:18px;position:absolute;right:5px;")
    }, listeners));
};

;// CONCATENATED MODULE: ./components/pages/companies/components/header-button.tsx



var HeaderButton = function(param) {
    var disabled = param.disabled, isLoading = param.isLoading, onClick = param.onClick, tooltip = param.tooltip, label = param.label, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
            label: tooltip || "",
            className: "download-button-tooltip",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: disabled ? "header-button disabled" : "header-button",
                onClick: function() {
                    return onClick && !disabled && onClick();
                },
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;padding:6px 12px;cursor:pointer;vertical-align:bottom;transition:0.15s;&:hover{background:rgba(0,0,0,0.03);}opacity:", isLoading ? 0.5 : 1, ";"),
                children: [
                    children,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;font-style:normal;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:11px;line-height:100%;display:flex;align-items:center;text-align:center;letter-spacing:0.02em;color:", dist/* colors.textStrong */.O9.textStrong, ";margin-top:5.25px;"),
                        children: label
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/share/column-setting.tsx


var _this = undefined;
function column_setting_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        padding: 5px 0 5px 15px;\n                      "
    ]);
    column_setting_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function column_setting_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                            cursor: pointer;\n                            margin: 0 10px 0 0;\n                            vertical-align: middle;\n                          "
    ]);
    column_setting_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var ColumnSetting = function(props) {
    var ref = (0,react.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var ref1 = (0,react.useState)(""), snackbarMessage = ref1[0], setSnackbarMessage = ref1[1];
    var handleToggle = function(name) {
        props.dispatch(toggleColumn(name));
    };
    var handleSort = function(names) {
        props.dispatch(updateColumns(names));
    };
    // TODO: 親側のコンポーネントでも同じような情報を持っているので整理したい
    var availableColumnNamesHash = getColumnNames(props.permission.latestPlan, props.permission.earlyAccess);
    var initialColumnNames = Object.keys(availableColumnNamesHash).filter(function(key) {
        // @ts-ignore
        return availableColumnNamesHash[key].selected;
    }).sort(function(a, b) {
        return(// @ts-ignore
        availableColumnNamesHash[a].displayOrder - // @ts-ignore
        availableColumnNamesHash[b].displayOrder);
    });
    var handleSelectAll = function(e) {
        e.preventDefault();
        // displayOrder が小さい順に key を並び替えた key の配列を返す
        var sortedKeys = Object.entries(availableColumnNamesHash).sort(function(param, param1) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), a = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), b = _param1[1];
            return a.displayOrder - b.displayOrder;
        }).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
            return key;
        });
        props.dispatch(updateColumns(sortedKeys));
    };
    var handleClearAll = function(e) {
        e.preventDefault();
        props.dispatch(clearAll());
    };
    var handleReset = function(initialColumnNames) {
        props.dispatch(column_reset(initialColumnNames));
    };
    var handleSaveColumnSetting = function(names) {
        try {
            localStorage.setItem("column_setting", names.toString());
            setSnackbarMessage("表示設定を保存しました。");
        } catch (e) {
            setSnackbarMessage("表示設定の保存に失敗しました。");
        }
        setIsShow(true);
    };
    var selected = props.selectedColumns;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderButton, {
                isLoading: false,
                disabled: !props.isHidden,
                label: "表示設定",
                onClick: props.onOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    name: "gear",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";vertical-align:middle;padding-right:4px;font-size:20px;")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Modal */.u_, {
                isHidden: props.isHidden,
                onClose: props.onClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "column-setting",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.white00 */.O9.white00, ";"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "header",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
                                    "data-test-id": "title",
                                    children: "表示項目の選択"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalCloseButton */.ol, {
                                    "data-test-id": "close",
                                    onClick: props.onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "bodies",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;& > .body{text-align:left;}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    className: "body column-selection",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("float:left;padding:15px 15px 0 0;"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "description",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray90 */.O9.gray90, ";font-size:13px;"),
                                            children: "表示項目の選択"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/companies#",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                onClick: handleSelectAll.bind(_this),
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:15px;color:", dist/* colors.link */.O9.link, ";text-decoration:none;font-size:13px;&:hover{text-decoration:underline;}"),
                                                children: "すべて選択"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/companies#",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                onClick: handleClearAll.bind(_this),
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:15px;color:", dist/* colors.link */.O9.link, ";text-decoration:none;font-size:13px;&:hover{text-decoration:underline;}"),
                                                children: "すべてクリア"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                                            className: "options",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;overflow-y:auto;margin-top:6px;width:400px;height:345px;padding-left:0;"),
                                            children: Object.keys(availableColumnNamesHash).sort(function(a, b) {
                                                return(// @ts-ignore
                                                availableColumnNamesHash[a].displayOrder - // @ts-ignore
                                                availableColumnNamesHash[b].displayOrder);
                                            }).map(function(name, i) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(column_setting_templateObject()),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
                                                        className: "checkbox",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                                                className: "checkbox",
                                                                disabled: UNREMOVABLE_NAMES.includes(name),
                                                                type: "checkbox",
                                                                checked: selected.includes(name),
                                                                onChange: function() {
                                                                    return handleToggle(name);
                                                                },
                                                                css: (0,emotion_react_browser_esm/* css */.iv)(column_setting_templateObject1())
                                                            }),
                                                            // @ts-ignore
                                                            availableColumnNamesHash[name].label.replace("\n", "")
                                                        ]
                                                    })
                                                }, "".concat(i, "-").concat(name));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnSort, {
                                    selected: selected,
                                    onRemove: function(name) {
                                        return handleToggle(name);
                                    },
                                    onSort: function(selected) {
                                        return handleSort(selected);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "reset",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-bottom:15px;padding-left:15px;text-align:right;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    href: "#",
                                    decoration: "none",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        handleReset(initialColumnNames);
                                    },
                                    className: "return-default",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0px 6px 2px 0px;margin-right:16px;font-size:14px;"),
                                    children: "初期設定に戻す"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        handleSaveColumnSetting(selected);
                                    },
                                    decoration: "none",
                                    className: "save-column-setting",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-bottom:2px;font-size:14px;"),
                                    children: "この設定を次からも使う"
                                })
                            ]
                        })
                    ]
                })
            }),
            isShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Snackbar, {
                setIsShow: setIsShow,
                isShow: isShow,
                text: snackbarMessage
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/containers/column-setting.tsx


var column_setting_mapStateToProps = function(state) {
    return {
        selectedColumns: state.column.setting,
        permission: state.permission
    };
};
var column_setting_ColumnSetting = (0,es/* connect */.$j)(column_setting_mapStateToProps)(ColumnSetting);

;// CONCATENATED MODULE: ./components/pages/companies/components/result-count.tsx
// @flow








var ResultCount = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ResultCount, _Component);
    var _super = (0,_create_super/* default */.Z)(ResultCount);
    function ResultCount() {
        (0,_class_call_check/* default */.Z)(this, ResultCount);
        return _super.apply(this, arguments);
    }
    var _proto = ResultCount.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "result-count",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:14px 0 14px 24px;color:#666;font-size:14px;line-height:1;margin-top:auto;margin-bottom:auto;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        "検索結果",
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            className: "count",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0 6px 0 2px;font-size:24px;color:", dist/* colors.black10 */.O9.black10, ";"),
                            children: (0,utils/* formatNumber */.uf)(this.props.value)
                        }),
                        " ",
                        "社"
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "annotation",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;color:", dist/* colors.textLight */.O9.textLight, ";margin-left:12px;"),
                    children: "表示は30,000社まで"
                })
            ]
        });
    };
    return ResultCount;
}(react.Component);

// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./lib/wovn.ts
var wovn = __webpack_require__(15598);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./components/pages/companies/common/api.ts
var api = __webpack_require__(13666);
// EXTERNAL MODULE: ./lib/api/common.ts + 3 modules
var common = __webpack_require__(6140);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
;// CONCATENATED MODULE: ./components/pages/companies/libs/queries.ts




function queriesOf(selected) {
    var obj = {};
    var totalFunding = selected.totalFunding, valuation = selected.valuation, employees = selected.employees, established = selected.established, ipoed = selected.ipoed, lastFundraised = selected.lastFundraised, rest = (0,_object_without_properties/* default */.Z)(selected, [
        "totalFunding",
        "valuation",
        "employees",
        "established",
        "ipoed",
        "lastFundraised"
    ]);
    if (totalFunding) {
        var totalFundingFrom = totalFunding.from, totalFundingTo = totalFunding.to;
        Object.assign(obj, {
            totalFundingFrom: totalFundingFrom,
            totalFundingTo: totalFundingTo
        });
    }
    if (valuation) {
        var valuationFrom = valuation.from, valuationTo = valuation.to;
        Object.assign(obj, {
            valuationFrom: valuationFrom,
            valuationTo: valuationTo
        });
    }
    if (employees) {
        var employeesFrom = employees.from, employeesTo = employees.to;
        Object.assign(obj, {
            employeesFrom: employeesFrom,
            employeesTo: employeesTo
        });
    }
    if (established) {
        var establishedFrom = established.from, establishedTo = established.to;
        Object.assign(obj, {
            establishedFrom: establishedFrom ? normalize(establishedFrom) : null,
            establishedTo: establishedTo ? normalize(establishedTo) : null
        });
    }
    if (ipoed) {
        var ipoedFrom = ipoed.from, ipoedTo = ipoed.to;
        Object.assign(obj, {
            ipoedFrom: ipoedFrom ? normalize(ipoedFrom) : null,
            ipoedTo: ipoedTo ? normalize(ipoedTo) : null
        });
    }
    if (lastFundraised) {
        var lastFundraisedFrom = lastFundraised.from, lastFundraisedTo = lastFundraised.to;
        Object.assign(obj, {
            lastFundraisedFrom: lastFundraisedFrom ? normalize(lastFundraisedFrom) : null,
            lastFundraisedTo: lastFundraisedTo ? normalize(lastFundraisedTo) : null
        });
    }
    for(var item in rest){
        var selectedItem = selected[item];
        selectedItem && Object.assign(obj, (0,_define_property/* default */.Z)({}, item, selectedItem.join(",")));
    }
    return obj;
}
var normalize = function(date) {
    return (0,format["default"])((0,parse["default"])(date, "yyyy-MM-dd", new Date()), "yyyy-MM-dd");
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareDesc/index.js
var compareDesc = __webpack_require__(17445);
;// CONCATENATED MODULE: ./components/pages/companies/saga/validate.ts









var validate = function(conditions) {
    return (0,_to_consumable_array/* default */.Z)(validateRange(conditions, [
        "totalFunding",
        "valuation",
        "employees"
    ])).concat((0,_to_consumable_array/* default */.Z)(validatePeriod(conditions, [
        "established",
        "ipoed",
        "lastFundraised",
        "statusUpdated", 
    ])), (0,_to_consumable_array/* default */.Z)(validateSelected(conditions)));
};
function validateRange(conditions, keys) {
    var errors = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var cond = conditions[key];
            if (!cond) {
                continue;
            }
            var from = cond.from, to = cond.to;
            if (from === null || to === null || from === undefined || to === undefined) {
                continue;
            }
            if (from > to) {
                errors.push(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return errors;
}
function validatePeriod(conditions, keys) {
    var errors = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var cond = conditions[key];
            if (!cond) {
                continue;
            }
            var from = cond.from, to = cond.to;
            if (from && !isValidFormat(from) || to && !isValidFormat(to)) {
                errors.push(key);
            }
            if (from && to && !isValidPeriod(from, to)) {
                errors.push(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return errors;
}
var isValidFormat = function(s) {
    var dateRegex = /^\d{4}\-(0?[1-9]|1[0-9])\-(0?[1-9]|[12][0-9]|3[01])$/;
    return s.match(dateRegex);
};
var isValidPeriod = function(from, to) {
    return (0,compareDesc/* default */.Z)((0,parse["default"])(from, "yyyy-MM-dd", new Date()), (0,parse["default"])(to, "yyyy-MM-dd", new Date())) >= 0;
};
function validateSelected(conditions) {
    var keys = (0,_to_consumable_array/* default */.Z)(CHECK_CONDITION_NAMES).concat((0,_to_consumable_array/* default */.Z)(RADIO_CONDITION_NAMES));
    return keys.filter(function(name) {
        var selected = conditions[name] || [];
        var options = constants_conditions/* CONDITION_ITEMS */.GO[name].options;
        var errorSelected = selected.filter(function(select) {
            return !options[select];
        });
        return errorSelected.length;
    });
}
function validateConditions() {
    var selected, errors, _tmp;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return {
                            selected: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.condition.selected), {
                                statusUpdated: state.statusCondition.statusUpdated
                            })
                        };
                    })
                ];
            case 1:
                selected = _state.sent().selected;
                errors = validate(selected);
                if (!// @ts-ignore
                (errors.length > 0)) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setError(errors))
                ];
            case 2:
                _tmp = _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(clearError())
                ];
            case 4:
                _tmp = _state.sent();
                _state.label = 5;
            case 5:
                _tmp;
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./components/pages/companies/actions/statuses.ts
var FETCH_STATUSES = "FETCH_STATUSES";
function fetchStatuses() {
    return {
        type: FETCH_STATUSES
    };
}
var SUCCESS_FETCH_STATUSES = "SUCCESS_FETCH_STATUSES";
function successFetchStatuses(statuses) {
    return {
        type: SUCCESS_FETCH_STATUSES,
        payload: statuses
    };
}
var FAILED_FETCH_STATUSES = "FAILED_FETCH_STATUSES";
function failedFetchStatuses(message) {
    console.log("Error: FAILURE_DOWNLOAD ", message);
    return {
        type: FAILED_FETCH_STATUSES
    };
}
var statusesActions = {
    fetchStatuses: fetchStatuses,
    successFetchStatuses: successFetchStatuses,
    failedFetchStatuses: failedFetchStatuses
};

;// CONCATENATED MODULE: ./components/pages/companies/actions/contactPerson.ts
var FETCH_CONTACT_PERSONS = "FETCH_CONTACT_PERSONS";
function fetchContactPersons() {
    return {
        type: FETCH_CONTACT_PERSONS
    };
}
var SUCCESS_FETCH_CONTACT_PERSONS = "SUCCESS_FETCH_CONTACT_PERSONS";
function successFetchContactPersons(contactPersons) {
    return {
        type: SUCCESS_FETCH_CONTACT_PERSONS,
        payload: contactPersons
    };
}
var FAILED_FETCH_CONTACT_PERSONS = "FAILED_FETCH_CONTACT_PERSONS";
function failedFetchContactPersons(message) {
    console.log("Error:  FAILURE_FETCH_CONTACT_PERSONS", message);
    return {
        type: FAILED_FETCH_CONTACT_PERSONS
    };
}
var contactPersonsActions = {
    fetchContactPersons: fetchContactPersons,
    successFetchContactPersons: successFetchContactPersons,
    failedFetchContactPersons: failedFetchContactPersons
};

;// CONCATENATED MODULE: ./components/pages/companies/actions/contactPersonsFilterList.ts
var FETCH_CONTACT_PERSONS_FILTER_LIST = "FETCH_CONTACT_PERSONS_FILTER_LIST";
function fetchContactPersonsFilterList() {
    return {
        type: FETCH_CONTACT_PERSONS_FILTER_LIST
    };
}
var SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST = "SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST";
function successFetchContactPersonsFilterList(contactPersons) {
    return {
        type: SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST,
        payload: contactPersons
    };
}
var FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST = "FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST";
function failedFetchContactPersonsFilterList(message) {
    console.log("Error:  FAILURE_FETCH_CONTACT_PERSONS_FILTER_LIST", message);
    return {
        type: FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST
    };
}
var contactPersonsFilterListActions = {
    fetchContactPersonsFilterList: fetchContactPersonsFilterList,
    successFetchContactPersonsFilterList: successFetchContactPersonsFilterList,
    failedFetchContactPersonsFilterList: failedFetchContactPersonsFilterList
};

// EXTERNAL MODULE: ./lib/tracking.ts
var tracking = __webpack_require__(56902);
;// CONCATENATED MODULE: ./components/pages/companies/actions/sourcingAnnotation.ts
var REFRESH_SOURCING_ANNOTATION_CANDIDATES = "REFRESH_SOURCING_ANNOTATION_CANDIDATES";
function refreshSourcingAnnotationCandidates() {
    return {
        type: REFRESH_SOURCING_ANNOTATION_CANDIDATES
    };
}
var SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES = "SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES";
function successFetchCandidates(candidatesResponse) {
    return {
        type: SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES,
        payload: candidatesResponse
    };
}
var CHANGE_SOURCING_ROUTE = "CHANGE_SOURCING_ROUTE";
function changeSourcingRoute(payload) {
    return {
        type: CHANGE_SOURCING_ROUTE,
        payload: payload
    };
}
var DETOUCH_COMPANY_SOURCING_ROUTE = "DETOUCH_COMPANY_SOURCING_ROUTE";
function detouchCompanySourcingRoute(payload) {
    return {
        type: DETOUCH_COMPANY_SOURCING_ROUTE,
        payload: payload
    };
}
var SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE = "SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE";
function successDetouchCompanySourcingRoute(payload) {
    return {
        type: SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE,
        payload: payload
    };
}
var SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE = "SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE";
function sucessUpdateCompanySouringRoute(payload) {
    return {
        type: SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE,
        payload: payload
    };
}
var CREATE_SOURCING_ROUTE = "CREATE_SOURCING_ROUTE";
function createSourcingRoute(payload) {
    return {
        type: CREATE_SOURCING_ROUTE,
        payload: payload
    };
}
var UPDATE_SOURCING_ROUTE = "UPDATE_SOURCING_ROUTE";
function updateSourcingRoute(payload) {
    return {
        type: UPDATE_SOURCING_ROUTE,
        payload: payload
    };
}
var DELETE_SOURCING_ROUTE = "DELETE_SOURCING_ROUTE";
function deleteSourcingRoute(payload) {
    return {
        type: DELETE_SOURCING_ROUTE,
        payload: payload
    };
}
var SUCCESS_UPDATE_SOURCING_ROUTE = "SUCCESS_UPDATE_SOURCING_ROUTE";
function successUpdateSourcingRoute(payload) {
    return {
        type: SUCCESS_UPDATE_SOURCING_ROUTE,
        payload: payload
    };
}
var SUCCESS_DELETE_SOURCING_ROUTE = "SUCCESS_DELETE_SOURCING_ROUTE";
function successDeleteSourcingRoute(payload) {
    return {
        type: SUCCESS_DELETE_SOURCING_ROUTE,
        payload: payload
    };
}
var ADD_COMPANY_MY_LABEL = "ADD_COMPANY_MY_LABEL";
function putCompanyMyLabel(payload) {
    return {
        type: ADD_COMPANY_MY_LABEL,
        payload: payload
    };
}
var DELETE_COMPANY_MY_LABEL = "DELETE_COMPANY_MY_LABEL";
function deleteCompanyMyLabel(payload) {
    return {
        type: DELETE_COMPANY_MY_LABEL,
        payload: payload
    };
}
var CREATE_MY_LABEL = "CREATE_MY_LABEL";
function createMyLabel(payload) {
    return {
        type: CREATE_MY_LABEL,
        payload: payload
    };
}
var UPDATE_MY_LABEL = "UPDATE_MY_LABEL";
function updateMyLabel(payload) {
    return {
        type: UPDATE_MY_LABEL,
        payload: payload
    };
}
var DELETE_MY_LABEL = "DELETE_MY_LABEL";
function deleteMyLabel(payload) {
    return {
        type: DELETE_MY_LABEL,
        payload: payload
    };
}

// EXTERNAL MODULE: ./lib/api/company.ts
var company = __webpack_require__(58124);
// EXTERNAL MODULE: ./lib/api/status.ts
var api_status = __webpack_require__(9926);
;// CONCATENATED MODULE: ./components/pages/companies/saga/mylabel.ts







function putCompanyMyLabelRequest(action) {
    var res, body, companyMyLabels;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(company/* addMyLabel */.B1, action.payload.companyId, action.payload.myLabelId, action.payload.user)
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    4
                ];
                body = res.json().then(function(body) {
                    return body;
                });
                return [
                    4,
                    body
                ];
            case 2:
                companyMyLabels = _state.sent().companyMyLabels;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successUpdateCompanyMyLabels({
                        companyId: action.payload.companyId,
                        companyMyLabels: companyMyLabels
                    }))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                console.log("Error: updateCompanyFirstInterviewDate failed", res.status);
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function deleteCompanyMyLabelRequest(action) {
    var res, body, companyMyLabels;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(company/* removeMyLabel */.xe, action.payload.companyId, action.payload.myLabelId, action.payload.user)
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    4
                ];
                body = res.json().then(function(body) {
                    return body;
                });
                return [
                    4,
                    body
                ];
            case 2:
                companyMyLabels = _state.sent().companyMyLabels;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successUpdateCompanyMyLabels({
                        companyId: action.payload.companyId,
                        companyMyLabels: companyMyLabels
                    }))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                console.log("Error: updateCompanyFirstInterviewDate failed", res.status);
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function postMyLabel(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api_status/* postMyLabel */.i1, action.payload.name)
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: createMyLabel");
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function putMyLabel(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api_status/* putMyLabel */.XC, action.payload.id, action.payload.name)
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: updateMyLabel");
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function execDeleteMyLabel(action) {
    var myLabelId, res, myLabelIds;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                myLabelId = action.payload.id;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api_status/* deleteMyLabel */.oe, myLabelId)
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.condition.myLabelIds;
                    })
                ];
            case 3:
                myLabelIds = _state.sent();
                if (!myLabelIds.includes(myLabelId)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitMyLabelCondition(myLabelIds.filter(function(id) {
                        return id !== myLabelId;
                    })))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(sagas_fetchCompanies)
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    3,
                    8
                ];
            case 7:
                console.error("Error: execDeleteMyLabel");
                _state.label = 8;
            case 8:
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./components/pages/companies/sagas.ts





















var compactObject = function(obj) {
    return (0,utils/* fromEntries */.sq)(Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
        return !!value;
    }));
};
// refs: https://uzabase.slack.com/archives/C9JE6SZNK/p1693281485086959
// AWS WAF の block SQLi ルールに引っかかってしまう問題への対処
var normalizeTextToAvoidSqlInjectionWafRule = function(input) {
    return input.replace(/\(/g, "（").replace(/\)/g, "）");
};
function buildCondintion(conditionState, columnState) {
    var input = conditionState.keywords, tags = conditionState.tags, offset = conditionState.offset, limit = conditionState.limit, sort = conditionState.sort, order = conditionState.order, selected = conditionState.selected, page = conditionState.page;
    var ref = extractTagsAndKeywords(input), extractedTags = ref.extractedTags, extractedKeywords = ref.extractedKeywords;
    tags = extractedTags.replace(/^,/, "").replace(/,$/, "");
    var keywords = normalizeTextToAvoidSqlInjectionWafRule(extractedKeywords);
    var fields = buildColumnField(columnState);
    offset = page ? (page - 1) * 50 : offset;
    var q = (0,_object_spread/* default */.Z)({
        keywords: keywords,
        tags: tags,
        offset: offset,
        limit: limit,
        sort: sort,
        order: order,
        fields: fields,
        page: page
    }, queriesOf(selected));
    return compactObject(q);
}
function buildColumnField(columnState) {
    var setting = columnState.setting;
    var fields = setting.join(",");
    return fields;
}
function extractTagsAndKeywords(input) {
    var tagRegexp = /(#[^\s]+)/g;
    var tagList = input.match(tagRegexp) || [];
    var extractedTags = tagList.map(function(s) {
        return s.replace("#", "");
    }).join(",");
    var extractedKeywords = input.split(" ").map(function(v) {
        return v.replace(tagRegexp, "");
    }).filter(function(v) {
        return v;
    }).join(" ");
    return {
        extractedTags: extractedTags,
        extractedKeywords: extractedKeywords
    };
}
function prepareCondition() {
    var conditionState, columnState;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.condition;
                    })
                ];
            case 1:
                conditionState = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.column;
                    })
                ];
            case 2:
                columnState = _state.sent();
                return [
                    2,
                    buildCondintion(conditionState, columnState)
                ];
        }
    });
}
function prepareStatusCondition() {
    var conditionState;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.statusCondition;
                    })
                ];
            case 1:
                conditionState = _state.sent();
                return [
                    2,
                    buildStatusCondition(conditionState)
                ];
        }
    });
}
function buildStatusCondition(conditionState) {
    var conditions = conditionState.filterItems.reduce(function(acc, curr) {
        return curr.conditions.length === 0 ? acc : Object.assign(acc, (0,_define_property/* default */.Z)({}, curr.itemName, curr.conditions.map(function(c) {
            return c.id.toString();
        }).join(",")));
    }, {});
    var dateConditions = [
        {
            key: "statusUpdated",
            value: conditionState.statusUpdated
        },
        {
            key: "firstInterviewDate",
            value: conditionState.firstInterviewDate
        }, 
    ];
    dateConditions.forEach(function(param) {
        var key = param.key, value = param.value;
        if (value) {
            var updatedFromKey = "".concat(key, "From");
            var updatedToKey = "".concat(key, "To");
            if (value.from) {
                conditions[updatedFromKey] = normalize(value.from);
            }
            if (value.to) {
                conditions[updatedToKey] = normalize(value.to);
            }
        }
    });
    if (conditionState.sourcingRouteIds.length !== 0) {
        conditions.sourcingRouteIds = conditionState.sourcingRouteIds.map(function(e) {
            return e.id;
        }).join(",");
    }
    if (conditionState.myLabelIds.length > 0) {
        conditions.myLabelIds = conditionState.myLabelIds.join(",");
    }
    return conditions;
}
function handleRequestDownload() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (false) {}
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* take */.qn)(REQUEST_DOWNLOAD)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(downloadCompanies)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    0
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function downloadCompanies() {
    var errors, condition, statusCondition, ref, payload, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(validateConditions)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.error;
                    })
                ];
            case 2:
                errors = _state.sent().errors;
                if (errors.length > 0) return [
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(prepareCondition)
                ];
            case 3:
                condition = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(prepareStatusCondition)
                ];
            case 4:
                statusCondition = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* getBlob */.Br, "/api/v2/companies/report?".concat(query_string.stringify(condition), "&").concat(query_string.stringify(statusCondition)))
                ];
            case 5:
                ref = _state.sent(), payload = ref.payload, error = ref.error;
                if (!(payload && !error)) return [
                    3,
                    8
                ];
                download_default()(payload, "ep-companies-".concat((0,utils/* timestamp */.AB)(), ".xlsx"), payload.type);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDownload())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(fetchPermission)
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 8:
                console.error(error);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failureDownload(error))
                ];
            case 9:
                _state.sent();
                _state.label = 10;
            case 10:
                return [
                    2
                ];
        }
    });
}
var PREFLIGHT_SEARCH = "PREFLIGHT_SEARCH";
var preflightSearch = function() {
    return {
        type: PREFLIGHT_SEARCH
    };
};
function handleChangeCondition() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (false) {}
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* take */.qn)([
                        CHANGE_KEYWORDS,
                        CHANGE_PAGE,
                        TOGGLE_OPTION,
                        SET_OPTIONS,
                        REMOVE_CONDITION,
                        SET_RANGE,
                        SET_PERIOD,
                        TOGGLE_SORT,
                        SELECT_FILTER_STATUS_CONDITION,
                        SELECT_FILTER_STATUS_UPDATED,
                        SELECT_FILTER_FIRST_INTERVIEW_DATE,
                        SELECT_FILTER_SOURCING_ROUTE,
                        SELECT_FILTER_MY_LABEL
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(preflightSearch())
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    0
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function handleRequestSearch() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(PREFLIGHT_SEARCH, sagas_fetchCompanies)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function sagas_fetchCompanies() {
    var abortController, errors, condition, statusCondition, response;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                abortController = new AbortController();
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    ,
                    13,
                    15
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* delay */.gw)(200)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(requestSearch())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(validateConditions)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.error;
                    })
                ];
            case 5:
                errors = _state.sent().errors;
                if (errors.length > 0) return [
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(prepareCondition)
                ];
            case 6:
                condition = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(prepareStatusCondition)
                ];
            case 7:
                statusCondition = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/v2/companies?".concat(query_string.stringify(condition), "&").concat(query_string.stringify(statusCondition)), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition), {
                        signal: abortController.signal
                    }))
                ];
            case 8:
                response = _state.sent();
                if (!response) return [
                    3,
                    10
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successSearch(response))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failureSearch("failed to fetch response"))
                ];
            case 11:
                _state.sent();
                _state.label = 12;
            case 12:
                return [
                    3,
                    15
                ];
            case 13:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* cancelled */.By)()
                ];
            case 14:
                // @ts-ignore
                if (_state.sent()) {
                    abortController.abort();
                }
                return [
                    7
                ];
            case 15:
                return [
                    2
                ];
        }
    });
}
function fetchPermission() {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/users/me")
                ];
            case 1:
                res = _state.sent();
                if (!res) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successFetchPermission(res.role, res.latestPlan, res.searchDownloadRestricted, res.searchDownloadAllowed, res.earlyAccess))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failFetchPermission("failed to fetch permission"))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function sagas_fetchStatuses() {
    var response, e;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(statusesActions.fetchStatuses())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    5,
                    ,
                    7
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/statuses")
                ];
            case 3:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(statusesActions.successFetchStatuses(response))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 5:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(statusesActions.failedFetchStatuses("failed to fetch statuses"))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function fetchContactPerson() {
    var response, e;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsActions.fetchContactPersons())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    5,
                    ,
                    7
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/users")
                ];
            case 3:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsActions.successFetchContactPersons(response))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 5:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsActions.failedFetchContactPersons("failed to fetch statuses"))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function fetchContactPersonFilterList() {
    var response, e;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // 無効ユーザーを含む一覧取得
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsFilterListActions.fetchContactPersonsFilterList())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    5,
                    ,
                    7
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/including_invalid_users")
                ];
            case 3:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsFilterListActions.successFetchContactPersonsFilterList(response))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 5:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(contactPersonsFilterListActions.failedFetchContactPersonsFilterList("failed to fetch statuses"))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function fetchSourcingAnnotationCandidates() {
    var response, e;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(common/* callAPI */.F, "/api/v1/sourcing_annotations/candidates")
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successFetchCandidates(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                e = _state.sent();
                console.log("failed to fetch sourcing annotation candidates");
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
function putStatus(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/status"), {
                        method: "PUT",
                        body: JSON.stringify({
                            id: action.payload.id
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successChangeStatus(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* STATUS_SETTING */.JW);
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_STATUS_SETTING */.nW);
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(faildChangeStatus("failed to put status"))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function putContactPerson(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/contact_person"), {
                        method: "PUT",
                        body: JSON.stringify({
                            id: action.payload.id
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successChangeContactPerson(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* CONTACT_PERSON_SETTING */.s1);
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_CONTACT_PERSON_SETTING */.FE);
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(faildChangeContactPerson("failed to put contact person"))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function deleteStatus(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/status"), {
                        method: "DELETE"
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDeleteCompanyStatus(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* STATUS_SETTING */.JW);
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(faildDeleteCompanyStatus("failed to delete company status"))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function deleteContactPerson(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/company_contact_person"), {
                        method: "DELETE"
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDeleteCompanyContactPerson(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* CONTACT_PERSON_SETTING */.s1);
                return [
                    3,
                    5
                ];
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(faildDeleteCompanyContactPerson("failed to delete company status"))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function putMemo(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/pages/companies/".concat(action.payload.companyId, "/company_memo"), {
                        method: "PUT",
                        credentials: "include",
                        body: JSON.stringify({
                            content: action.payload.memo
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successUpdateCompanyMemo(action.payload))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: updateCompanyMemo failed", res.status);
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function putFirstInterviewDate(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/first_interview_date"), {
                        method: "PUT",
                        body: JSON.stringify({
                            firstInterviewDate: action.payload.firstInterviewDate
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successUpdateCompanyFirstInterviewDate(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_FIRST_INTERVIEW_DATE_SETTING */.OU);
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: updateCompanyFirstInterviewDate failed", res.status);
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function deleteFirstInterviewDate(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/companies/".concat(action.payload.companyId, "/first_interview_date"), {
                        method: "DELETE"
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDeleteCompanyFirstInterviewDate(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_FIRST_INTERVIEW_DATE_SETTING */.OU);
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: deleteCompanyFirstInterviewDate failed", res.status);
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function putCompanySourcingRoute(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/v1/companies/".concat(action.payload.companyId, "/sourcing_route"), {
                        method: "PUT",
                        body: JSON.stringify({
                            sourcingRouteId: action.payload.sourcingRouteId
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(sucessUpdateCompanySouringRoute(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_SOURCING_ROUTE_SETTING */.cY);
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: udpateCompanySouricngRoute");
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function deleteCompanySourcingRoute(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/v1/companies/".concat(action.payload.companyId, "/sourcing_route"), {
                        method: "DELETE"
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDetouchCompanySourcingRoute(action.payload))
                ];
            case 2:
                _state.sent();
                (0,tracking/* trackEvent */.L9)(action.payload.user, tracking/* SUM_OF_SOURCING_ROUTE_SETTING */.cY);
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: detouchCompanySouricngRoute");
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function postSourcingRoute(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/v1/sourcing_routes", {
                        method: "POST",
                        body: JSON.stringify({
                            sourcingRouteName: action.payload.sourcingRouteName
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                console.log("Error: createSouricngRoute");
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function putSourcingRoute(action) {
    var res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/v1/sourcing_routes/".concat(action.payload.id), {
                        method: "PUT",
                        body: JSON.stringify({
                            sourcingRouteName: action.payload.name
                        })
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                // 再検索せずに検索結果にソーシングルート名の変更を反映させる
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successUpdateSourcingRoute(action.payload))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                console.log("Error: putSourcingRoute");
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function deleteSourcingRouteRequest(action) {
    var res, ids;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(api/* callAPIRaw */.RH, "/api/v1/sourcing_routes/".concat(action.payload.id), {
                        method: "DELETE"
                    })
                ];
            case 1:
                res = _state.sent();
                if (!res.ok) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(refreshSourcingAnnotationCandidates())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(successDeleteSourcingRoute(action.payload))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.condition.sourcingRouteIds;
                    })
                ];
            case 4:
                ids = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitSourcingRoutesCondition(ids.filter(function(e) {
                        return e.id != action.payload.id;
                    })))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(sagas_fetchCompanies)
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 7:
                console.log("Error: deleteSourcingRoute");
                _state.label = 8;
            case 8:
                return [
                    2
                ];
        }
    });
}
function rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // Initialize state
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setCondition)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(fetchPermission)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(handleRequestSearch)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(handleChangeCondition)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(handleRequestDownload)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(sagas_fetchStatuses)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(fetchContactPerson)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(fetchContactPersonFilterList)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(fetchSourcingAnnotationCandidates)
                ];
            case 9:
                _state.sent();
                // yield fork(handleUrlChange)
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(FETCH_COMPANIES, sagas_fetchCompanies)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(CHANGE_STATUS, putStatus)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(CHANGE_CONTACT_PERSON, putContactPerson)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_COMPANY_STATUS, deleteStatus)
                ];
            case 13:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_COMPANY_CONTACT_PERSON, deleteContactPerson)
                ];
            case 14:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(UPDATE_COMPANY_MEMO, putMemo)
                ];
            case 15:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(UPDATE_COMPANY_FIRST_INTERVIEW_DATE, putFirstInterviewDate)
                ];
            case 16:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_COMPANY_FIRST_INTERVIEW_DATE, deleteFirstInterviewDate)
                ];
            case 17:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(CHANGE_SOURCING_ROUTE, putCompanySourcingRoute)
                ];
            case 18:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(CREATE_SOURCING_ROUTE, postSourcingRoute)
                ];
            case 19:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(UPDATE_SOURCING_ROUTE, putSourcingRoute)
                ];
            case 20:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_SOURCING_ROUTE, deleteSourcingRouteRequest)
                ];
            case 21:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(REFRESH_SOURCING_ANNOTATION_CANDIDATES, fetchSourcingAnnotationCandidates)
                ];
            case 22:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DETOUCH_COMPANY_SOURCING_ROUTE, deleteCompanySourcingRoute)
                ];
            case 23:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(ADD_COMPANY_MY_LABEL, putCompanyMyLabelRequest)
                ];
            case 24:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_COMPANY_MY_LABEL, deleteCompanyMyLabelRequest)
                ];
            case 25:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(CREATE_MY_LABEL, postMyLabel)
                ];
            case 26:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(UPDATE_MY_LABEL, putMyLabel)
                ];
            case 27:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(DELETE_MY_LABEL, execDeleteMyLabel)
                ];
            case 28:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./components/pages/companies/libs/params.ts






var buildRangeCondition = function(name, from, to) {
    if ((from === null || from === undefined) && (to === null || to === undefined)) {
        return {};
    }
    return (0,_define_property/* default */.Z)({}, name, {
        from: from,
        to: to
    });
};
var buildDateRangeCondition = function(name, from, to) {
    return buildRangeCondition(name, from, to);
};
var buildNumberRangeCondition = function(name, from, to) {
    return buildRangeCondition(name, Number(from) || null, Number(to) || null);
};
var buildSelectedConditions = function(rest) {
    return (0,utils/* fromEntries */.sq)(Object.entries(rest)// field名がおかしいものは除外
    .filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), name = _param[0];
        return constants_conditions/* CONDITION_ITEMS */.GO[name];
    })// valueがおかしいものも除外
    .filter(function(item) {
        return typeof item[1] === "string" && item[1] !== "";
    })// splitしたentityに変換
    .map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], value = _param[1];
        return [
            name,
            value.split(",")
        ];
    }));
};
// この関数ではあえてvalidateをしてない。
// validationはvalidate.tsに責務を移譲する
function paramsOf(query) {
    var obj = {};
    var totalFundingFrom = query.totalFundingFrom, totalFundingTo = query.totalFundingTo, valuationFrom = query.valuationFrom, valuationTo = query.valuationTo, employeesFrom = query.employeesFrom, employeesTo = query.employeesTo, establishedFrom = query.establishedFrom, establishedTo = query.establishedTo, ipoedFrom = query.ipoedFrom, ipoedTo = query.ipoedTo, lastFundraisedFrom = query.lastFundraisedFrom, lastFundraisedTo = query.lastFundraisedTo, rest = (0,_object_without_properties/* default */.Z)(query, [
        "totalFundingFrom",
        "totalFundingTo",
        "valuationFrom",
        "valuationTo",
        "employeesFrom",
        "employeesTo",
        "establishedFrom",
        "establishedTo",
        "ipoedFrom",
        "ipoedTo",
        "lastFundraisedFrom",
        "lastFundraisedTo"
    ]);
    obj = (0,_object_spread/* default */.Z)({}, obj, buildNumberRangeCondition("totalFunding", totalFundingFrom, totalFundingTo), buildNumberRangeCondition("valuation", valuationFrom, valuationTo), buildNumberRangeCondition("employees", employeesFrom, employeesTo), buildDateRangeCondition("established", establishedFrom, establishedTo), buildDateRangeCondition("ipoed", ipoedFrom, ipoedTo), buildDateRangeCondition("lastFundraised", lastFundraisedFrom, lastFundraisedTo), buildSelectedConditions(rest));
    return obj;
}

;// CONCATENATED MODULE: ./components/pages/companies/constants/orders.ts
var Orders = {
    ASC: "ASC",
    DESC: "DESC"
};
var SORTABLE_FIELD = {
    established: "established",
    ipoed: "ipoed",
    employees: "employees",
    lastFundraised: "lastFundraised",
    updated: "updated",
    created: "created",
    totalFunding: "totalFunding",
    valuation: "valuation",
    firstInterviewDate: "firstInterviewDate"
};
function isSortableField(field) {
    return Object.keys(SORTABLE_FIELD).includes(field);
}
function isSortingOrder(sort) {
    return !!Orders[sort];
}

;// CONCATENATED MODULE: ./components/pages/companies/components/pagination-button.tsx
// @flow



function PaginationButton(param) {
    var n = param.n, current = param.current, onClick = param.onClick;
    return n < 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: "splitter",
        children: "…"
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: n === current ? "is-active pl-pagination-item" : "pl-pagination-item",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            onClick: function() {
                return onClick(n);
            },
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;"),
            children: n
        })
    });
}

;// CONCATENATED MODULE: ./components/pages/companies/components/end-pagination-button.tsx





var noop = function() {};
function BasePaginationButton(param) {
    var current = param.current, left = param.left, disabled = param.disabled, onClick = param.onClick;
    var props = {
        className: left ? "pl-pagination-previous" : "pl-pagination-next",
        onClick: noop
    };
    var icon = left ? "icomoon icon-arrow1-left" : "icomoon icon-arrow1-right";
    if (disabled) {
        props.className += " is-disabled";
    } else {
        var diff = left ? -1 : 1;
        props.onClick = function() {
            return onClick(current + diff);
        };
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("cursor: pointer;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
            className: icon
        })
    }));
}
var LeftPaginationButton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasePaginationButton, (0,_object_spread/* default */.Z)({
        left: true
    }, props));
};
var RightPaginationButton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasePaginationButton, (0,_object_spread/* default */.Z)({
        left: false
    }, props));
};

;// CONCATENATED MODULE: ./components/pages/companies/components/pagination.tsx





function range(n) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var list = [];
    for(var i = start; i < start + n; i++)list.push(i);
    return list;
}
function insertSplitter(list) {
    var ret = (0,_to_consumable_array/* default */.Z)(list);
    for(var i = 0; i < ret.length - 1; i++){
        if (ret[i + 1] - ret[i] !== 1) {
            ret.splice(i + 1, 0, -1);
            i += 1;
        }
    }
    return ret;
}
var FIXED_COUNT = 2;
var MID_COUNT = 1;
var MAX_PAGE = 600;
function generatePageNumbers(page, totalPage) {
    var head = range(FIXED_COUNT);
    var mid = range(MID_COUNT * 2 + 1, page - MID_COUNT - 1);
    var foot = range(FIXED_COUNT, Math.min(totalPage, MAX_PAGE) - FIXED_COUNT);
    var list = (0,utils/* unique */.Tw)((0,_to_consumable_array/* default */.Z)(head).concat((0,_to_consumable_array/* default */.Z)(mid), (0,_to_consumable_array/* default */.Z)(foot))).filter(function(v) {
        return v >= 0 && v < Math.min(totalPage, MAX_PAGE);
    });
    return insertSplitter(list);
}
var Pagination = function(props) {
    var handleClick = function(page) {
        var offset = page * props.limit;
        if (props.offset === offset) return;
        props.onChange(offset, page);
    };
    var totalPage = Math.ceil(props.total / props.limit);
    var page = props.page;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "pl-pagination",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
            className: "pl-pagination-list",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftPaginationButton, {
                    current: page,
                    disabled: page === 1,
                    onClick: handleClick
                }, "l"),
                generatePageNumbers(page, totalPage).map(function(n, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaginationButton, {
                        n: n + 1,
                        current: page,
                        onClick: handleClick
                    }, "".concat(n, "-").concat(i));
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightPaginationButton, {
                    current: page,
                    disabled: page >= Math.min(totalPage, MAX_PAGE),
                    onClick: handleClick
                }, "r")
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/saga/history.ts













function parseQuery(locationSearch) {
    return query_string.parse(locationSearch, {
        arrayFormat: "index"
    });
}
function setKeywordCondition(keywords) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(typeof keywords === "string")) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(changeKeywords(keywords))
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2
                ];
        }
    });
}
// 関数にしてやらないと、yieldが使えなくてエラーになる・・・
function pageNumber(page) {
    var pageNumber = Number(page);
    if (pageNumber > MAX_PAGE) {
        pageNumber = 1;
    }
    return pageNumber;
}
function setPageCondition(page) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(typeof page === "string")) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setPage(pageNumber(page)))
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2
                ];
        }
    });
}
function setTagsCondition(tags) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(typeof tags === "string")) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setTags(tags))
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2
                ];
        }
    });
}
function addTagsToKeywordsCondition(tags) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(typeof tags === "string")) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(addTagsToKeywords(tags))
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2
                ];
        }
    });
}
//TODO 一旦引数の型指定でanyにしたが、できればanyはやめたい
function setPagerCondtion(param) {
    var sort, order, pager;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                sort = param.sort, order = param.order;
                pager = {
                    offset: 0,
                    // offset: isNaN(Number(offset)) ? undefined : Number(offset),
                    order: isSortingOrder(order) ? order : undefined,
                    sort: isSortableField(sort) ? sort : undefined
                };
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(syncSortOrder(pager))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setSelectedCondtion(selected) {
    var condition;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                condition = paramsOf(selected);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(syncSelectedCondition(condition))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
var paramsToColumns = function(fields) {
    if (!fields) {
        return [];
    }
    //TODO fieldsの型を指定したいので暫定的な対応
    if (Array.isArray(fields)) {
        return [];
    }
    return fields.split(",").filter(function(col) {
        return Object.keys(COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS).includes(col);
    });
};
function setColumns(fields) {
    var columns;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                columns = paramsToColumns(fields);
                if (!(columns.length > 0)) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(updateColumns(columns))
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2
                ];
        }
    });
}
function history_setStatus(fields) {
    var statusConditions;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!fields || Array.isArray(fields)) {
                    return [
                        2
                    ];
                }
                statusConditions = fields.split(",").map(function(s) {
                    return {
                        id: s
                    };
                });
                if (statusConditions.length < 1) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitStatusCondition(statusConditions))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setStatusUpdatedAt(from, to) {
    var ref, ref1, statusUpdatedCondition;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!from && !to || Array.isArray(from) || Array.isArray(to)) {
                    return [
                        2
                    ];
                }
                statusUpdatedCondition = {
                    from: (ref = from === null || from === void 0 ? void 0 : from.split("T")[0]) !== null && ref !== void 0 ? ref : null,
                    to: (ref1 = to === null || to === void 0 ? void 0 : to.split("T")[0]) !== null && ref1 !== void 0 ? ref1 : null
                };
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitStatusUpdatedAt(statusUpdatedCondition))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setFirstInterviewDate(from, to) {
    var ref, ref1, firstInterviewDateCondition;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!from && !to || Array.isArray(from) || Array.isArray(to)) {
                    return [
                        2
                    ];
                }
                firstInterviewDateCondition = {
                    from: (ref = from === null || from === void 0 ? void 0 : from.split("T")[0]) !== null && ref !== void 0 ? ref : null,
                    to: (ref1 = to === null || to === void 0 ? void 0 : to.split("T")[0]) !== null && ref1 !== void 0 ? ref1 : null
                };
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitFirstInterviewDate(firstInterviewDateCondition))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setContactPeople(fields) {
    var contactPersonConditions;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!fields || Array.isArray(fields)) {
                    return [
                        2
                    ];
                }
                contactPersonConditions = fields.split(",").map(function(s) {
                    return {
                        id: Number(s)
                    };
                });
                if (contactPersonConditions.length < 1) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitContactPersonCondition(contactPersonConditions))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setSourcingRoutes(fields) {
    var condition;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!fields || Array.isArray(fields)) return [
                    2
                ];
                condition = fields.split(",").map(function(it) {
                    return {
                        id: parseInt(it)
                    };
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitSourcingRoutesCondition(condition))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setMyLabels(fields) {
    var myLabels, condition;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!fields) return [
                    2
                ];
                myLabels = Array.isArray(fields) ? fields[0] : fields;
                condition = myLabels.split(",").map(function(it) {
                    return parseInt(it, 10);
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(setInitMyLabelCondition(condition))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
var isDefaultFields = function(fields) {
    return fields.trim() === initialColumns.join(",").trim();
};
// limit,offsetは利用しない（入力側でも防ぐが、下手に要素としても与えたくない）
// fieldsの値は変化がなければ共有URLから消してしまう（ここは要検討かも？）
var buildShareUrl = function(condition, column, statusCondition) {
    var _ref = buildCondintion(condition, column), fields = _ref.fields, limit = _ref.limit, offset = _ref.offset, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "fields",
        "limit",
        "offset"
    ]);
    var fieldNormalized = isDefaultFields(fields) ? {} : {
        fields: fields
    };
    var q = (0,_object_spread/* default */.Z)({}, rest, fieldNormalized);
    var statusQuery = buildStatusCondition(statusCondition);
    var statusQueryString = "";
    if (statusQuery) {
        var sq = query_string.stringify(statusQuery);
        statusQueryString = query_string.stringify(q) && sq !== "" ? "&".concat(sq) : sq;
    }
    var url = "";
    if (true) {
        // 画面描画が終わってからURLを取得する
        url = window.location.origin + window.location.pathname;
    }
    return "".concat(url, "?").concat(query_string.stringify(q)).concat(statusQueryString);
};
function setCondition() {
    var locationSearch, _ref, /*limit, offset,*/ sort, keywords, tags, order, fields, status, contactPerson, contactPeople, page, statusUpdatedFrom, statusUpdatedTo, firstInterviewDateFrom, firstInterviewDateTo, sourcingRouteIds, myLabelIds, selected, contactPersonIds;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                locationSearch = location.search;
                _ref = parseQuery(locationSearch), sort = _ref.sort, keywords = _ref.keywords, tags = _ref.tags, order = _ref.order, fields = _ref.fields, status = _ref.status, contactPerson = _ref.contactPerson, contactPeople = _ref.contactPeople, page = _ref.page, statusUpdatedFrom = _ref.statusUpdatedFrom, statusUpdatedTo = _ref.statusUpdatedTo, firstInterviewDateFrom = _ref.firstInterviewDateFrom, firstInterviewDateTo = _ref.firstInterviewDateTo, sourcingRouteIds = _ref.sourcingRouteIds, myLabelIds = _ref.myLabelIds, selected = (0,_object_without_properties/* default */.Z)(_ref, [
                    "sort",
                    "keywords",
                    "tags",
                    "order",
                    "fields",
                    "status",
                    "contactPerson",
                    "contactPeople",
                    "page",
                    "statusUpdatedFrom",
                    "statusUpdatedTo",
                    "firstInterviewDateFrom",
                    "firstInterviewDateTo",
                    "sourcingRouteIds",
                    "myLabelIds"
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setTagsCondition, tags)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setKeywordCondition, keywords)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(addTagsToKeywordsCondition, tags)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setPageCondition, page)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setSelectedCondtion, selected)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setPagerCondtion, {
                        sort: sort,
                        order: order
                    })
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setColumns, fields)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(history_setStatus, status)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setStatusUpdatedAt, statusUpdatedFrom, statusUpdatedTo)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setFirstInterviewDate, firstInterviewDateFrom, firstInterviewDateTo)
                ];
            case 10:
                _state.sent();
                contactPersonIds = contactPeople !== null && contactPeople !== void 0 ? contactPeople : contactPerson;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setContactPeople, contactPersonIds)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setSourcingRoutes, sourcingRouteIds)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(setMyLabels, myLabelIds)
                ];
            case 13:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(validateConditions)
                ];
            case 14:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./components/pages/companies/components/comma-separated-list.tsx




var omitWithEllipsis = function(a, length) {
    a = a !== null && a !== void 0 ? a : [];
    return a.length > length ? "".concat(a.splice(0, length).join(", "), "...") : a.join(", ");
};
var CommaSeparatedList = function(props) {
    var value = props.value;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: omitWithEllipsis(value, 3)
    }));
};
/* harmony default export */ var comma_separated_list = (CommaSeparatedList);

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/Memo.tsx




var Memo = function(param) {
    var text = param.text, shortName = param.shortName, onClickEdit = param.onClickEdit, disabled = param.disabled;
    var handleOnClick = function() {
        onClickEdit(shortName);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "memo-area",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:8px;margin-right:4px;white-space:normal;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;width:300px;line-height:150%;word-break:break-word;"),
                title: text,
                children: text
            }),
            !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                label: "メモを編集",
                id: "memo",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "edit-icon",
                    "data-for": "memo",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:20px;height:20px;margin-left:4px;margin-right:4px;display:block;visibility:hidden;:hover{background-color:rgba(0,0,0,0.08);border-radius:50%;}align-items:center;position:relative;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* ClickableIcomoonIcon */.E, {
                        name: "pen-fill",
                        onClick: handleOnClick,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;")
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/roundtype.ts
var roundtype = __webpack_require__(39250);
;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/DescriptionText.tsx



var DescriptionText = function(param) {
    var text = param.text, dataTestId = param.dataTestId;
    var ref, ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
        "data-test-id": dataTestId,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.description) === null || ref === void 0 ? void 0 : ref.width, "px;max-width:", (ref1 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.description) === null || ref1 === void 0 ? void 0 : ref1.width, "px;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:normal;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;width:100%;line-height:150%;word-break:break-word;"),
            title: text,
            children: text ? text : ""
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/TableCell.tsx




















var TableCell = function(param) {
    var name = param.name, data = param.data, columns = param.columns, condition = param.condition, statusCondition = param.statusCondition, selectedCompanyStatus = param.selectedCompanyStatus, setSelectedCompanyStatus = param.setSelectedCompanyStatus, selectedCompanyContactPerson = param.selectedCompanyContactPerson, setSelectedCompanyContactPerson = param.setSelectedCompanyContactPerson, selectedCompanyFirstInterviewDate = param.selectedCompanyFirstInterviewDate, setSelectedCompanyFirstInterviewDate = param.setSelectedCompanyFirstInterviewDate, onTriggerEditStatus = param.onTriggerEditStatus, isInhouse = param.isInhouse;
    var statusTargetRef = (0,react.useRef)(null);
    var contactPersonTargetRef = (0,react.useRef)(null);
    var firstInterviewDateRef = (0,react.useRef)(null);
    var totalFundingText = function(n) {
        return (0,utils/* formatNumber */.uf)(n) || "-";
    };
    var user = (0,AuthContext/* useUser */.a)();
    switch(name){
        case "name":
            var ref, ref1;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("// widthを使うと他のCSSで上書きされるため、min-widthとmax-widthを使う\n            min-width:", (ref = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref === void 0 ? void 0 : ref.width, "px;max-width:", (ref1 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref1 === void 0 ? void 0 : ref1.width, "px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    className: "name",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:8px;white-space:break-spaces;display:flex;justify-content:space-between;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            as: "/companies/".concat(data.companyId),
                            href: url/* COMPANY_HREF */.bP,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                decoration: "none",
                                onClick: function() {
                                    return sessionStorage.setItem("search_condition", JSON.stringify({
                                        url: buildShareUrl(condition, columns, statusCondition),
                                        y_offset: window.pageYOffset
                                    }));
                                },
                                children: data.name
                            })
                        }),
                        isInhouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                            label: "ステータスパネルを開く",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "panel-icon",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:20px;height:20px;display:flex;visibility:hidden;:hover{background-color:rgba(0,0,0,0.08);border-radius:50%;}justify-content:center;align-items:center;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* ClickableIcomoonIcon */.E, {
                                    name: "side-panel",
                                    onClick: function() {
                                        return onTriggerEditStatus(data.companyId);
                                    },
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.textLight */.O9.textLight, ";cursor:pointer;"),
                                    "data-test-id": "panel-icon"
                                })
                            })
                        })
                    ]
                })
            });
        case "description":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionText, {
                text: data[name],
                dataTestId: name
            });
        case "employees":
            var ref2, ref3;
            var value = data[name];
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                className: "text-right ".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref2 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref2 === void 0 ? void 0 : ref2.width, "px;max-width:", (ref3 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref3 === void 0 ? void 0 : ref3.width, "px;"),
                children: typeof value === "object" ? (0,utils/* formatRange */.nS)(value) : (0,utils/* formatNumber */.uf)(value)
            });
        case "ipoJikasougaku":
            var ref4, ref5;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                className: "text-right ".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref4 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref4 === void 0 ? void 0 : ref4.width, "px;max-width:", (ref5 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref5 === void 0 ? void 0 : ref5.width, "px;"),
                children: (0,utils/* formatNumber */.uf)(data[name])
            });
        case "valuation":
            var ref6, ref7;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("td", {
                "data-test-id": name,
                className: "text-right ".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref6 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref6 === void 0 ? void 0 : ref6.width, "px;max-width:", (ref7 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref7 === void 0 ? void 0 : ref7.width, "px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "sub-text",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#999;font-size:11px;"),
                        children: data["type"] === "IPO企業" && data[name] ? "IPO前最終調達時" : ""
                    }),
                    (0,utils/* formatNumber */.uf)(data[name])
                ]
            });
        case "totalFunding":
            var ref8, ref9;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                className: "text-right ".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref8 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref8 === void 0 ? void 0 : ref8.width, "px;max-width:", (ref9 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref9 === void 0 ? void 0 : ref9.width, "px;"),
                children: totalFundingText(data[name])
            });
        case "updated":
        case "created":
        case "lastValuationDate":
            var ref10, ref11;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref10 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref10 === void 0 ? void 0 : ref10.width, "px;max-width:", (ref11 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref11 === void 0 ? void 0 : ref11.width, "px;"),
                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                children: (0,utils/* formatDatetime */.DZ)(data[name])
            });
        case "tags":
            var ref12, ref13;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref12 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref12 === void 0 ? void 0 : ref12.width, "px;max-width:", (ref13 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref13 === void 0 ? void 0 : ref13.width, "px;"),
                children: data.tags.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                    className: "tag-list",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-wrap:nowrap;white-space:break-spaces;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:150%;"),
                        children: data.tags.slice(0, 6).map(function(tag, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                tag: tag
                            }, i);
                        })
                    })
                }) : null
            });
        case "shareholderStatus":
        case "origin":
        case "institute":
            var ref14, ref15;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref14 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref14 === void 0 ? void 0 : ref14.width, "px;max-width:", (ref15 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref15 === void 0 ? void 0 : ref15.width, "px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(comma_separated_list, {
                    value: data[name],
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:break-spaces;")
                })
            });
        case "type":
            var ref16, ref17;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref16 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref16 === void 0 ? void 0 : ref16.width, "px;max-width:", (ref17 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref17 === void 0 ? void 0 : ref17.width, "px;"),
                children: data[name] === "IPO企業" ? "IPO企業" : "未公開企業"
            });
        case "website":
            var ref18, ref19;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref18 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref18 === void 0 ? void 0 : ref18.width, "px;max-width:", (ref19 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref19 === void 0 ? void 0 : ref19.width, "px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    passHref: true,
                    href: data[name] != undefined ? data[name].toString() : "",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:normal;word-break:break-all;"),
                        decoration: "none",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: data[name]
                    })
                })
            });
        case "latestInitialSeries":
            var ref20, ref21;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref20 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref20 === void 0 ? void 0 : ref20.width, "px;max-width:", (ref21 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref21 === void 0 ? void 0 : ref21.width, "px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:150px;"),
                    children: data["type"] === "未公開企業" ? data[name] : ""
                })
            });
        case "cbLatestRoundType":
            var ref22, ref23;
            var cbLatestRoundType = data[name];
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref22 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref22 === void 0 ? void 0 : ref22.width, "px;max-width:", (ref23 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref23 === void 0 ? void 0 : ref23.width, "px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("line-height:1.5;word-break:break-word;white-space:normal;"),
                    children: cbLatestRoundType ? (0,roundtype/* formatLastFundingType */.e)(cbLatestRoundType) : ""
                })
            });
        case "investingStatus":
            var ref24, ref25;
            var status = data[name];
            if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                className: isInhouse ? "" : "disabled",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref24 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref24 === void 0 ? void 0 : ref24.width, "px;max-width:", (ref25 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref25 === void 0 ? void 0 : ref25.width, "px;&:hover{cursor:pointer;&::before{border-right:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);}}&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;position:absolute;left:0;top:0;pointer-events:none;}&.disabled{cursor:not-allowed;opacity:0.3;}position:relative;"),
                ref: statusTargetRef,
                onClick: function() {
                    if (!isInhouse) {
                        return;
                    }
                    selectedCompanyStatus != null ? setSelectedCompanyStatus(null) : setSelectedCompanyStatus({
                        companyId: data.companyId,
                        selectedStatusName: status,
                        target: statusTargetRef.current
                    });
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-break:break-all;white-space:break-spaces;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:150%;"),
                            children: data[name]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;display:block;"),
                            name: "arrow1-down"
                        })
                    ]
                })
            });
        case "contactPerson":
            var ref26, ref27;
            if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
                return null;
            }
            var contactPerson = data[name];
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                className: isInhouse ? "" : "disabled",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref26 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref26 === void 0 ? void 0 : ref26.width, "px;max-width:", (ref27 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref27 === void 0 ? void 0 : ref27.width, "px;&:hover{cursor:pointer;&::before{border-right:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);}}&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;position:absolute;left:0;top:0;pointer-events:none;}&.disabled{cursor:not-allowed;opacity:0.3;}position:relative;"),
                ref: contactPersonTargetRef,
                onClick: function() {
                    if (!isInhouse) {
                        return;
                    } else {
                        selectedCompanyContactPerson != null ? setSelectedCompanyContactPerson(null) : setSelectedCompanyContactPerson({
                            companyId: data.companyId,
                            selectedContactPersonFirstName: contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.firstName,
                            selectedContactPersonLastName: contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.lastName,
                            target: contactPersonTargetRef.current
                        });
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:break-spaces;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;"),
                            children: contactPerson && "".concat(contactPerson.lastName, " ").concat(contactPerson.firstName)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;display:block;"),
                            name: "arrow1-down"
                        })
                    ]
                })
            });
        case "investingStatusUpdated":
            var ref28, ref29;
            if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref28 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref28 === void 0 ? void 0 : ref28.width, "px;max-width:", (ref29 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref29 === void 0 ? void 0 : ref29.width, "px;&.disabled{cursor:not-allowed;opacity:0.3;}"),
                className: "".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y, " ").concat(isInhouse ? "" : "disabled"),
                children: (0,date/* convertToJst */.N6)(data[name])
            });
        case "memo":
            if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
                return null;
            } else {
                var ref30, ref31, ref32;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    "data-test-id": name,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref30 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.memo) === null || ref30 === void 0 ? void 0 : ref30.width, "px;max-width:", (ref31 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.memo) === null || ref31 === void 0 ? void 0 : ref31.width, "px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Memo, {
                        text: (ref32 = data[name]) === null || ref32 === void 0 ? void 0 : ref32.content,
                        shortName: data.companyId,
                        onClickEdit: onTriggerEditStatus,
                        disabled: !isInhouse
                    })
                });
            }
        case "firstInterviewDate":
            var ref33, ref34;
            if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
                return null;
            }
            var firstInterviewDate = data[name];
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref33 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref33 === void 0 ? void 0 : ref33.width, "px;max-width:", (ref34 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref34 === void 0 ? void 0 : ref34.width, "px;&:hover{cursor:pointer;&::before{border-right:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);}}&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;position:absolute;left:0;top:0;pointer-events:none;}&.disabled{cursor:not-allowed;opacity:0.3;}position:relative;"),
                className: "".concat(wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y, " ").concat(isInhouse ? "" : "disabled"),
                ref: firstInterviewDateRef,
                onClick: function() {
                    if (!isInhouse) return;
                    selectedCompanyFirstInterviewDate != null ? setSelectedCompanyFirstInterviewDate(null) : setSelectedCompanyFirstInterviewDate({
                        shortName: data.companyId,
                        selectedFirstInterviewDate: firstInterviewDate ? new Date(firstInterviewDate) : new Date(),
                        target: firstInterviewDateRef.current
                    });
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:break-spaces;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;"),
                            children: (0,date/* convertToJst */.N6)(data[name])
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;display:block;"),
                            name: "arrow1-down"
                        })
                    ]
                })
            });
        case "sourcingRoute":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
        case "myLabels":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
        default:
            var ref35, ref36;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                "data-test-id": name,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", (ref35 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref35 === void 0 ? void 0 : ref35.width, "px;max-width:", (ref36 = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name]) === null || ref36 === void 0 ? void 0 : ref36.width, "px;white-space:break-spaces;"),
                children: data[name]
            });
    }
};

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/Header.tsx




var Header = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("th", {
        className: props.right ? "text-right" : undefined,
        style: props.style,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-bottom:1px solid ", dist/* colors.border */.O9.border, ";display:table-cell;height:40px;padding:2px 8px;position:relative;color:", dist/* colors.textStrong */.O9.textStrong, ";font-size:12px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";text-align:left;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: props.children
            }),
            props.extra
        ]
    });
};

// EXTERNAL MODULE: ./components/common/Help.tsx
var Help = __webpack_require__(33869);
;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/HelpHeader.tsx





var HelpHeader = function(props) {
    var helpElement = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray90 */.O9.gray90, ";vertical-align:middle;"),
            children: props.helpText
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        style: props.style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-flex;align-items:center;column-gap:4px;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "u-mr10",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;white-space:pre-wrap;line-height:1.25;"),
                    children: props.label
                }),
                props.link ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    className: "help-icon",
                    href: props.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:inherit;"),
                    children: helpElement()
                }) : helpElement()
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/SortableHeader.tsx





var SortableHeader = function(props) {
    var name = props.name;
    var state = props.sorting;
    var onToggle = props.onToggle;
    var iconClass = function(param, name) {
        var sort = param.sort, order = param.order;
        if (sort === name) {
            return order === "ASC" ? "icomoon icon-arrow8-up selected" : "icomoon icon-arrow8-down selected";
        } else {
            return "icomoon icon-sort-fill";
        }
    };
    // todo:初回面談日のソートが実装できるまではソート用カラム特有の要素を削除しておく
    var icon = props.name === "firstInterviewDate" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;padding:5px 7px;color:#999;cursor:pointer;font-size:1rem;position:absolute;margin:0;top:10px;right:6px;vertical-align:middle;border-radius:50%;padding-left:6px;padding-right:6px;transition:0.15s;&:hover{background-color:#d9d9d9;color:", dist/* colors.gray90 */.O9.gray90, ";}& > i.selected{color:", dist/* colors.cyan50 */.O9.cyan50, ";}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
            className: iconClass(state, name),
            onClick: function() {
                return onToggle(name);
            }
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        right: props.right,
        extra: icon,
        style: {
            width: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].width
        },
        children: props.children
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/molucule/TableHeader.tsx












var TableHeader = function(_param) {
    var name = _param.name, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name"
    ]);
    var style = {
        width: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].width
    };
    var user = (0,AuthContext/* useUser */.a)();
    switch(name){
        case "established":
        case "ipoed":
        case "employees":
        case "lastFundraised":
        case "updated":
        case "created":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortableHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: name,
                style: style
            }, rest), {
                children: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label
            }));
        case "totalFunding":
        case "valuation":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortableHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: name,
                style: style
            }, rest), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:80%;text-align:center;"),
                    children: [
                        COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "sub-text",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";"),
                            children: "（百万円）"
                        })
                    ]
                })
            }));
        case "ipoCategory":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "日本国内スタートアップにおけるIPO企業の株主、上場市場による分類",
                style: style
            });
        case "ipoJikasougaku":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                style: style,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:80%;text-align:center;"),
                    children: [
                        COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "sub-text",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";"),
                            children: "（百万円）"
                        })
                    ]
                })
            });
        case "market":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "日本国内スタートアップにおけるIPO時の上場市場",
                style: style
            });
        case "latestInitialSeries":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "スピーダが独自に定義する成長フェーズ",
                style: style,
                link: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA"
            });
        case "cbLatestRoundType":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "定義を見る",
                style: style,
                link: "https://help.initial.inc/ja/articles/5489432"
            });
        case "corporateNumber":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "日本の国税庁が法人に対して発行した識別番号",
                style: style
            });
        case "investingStatus":
        case "contactPerson":
        case "investingStatusUpdated":
        case "memo":
            return (0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                style: style,
                children: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label
            }) : null;
        case "firstInterviewDate":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SortableHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: name,
                style: style
            }, rest), {
                children: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label
            }));
        case "sourcingRoute":
        case "myLabels":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                style: style,
                children: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label
            });
        case "researchStatus":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpHeader, {
                label: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label,
                helpText: "日本国内スタートアップにおける調査状況",
                style: style
            });
        default:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                style: style,
                children: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label
            });
    }
};

// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/index.mjs + 16 modules
var simplebar_react_dist = __webpack_require__(49989);
// EXTERNAL MODULE: ./components/header/AppBar.tsx + 16 modules
var AppBar = __webpack_require__(22991);
// EXTERNAL MODULE: ./components/pages/companies/components/tableCell/MyLabelDropdown.tsx + 1 modules
var MyLabelDropdown = __webpack_require__(95397);
// EXTERNAL MODULE: ./node_modules/html-sloppy-escaper/esm/index.js + 1 modules
var esm = __webpack_require__(55458);
// EXTERNAL MODULE: ./components/pages/companies/components/atom/MyLabelItem.tsx
var MyLabelItem = __webpack_require__(26447);
;// CONCATENATED MODULE: ./components/pages/companies/components/tableCell/MyLabelCell.tsx












var myLabelWidth = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.myLabels.width;
var MyLabelCell = function(param) {
    var candidates = param.candidates, myLabels = param.myLabels, position = param.position, onSelectMyLabel = param.onSelectMyLabel, onDeselectMyLabel = param.onDeselectMyLabel, onRequestEditModal = param.onRequestEditModal, disabled = param.disabled;
    var ref = (0,react.useState)(false), isOpenDropdown = ref[0], setIsOpenDropdown = ref[1];
    var cellRef = (0,react.useRef)(null);
    var handleOnClickCell = function() {
        if (disabled) return;
        setIsOpenDropdown(true);
    };
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        cellRef
    ], function() {
        if (isOpenDropdown) {
            setIsOpenDropdown(!isOpenDropdown);
        }
    });
    var user = (0,AuthContext/* useUser */.a)();
    var dropdownMaxHeight = 300;
    var dropdownHeight = Math.min(candidates.length * 25 + 40, dropdownMaxHeight);
    var dropdownTop = undefined;
    if (position) {
        var restRowsHeight = (position.rowCount - position.rowIndex) * position.rowHeight;
        var restTableHeight = position.minTableHeight - (position.rowIndex + 1) * position.rowHeight;
        var restHeight = Math.max(restRowsHeight, restTableHeight);
        if (restHeight < dropdownHeight) {
            dropdownTop = restHeight - dropdownHeight;
        }
    }
    if (!(0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user)) {
        return null;
    }
    var myLabelIds = myLabels.map(function(it) {
        return it.id;
    });
    var selectedMyLabels = candidates.filter(function(myLabel) {
        return myLabelIds.includes(myLabel.id);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("td", {
        ref: cellRef,
        "data-test-id": "myLabel",
        onClick: handleOnClickCell,
        className: disabled ? "disabled" : "",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", myLabelWidth, "px;max-width:", myLabelWidth, "px;white-space:break-spaces;&:hover{cursor:pointer;&::before{border-right:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);}}&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;position:absolute;left:0;top:0;pointer-events:none;}&.disabled{cursor:not-allowed;opacity:0.3;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelTooltip, {
                        myLabels: selectedMyLabels,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0;margin:0;white-space:break-spaces;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;> li{margin-right:4px;}"),
                            children: selectedMyLabels.map(function(myLabel) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelItem/* MyLabelItem */.U, {
                                    myLabel: myLabel,
                                    maxWidth: "".concat(myLabelWidth * 0.85, "px")
                                }, myLabel.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;display:block;"),
                        name: "arrow1-down"
                    })
                ]
            }),
            isOpenDropdown ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelDropdown/* MyLabelDropdown */.u, {
                candidates: candidates,
                selectedMyLabelIds: myLabels.map(function(myLabel) {
                    return myLabel.id;
                }),
                maxHeight: dropdownMaxHeight,
                position: {
                    top: dropdownTop,
                    left: 8
                },
                onSelectMyLabel: onSelectMyLabel,
                onDeselectMyLabel: onDeselectMyLabel,
                onRequestEditModal: onRequestEditModal
            }) : null
        ]
    });
};
var MyLabelTooltip = function(param) {
    var myLabels = param.myLabels, children = param.children;
    var label = myLabels.map(function(it) {
        return it.name;
    }).map(esm/* escape */.Y).join("<br>");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
        label: label,
        "data-html": true,
        children: children
    });
};

// EXTERNAL MODULE: ./components/pages/companies/components/tableCell/SourcingRouteDropdown.tsx
var SourcingRouteDropdown = __webpack_require__(38850);
;// CONCATENATED MODULE: ./components/pages/companies/components/tableCell/SourcingRouteCell.tsx







var sourcingRouteWidth = COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.sourcingRoute.width;
var SourcingRouteCell = function(param) {
    var candidates = param.candidates, selected = param.selected, position = param.position, onSelect = param.onSelect, onDeselect = param.onDeselect, onRequestEditModal = param.onRequestEditModal, disabled = param.disabled;
    var ref = (0,react.useState)(false), isOpenDropdown = ref[0], setIsOpenDropdown = ref[1];
    var cellRef = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        cellRef
    ], function() {
        if (isOpenDropdown) {
            setIsOpenDropdown(!isOpenDropdown);
        }
    });
    var handleClick = (0,react.useCallback)(function() {
        if (disabled) return;
        setIsOpenDropdown(!isOpenDropdown);
    }, [
        isOpenDropdown
    ]);
    var dropdownMaxHeight = 300;
    var dropdownHeight = Math.min(candidates.length * 40 + 40, dropdownMaxHeight);
    var dropdownTop = undefined;
    if (position) {
        var restRowsHeight = (position.rowCount - position.rowIndex) * position.rowHeight;
        var restTableHeight = position.minTableHeight - (position.rowIndex + 1) * position.rowHeight;
        var restHeight = Math.max(restRowsHeight, restTableHeight);
        if (restHeight < dropdownHeight) {
            dropdownTop = restHeight - dropdownHeight;
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("td", {
        "data-test-id": "sourcingRoute",
        ref: cellRef,
        className: disabled ? "disabled" : "",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:", sourcingRouteWidth, "px;max-width:", sourcingRouteWidth, "px;&:hover{cursor:pointer;&::before{border-right:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);}}&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;position:absolute;left:0;top:0;pointer-events:none;}&.disabled{cursor:not-allowed;opacity:0.3;}position:relative;"),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-break:break-all;white-space:break-spaces;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:150%;"),
                        children: selected === null || selected === void 0 ? void 0 : selected.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:10px;display:block;"),
                        name: "arrow1-down"
                    })
                ]
            }),
            isOpenDropdown ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingRouteDropdown/* SourcingRouteDropdown */.B, {
                sourcingRoutes: candidates,
                selectedSourcingRouteId: selected === null || selected === void 0 ? void 0 : selected.id,
                maxHeight: dropdownMaxHeight,
                position: {
                    top: dropdownTop,
                    left: 8
                },
                onSelectSourcingRoute: function(id, name) {
                    return onSelect({
                        id: id
                    }, name);
                },
                onDeselectSourcingRoute: function() {
                    return onDeselect();
                },
                onRequestEditSourcingRouteModal: onRequestEditModal
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/result-table.tsx


function result_table_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  height: ",
        "px;\n                  td {\n                    padding: 8px 8px;\n                    display: table-cell;\n                    position: relative;\n                    font-size: 14px;\n                    line-height: 1.2;\n                    border-bottom: 1px solid #d9d9d9;\n                  }\n                  .text-right {\n                    text-align: right;\n                  }\n                  ",
        "\n                  &:hover {\n                    ",
        "\n                  }\n                  :hover span.edit-icon,\n                  :hover span.panel-icon {\n                    visibility: visible;\n                  }\n                "
    ]);
    result_table_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ResultTable = function(props) {
    var rowHeight = 80;
    var minTableHeight = 400;
    var scrollRef = useCalculateFixedElementPosition(props.companies);
    (0,react.useEffect)(function() {
        var searchCondition = JSON.parse(sessionStorage.getItem("search_condition"));
        var yOffset = searchCondition === null || searchCondition === void 0 ? void 0 : searchCondition.y_offset;
        if (yOffset) {
            window.scrollTo(0, Number(yOffset));
        }
    }, []);
    var handleOnSelectMyLabel = function(myLabelId, companyId) {
        props.onSelectMyLabel(myLabelId, companyId);
    };
    var handleOnDeselectMyLabel = function(myLabelId, companyId) {
        props.onDeselectMyLabel(myLabelId, companyId);
    };
    var isInhouse = function(company) {
        return company["companyId"].startsWith("A-");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("#horizontal-scroll-bar{.simplebar-track{bottom:0;position:fixed;}.simplebar-scrollbar::before{background-color:", dist/* colors.gray90 */.O9.gray90, ";transition:none;opacity:0.8;}}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(simplebar_react_dist/* default */.Z, {
            id: "horizontal-scroll-bar",
            scrollableNodeProps: {
                ref: scrollRef
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                className: "result-table",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.white00 */.O9.white00, ";border-top:1px solid #d9d9d9;white-space:nowrap;border-collapse:collapse;width:100%;table-layout:fixed;"),
                ref: scrollRef,
                "data-test-id": "result-table",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        id: "result-table-header",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";color:", dist/* colors.black30 */.O9.black30, ";z-index:999;width:max-content;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:48px;"),
                            children: props.columns.setting.map(function(col, i) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableHeader, (0,_object_spread/* default */.Z)({
                                    name: col
                                }, props), "".concat(i, "-").concat(col));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        "data-test-id": "body",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:48px;display:block;min-height:", minTableHeight, "px;"),
                        children: props.companies.map(function(row, rowIndex) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(result_table_templateObject(), rowHeight, props.selectedCompanyShortname === row.companyId && "background: ".concat(dist/* colors.cyan10 */.O9.cyan10, ";"), props.selectedCompanyShortname !== row.companyId && "background: rgba(0, 0, 0, 0.03);"),
                                "data-test-id": "row",
                                children: props.columns.setting.map(function(col, colIndex) {
                                    switch(col){
                                        case "myLabels":
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyLabelCell, {
                                                position: {
                                                    rowIndex: rowIndex,
                                                    rowCount: props.companies.length,
                                                    rowHeight: rowHeight,
                                                    minTableHeight: minTableHeight
                                                },
                                                myLabels: row.myLabels,
                                                candidates: props.candidates.myLabels,
                                                onSelectMyLabel: function(myLabelId) {
                                                    return handleOnSelectMyLabel(myLabelId, row.companyId);
                                                },
                                                onDeselectMyLabel: function(myLabelId) {
                                                    return handleOnDeselectMyLabel(myLabelId, row.companyId);
                                                },
                                                onRequestEditModal: props.onRequestEditMyLabelModal,
                                                disabled: !isInhouse(row)
                                            }, "".concat(colIndex, "-").concat(col));
                                        case "sourcingRoute":
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingRouteCell, {
                                                position: {
                                                    rowIndex: rowIndex,
                                                    rowCount: props.companies.length,
                                                    rowHeight: rowHeight,
                                                    minTableHeight: minTableHeight
                                                },
                                                selected: row.sourcingRoute,
                                                candidates: props.candidates.sourcingRoutes,
                                                onSelect: function(id, name) {
                                                    return props.onSelectSourcingRoute(row.companyId, id, name);
                                                },
                                                onDeselect: function() {
                                                    return props.onDeselectSourcingRoute(row.companyId);
                                                },
                                                onRequestEditModal: props.onRequestEditSourcingRouteModal,
                                                disabled: !isInhouse(row)
                                            }, "".concat(colIndex, "-").concat(col));
                                        default:
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableCell, {
                                                "data-test-id": col,
                                                name: col,
                                                data: row,
                                                columns: props.columns,
                                                condition: props.condition,
                                                statusCondition: props.statusCondition,
                                                selectedCompanyStatus: props.selectedCompanyStatus,
                                                selectedCompanyContactPerson: props.selectedCompanyContactPerson,
                                                selectedCompanyFirstInterviewDate: props.selectedCompanyFirstInterviewDate,
                                                setSelectedCompanyStatus: props.setSelectedCompanyStatus,
                                                setSelectedCompanyContactPerson: props.setSelectedCompanyContactPerson,
                                                setSelectedCompanyFirstInterviewDate: props.setSelectedCompanyFirstInterviewDate,
                                                onTriggerEditStatus: props.onTriggerEditStatus,
                                                isInhouse: isInhouse(row)
                                            }, "".concat(colIndex, "-").concat(col));
                                    }
                                })
                            }, "".concat(rowIndex, "-").concat(row.companyId));
                        })
                    })
                ]
            })
        })
    });
};
var useCalculateFixedElementPosition = function(companies) {
    var scrollRef = (0,react.useRef)(null);
    var calculateScrollBarPosition = useCalculateHorizontalScrollBarPosition(scrollRef);
    var calculateTableHeaderPosition = useCalculateScrollTableHeader(scrollRef);
    var calculateFixedElementPosition = (0,react.useCallback)(function() {
        calculateTableHeaderPosition();
        calculateScrollBarPosition();
    }, [
        calculateScrollBarPosition,
        calculateTableHeaderPosition
    ]);
    (0,react.useEffect)(function() {
        calculateFixedElementPosition() // NOTE: 初回描画時にスクロールバーの位置を調整するため
        ;
        window.addEventListener("scroll", calculateFixedElementPosition);
        return function() {
            window.removeEventListener("scroll", calculateFixedElementPosition);
        };
    }, [
        calculateFixedElementPosition
    ]);
    (0,react.useEffect)(function() {
        calculateFixedElementPosition() // NOTE: 会社数が変わる際にスクロールバーの位置を調整するため
        ;
    }, [
        companies,
        calculateFixedElementPosition
    ]);
    return scrollRef;
};
var useCalculateHorizontalScrollBarPosition = function(scrollRef) {
    var horizontalScrollBarRef = (0,react.useRef)(null);
    var calculateScrollBarPosition = (0,react.useCallback)(function() {
        if (!horizontalScrollBarRef.current) {
            horizontalScrollBarRef.current = document.querySelector("#horizontal-scroll-bar .simplebar-track");
        }
        if (!scrollRef.current) return;
        var elementRect = scrollRef.current.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var InViewPort = elementRect.bottom >= 0 && elementRect.bottom <= viewportHeight;
        if (InViewPort && horizontalScrollBarRef.current) {
            horizontalScrollBarRef.current.style.position = "absolute";
        } else if (!InViewPort && horizontalScrollBarRef.current) {
            horizontalScrollBarRef.current.style.position = "fixed";
        }
    }, [
        scrollRef
    ]);
    return calculateScrollBarPosition;
};
var useCalculateScrollTableHeader = function(scrollRef) {
    var tableHeaderRef = (0,react.useRef)(null);
    var scrollTableHeader = (0,react.useCallback)(function() {
        if (!tableHeaderRef.current || !scrollRef.current) return;
        tableHeaderRef.current.style.left = -scrollRef.current.scrollLeft + "px";
    }, [
        scrollRef
    ]);
    var calculateTableHeaderPosition = (0,react.useCallback)(function() {
        if (!tableHeaderRef.current) {
            tableHeaderRef.current = document.querySelector("#result-table-header");
        }
        if (!scrollRef.current) return;
        var elementRect = scrollRef.current.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var InViewPort = elementRect.top >= parseInt(AppBar/* APPBAR_HEIGHT */.sU) && elementRect.top <= viewportHeight;
        if (InViewPort && tableHeaderRef.current) {
            tableHeaderRef.current.style.position = "absolute";
            tableHeaderRef.current.style.top = "0";
            tableHeaderRef.current.style.left = "0";
            scrollRef.current.removeEventListener("scroll", scrollTableHeader);
        } else if (!InViewPort && tableHeaderRef.current) {
            var ref;
            tableHeaderRef.current.style.position = "fixed";
            tableHeaderRef.current.style.top = AppBar/* APPBAR_HEIGHT */.sU;
            tableHeaderRef.current.style.left = -scrollRef.current.scrollLeft + "px";
            (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", scrollTableHeader);
        }
    }, [
        scrollRef,
        scrollTableHeader
    ]);
    (0,react.useEffect)(function() {
        var ref;
        (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", scrollTableHeader);
        return function() {
            var ref;
            (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", scrollTableHeader);
        };
    }, [
        scrollRef,
        scrollTableHeader
    ]);
    return calculateTableHeaderPosition;
};

// EXTERNAL MODULE: ./components/atoms/LoadingOverlay.tsx
var LoadingOverlay = __webpack_require__(82786);
;// CONCATENATED MODULE: ./components/pages/companies/components/download-button.tsx





var DownloadButton = function(param) {
    var resultCount = param.resultCount, downloadLimit = param.downloadLimit, isLoading = param.isLoading, allowed = param.allowed, enterprise = param.enterprise, restricted = param.restricted, onClick = param.onClick;
    var zero = resultCount === 0;
    var over = resultCount > downloadLimit;
    var tooltipText = !enterprise ? "こちらの機能は本契約ユーザの方のみ利用可能となっています" : !allowed ? "こちらの機能は現在のプランではご利用いただけません。お問い合わせ: https://initial.inc/contact" : restricted ? "大量のダウンロードが検出されたので、機能を制限しております。お問い合わせ: https://initial.inc/contact" : over ? "先頭".concat(downloadLimit, "件のみダウンロードされます") : zero ? "検索結果が0件の場合はダウンロードできません" : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderButton, {
        disabled: !enterprise || !allowed || zero || restricted,
        isLoading: isLoading,
        tooltip: tooltipText,
        label: "ダウンロード",
        onClick: function() {
            return onClick();
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
            name: "download",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:4px;vertical-align:middle;font-size:20px;color:", dist/* colors.black10 */.O9.black10, ";")
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/components/company-statuses-option-drop-down.tsx

function company_statuses_option_drop_down_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            max-width: 320px;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n          "
    ]);
    company_statuses_option_drop_down_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CompanyStatusesOptionDropDown = function(param) {
    var selectedCompanyStatus = param.selectedCompanyStatus, setSelectedCompanyStatus = param.setSelectedCompanyStatus, statuses = param.statuses, onSelectStatusBlank = param.onSelectStatusBlank, onSelectStatus = param.onSelectStatus;
    var user = (0,AuthContext/* useUser */.a)();
    var statusSettingLink = function() {
        window.open(url/* statusSettingPath */.Uk, "_blank");
    };
    return selectedCompanyStatus != null ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionDropdown/* OptionDropdown */.b, {
        _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;max-height:320px;overflow-y:auto;top:", selectedCompanyStatus.target && selectedCompanyStatus.target.getBoundingClientRect().top + window.pageYOffset + 37, "px;left:", selectedCompanyStatus.target && selectedCompanyStatus.target.getBoundingClientRect().left + window.pageXOffset, "px;"),
        open: true,
        hideTopArrow: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                label: "（空白）",
                condition: selectedCompanyStatus.selectedStatusName == null,
                idx: 0,
                handleSet: function() {
                    onSelectStatusBlank(selectedCompanyStatus.companyId, user);
                    setSelectedCompanyStatus(null);
                }
            }),
            statuses.map(function(s, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                    condition: s.name === selectedCompanyStatus.selectedStatusName,
                    idx: idx,
                    handleSet: function() {
                        onSelectStatus(s.id, selectedCompanyStatus.companyId, s.name, user);
                        setSelectedCompanyStatus(null);
                    },
                    label: s.name,
                    _css: (0,emotion_react_browser_esm/* css */.iv)(company_statuses_option_drop_down_templateObject())
                }, s.id);
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                condition: true,
                idx: 0,
                handleSet: statusSettingLink,
                label: "ステータス項目を編集",
                icon: "icon-pen-fill",
                iconCss: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";")
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./components/pages/companies/components/company-contact-persons-option-drop-down.tsx





var CompanyContactPersonsOptionDropDown = function(param) {
    var selectedCompanyContactPerson = param.selectedCompanyContactPerson, setSelectedCompanyContactPerson = param.setSelectedCompanyContactPerson, contactPersons = param.contactPersons, onSelectContactPersonBlank = param.onSelectContactPersonBlank, onSelectContactPerson = param.onSelectContactPerson;
    var user = (0,AuthContext/* useUser */.a)();
    return selectedCompanyContactPerson != null ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionDropdown/* OptionDropdown */.b, {
        _css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;max-height:280px;overflow-y:auto;top:", selectedCompanyContactPerson.target && selectedCompanyContactPerson.target.getBoundingClientRect().top + window.pageYOffset + 37, "px;left:", selectedCompanyContactPerson.target && selectedCompanyContactPerson.target.getBoundingClientRect().left + window.pageXOffset, "px;"),
        open: true,
        hideTopArrow: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                label: "（空白）",
                condition: selectedCompanyContactPerson.selectedContactPersonFirstName == null && selectedCompanyContactPerson.selectedContactPersonLastName == null,
                idx: 0,
                handleSet: function() {
                    onSelectContactPersonBlank(selectedCompanyContactPerson.companyId, user);
                    setSelectedCompanyContactPerson(null);
                }
            }),
            contactPersons.map(// TODO: name ではなく id で突き合わせる
            function(p) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionDropdownItem/* OptionDropdownItem */.$, {
                    condition: p.firstName === selectedCompanyContactPerson.selectedContactPersonFirstName && p.lastName === selectedCompanyContactPerson.selectedContactPersonLastName,
                    idx: 0,
                    handleSet: function() {
                        onSelectContactPerson(p.id, selectedCompanyContactPerson.companyId, p.firstName, p.lastName, user);
                        setSelectedCompanyContactPerson(null);
                    },
                    label: "".concat(p.lastName, " ").concat(p.firstName)
                }, p.id);
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
};

// EXTERNAL MODULE: ./node_modules/react-clipboard.js/dist/react-clipboard.js
var react_clipboard = __webpack_require__(36964);
var react_clipboard_default = /*#__PURE__*/__webpack_require__.n(react_clipboard);
;// CONCATENATED MODULE: ./components/pages/companies/components/share/share-url.tsx








var ShareUrl = function(param) {
    var url = param.url;
    var ref = (0,react.useState)(false), copySucceed = ref[0], setCopySucceed = ref[1];
    var handleSuccess = function() {
        setCopySucceed(true);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_clipboard_default()), {
                component: "button",
                "data-clipboard-text": url,
                onSuccess: handleSuccess,
                className: "copy-url",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:transparent;border:none;padding:0;margin:0;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderButton, {
                    isLoading: false,
                    tooltip: "このフィルタ設定のリンクをコピー",
                    disabled: false,
                    label: "リンクコピー",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "link",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-right:4px;vertical-align:middle;font-size:20px;color:", dist/* colors.black10 */.O9.black10, ";")
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Snackbar, {
                isShow: copySucceed,
                setIsShow: setCopySucceed,
                text: "リンクをコピーしました"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/companies/containers/share-url.tsx



var share_url_mapStateToProps = function(state) {
    return {
        url: buildShareUrl(state.condition, state.column, state.statusCondition)
    };
};
var share_url_ShareUrl = (0,es/* connect */.$j)(share_url_mapStateToProps)(ShareUrl);

// EXTERNAL MODULE: ./components/pages/companies/components/molucule/SourcingAnnotationPanel.tsx + 8 modules
var SourcingAnnotationPanel = __webpack_require__(78650);
// EXTERNAL MODULE: ./components/pages/companies/components/company-firstInterview-date-calender.tsx
var company_firstInterview_date_calender = __webpack_require__(37280);
// EXTERNAL MODULE: ./components/pages/companies/components/SourcingAnnotationCandidateEditModal.tsx + 1 modules
var SourcingAnnotationCandidateEditModal = __webpack_require__(73153);
;// CONCATENATED MODULE: ./components/pages/companies/containers/search-result.tsx



























var SearchResult = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(null), selectedCompanyStatus = ref[0], setSelectedCompanyStatus = ref[1];
    var ref1 = (0,react.useState)(null), selectedCompanyContactPerson = ref1[0], setSelectedCompanyContactPerson = ref1[1];
    var ref2 = (0,react.useState)(null), selectedCompanyFirstInterviewDate = ref2[0], setSelectedCompanyFirstInterviewDate = ref2[1];
    var ref3 = (0,react.useState)(true), isHiddenColumnSettingModal = ref3[0], setIsHiddenColumnSettingModal = ref3[1];
    var ref4 = (0,react.useState)(true), isHiddenSourcingRouteCandidateModal = ref4[0], setIsHiddenSourcingRouteCandidateModal = ref4[1];
    var ref5 = (0,react.useState)(true), isHiddenMyLabelCandidateModal = ref5[0], setIsHiddenMyLabelCandidateModal = ref5[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var getColumnSetting = function() {
        var columnNamesHash = getColumnNames(props.latestPlan, props.earlyAccess);
        var initialColumnNames = Object.keys(columnNamesHash).filter(function(key) {
            // @ts-ignore
            return columnNamesHash[key].selected;
        }).sort(function(a, b) {
            return(// @ts-ignore
            columnNamesHash[a].displayOrder - columnNamesHash[b].displayOrder);
        });
        // クエリに fields の指定がある場合、他の場所で column のセットがされているので、
        // ここでは column セッティングをいじらない
        var query = router.query["fields"];
        if (typeof query === "string") {
            var queryArray = query.split(",");
            queryArray !== initialColumnNames;
            return;
        }
        // ユーザーが保存したカラム設定がある場合、それを優先して使う
        var columnSetting = localStorage.getItem("column_setting");
        if (columnSetting) {
            props.handleColmunSetting(columnSetting.split(","));
            return;
        }
        // permission によって初期選択の列を変更する
        props.handleColmunSetting(initialColumnNames);
    };
    (0,react.useEffect)(function() {
        getColumnSetting();
    }, [
        props.latestPlan,
        props.earlyAccess
    ]);
    (0,react.useEffect)(function() {
        dispatch(fetchCompanies());
        dispatch(refreshSourcingAnnotationCandidates());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ref6 = (0,react.useState)(undefined), selectedCompanyShortname = ref6[0], setSelectedCompanyShortname = ref6[1];
    var isPanelOpened = function() {
        return selectedCompanyShortname !== undefined;
    };
    var openPanel = function(v) {
        return setSelectedCompanyShortname(v);
    };
    var closePanel = function() {
        return setSelectedCompanyShortname(undefined);
    };
    var handleSourcingRouteModalClose = function() {
        setIsHiddenSourcingRouteCandidateModal(true);
    };
    var handleMyLabelModalClose = function() {
        setIsHiddenMyLabelCandidateModal(true);
    };
    var handleSelectSourcingRoute = function(companyId, sourcingRouteId, sourcingRouteName) {
        props.onSelectSourcingRoute(companyId, sourcingRouteId.id, sourcingRouteName, user);
    };
    var handleDeselectSourcingRoute = function(companyId) {
        props.onDeselectSourcingRoute(companyId, user);
    };
    var handleRequestEditSourcingRouteModal = function() {
        setIsHiddenSourcingRouteCandidateModal(false);
    };
    var handleSelectMyLabel = function(myLabelId, companyId) {
        props.onSelectMyLabel(companyId, myLabelId, user);
    };
    var handleDeselectMyLabel = function(myLabelId, companyId) {
        props.onDeselectMyLabel(companyId, myLabelId, user);
    };
    var handleRequestEditMyLabelModal = function() {
        setIsHiddenMyLabelCandidateModal(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay/* LoadingOverlay */.f, {
                active: props.searching
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "search-result-header",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:56px;display:flex;justify-content:space-between;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultCount, {
                                value: props.count
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "header-buttons",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(column_setting_ColumnSetting, {
                                        isHidden: isHiddenColumnSettingModal,
                                        onOpen: function() {
                                            return setIsHiddenColumnSettingModal(false);
                                        },
                                        onClose: function() {
                                            return setIsHiddenColumnSettingModal(true);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(share_url_ShareUrl, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay/* LoadingOverlay */.f, {
                                        active: props.downloading,
                                        styles: {
                                            spinner: function(base) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                                                    width: "1em",
                                                    height: "1em",
                                                    margin: 0,
                                                    "& svg circle": {
                                                        stroke: dist/* colors.gray70 */.O9.gray70,
                                                        strokeWidth: 10,
                                                        opacity: 0.5
                                                    }
                                                });
                                            },
                                            overlay: function(base) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                                                    background: "transparent"
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadButton, {
                                            resultCount: props.count,
                                            downloadLimit: 1000,
                                            isLoading: props.downloading,
                                            allowed: props.role === "moderator" || props.role === "enterprise" && props.allowed,
                                            enterprise: props.role === "moderator" || props.role === "enterprise",
                                            restricted: props.role !== "moderator" && props.restricted,
                                            onClick: function() {
                                                (0,tracking/* trackEvent */.L9)(user, "企業一覧のダウンロード");
                                                props.onDownload();
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    props.count > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultTable, {
                                companies: props.data,
                                sorting: props.sorting,
                                columns: props.columns,
                                candidates: props.sourcingAnnotationsCandidatesState,
                                onToggle: props.onToggleSort,
                                condition: props.condition,
                                statusCondition: props.statusCondition,
                                selectedCompanyStatus: selectedCompanyStatus,
                                setSelectedCompanyStatus: setSelectedCompanyStatus,
                                selectedCompanyContactPerson: selectedCompanyContactPerson,
                                setSelectedCompanyContactPerson: setSelectedCompanyContactPerson,
                                selectedCompanyFirstInterviewDate: selectedCompanyFirstInterviewDate,
                                setSelectedCompanyFirstInterviewDate: setSelectedCompanyFirstInterviewDate,
                                onTriggerEditStatus: openPanel,
                                selectedCompanyShortname: selectedCompanyShortname,
                                onSelectSourcingRoute: handleSelectSourcingRoute,
                                onDeselectSourcingRoute: handleDeselectSourcingRoute,
                                onRequestEditSourcingRouteModal: handleRequestEditSourcingRouteModal,
                                onSelectMyLabel: handleSelectMyLabel,
                                onDeselectMyLabel: handleDeselectMyLabel,
                                onRequestEditMyLabelModal: handleRequestEditMyLabelModal
                            }),
                            (selectedCompanyStatus != null || selectedCompanyContactPerson != null || selectedCompanyFirstInterviewDate != undefined) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* Cover */.Y, {
                                handleClick: function() {
                                    setSelectedCompanyStatus(null);
                                    setSelectedCompanyContactPerson(null);
                                    setSelectedCompanyFirstInterviewDate(null);
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyStatusesOptionDropDown, {
                                selectedCompanyStatus: selectedCompanyStatus,
                                setSelectedCompanyStatus: setSelectedCompanyStatus,
                                statuses: props.statuses,
                                onSelectStatusBlank: props.onSelectStatusBlank,
                                onSelectStatus: props.onSelectStatus
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyContactPersonsOptionDropDown, {
                                selectedCompanyContactPerson: selectedCompanyContactPerson,
                                setSelectedCompanyContactPerson: setSelectedCompanyContactPerson,
                                contactPersons: props.contactPersons,
                                onSelectContactPersonBlank: props.onSelectContactPersonBlank,
                                onSelectContactPerson: props.onSelectContactPerson
                            }),
                            selectedCompanyFirstInterviewDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;z-index:2;top:", selectedCompanyFirstInterviewDate.target.getBoundingClientRect().top + window.pageYOffset + 37, "px;left:", selectedCompanyFirstInterviewDate.target.getBoundingClientRect().left + window.pageXOffset, "px;margin-top:16px;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(company_firstInterview_date_calender/* CompanyFirstInterviewDateCalender */.G, {
                                    shortName: selectedCompanyFirstInterviewDate.shortName,
                                    firstInterviewDate: selectedCompanyFirstInterviewDate.selectedFirstInterviewDate,
                                    onSelectFirstInterviewDateBlank: function(companyId, user) {
                                        setSelectedCompanyFirstInterviewDate(null);
                                        props.onSelectFirstInterviewDateBlank(companyId, user);
                                    },
                                    onSelectFirstInterviewDate: function(companyId, firstInterviewDate, user) {
                                        setSelectedCompanyFirstInterviewDate(null);
                                        props.onSelectFirstInterviewDate(companyId, firstInterviewDate, user);
                                    }
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {})
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "result-table is-empty",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;color:#d9d9d9;font-size:22px;vertical-align:middle;line-height:200px;border-top:1px solid #d9d9d9;"),
                        children: "検索結果が見つかりませんでした"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "u-justify-center u-my10 u-flex-row",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-block:8px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination, {
                            limit: props.limit,
                            offset: props.offset,
                            total: props.count,
                            onChange: props.onPageChange,
                            page: props.page
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationPanel/* SourcingAnnotationPanel */.h, {
                isOpen: isPanelOpened(),
                companyShortname: selectedCompanyShortname,
                myLabels: props.sourcingAnnotationsCandidatesState.myLabels,
                sourcingRoutes: props.sourcingAnnotationsCandidatesState.sourcingRoutes,
                onSelectStatus: function(companyId, status, user) {
                    props.onSelectStatus(status.id, companyId, status.name, user);
                },
                onSelectStatusBlank: props.onSelectStatusBlank,
                onSelectContactPerson: function(companyContactPerson, user) {
                    props.onSelectContactPerson(companyContactPerson.userId, companyContactPerson.companyId, companyContactPerson.firstName || "", companyContactPerson.lastName || "", user);
                },
                onSelectContactPersonBlank: props.onSelectContactPersonBlank,
                onSelectMyLabel: handleSelectMyLabel,
                onDeselectMyLabel: handleDeselectMyLabel,
                onRequestEditMyLabelModal: handleRequestEditMyLabelModal,
                onSelectFirstInterviewDate: props.onSelectFirstInterviewDate,
                onSelectFirstInterviewDateBlank: props.onSelectFirstInterviewDateBlank,
                onSelectSourcingRoute: props.onSelectSourcingRoute,
                onDeselectSourcingRoute: handleDeselectSourcingRoute,
                onRequestEditSourcingRouteModal: handleRequestEditSourcingRouteModal,
                onUpdateMemo: props.onUpdateMemo,
                closePanel: closePanel
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationCandidateEditModal/* SourcingAnnotationCandidateEditModal */.$, {
                isHidden: isHiddenSourcingRouteCandidateModal,
                modalId: "sourcing-route",
                modalName: "ソーシングルート",
                onCreate: props.onCreateSourcingRoute,
                onUpdate: props.onUpdateSourcingRouteName,
                onDelete: props.onDeleteSourcingRoute,
                onClose: handleSourcingRouteModalClose,
                children: props.sourcingAnnotationsCandidatesState.sourcingRoutes
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationCandidateEditModal/* SourcingAnnotationCandidateEditModal */.$, {
                isHidden: isHiddenMyLabelCandidateModal,
                modalId: "my-label",
                modalName: "マイラベル",
                onCreate: props.onCreateMyLabel,
                onUpdate: props.onUpdateMyLabelName,
                onDelete: props.onDeleteMyLabel,
                onClose: handleMyLabelModalClose,
                children: props.sourcingAnnotationsCandidatesState.myLabels
            })
        ]
    });
};
var search_result_mapStateToProps = function(state) {
    return {
        limit: state.condition.limit,
        offset: state.condition.offset,
        page: state.condition.page,
        sorting: {
            sort: state.condition.sort,
            order: state.condition.order
        },
        count: state.result.count,
        data: state.result.data,
        columns: state.column,
        condition: state.condition,
        statusCondition: state.statusCondition,
        role: state.permission.role,
        restricted: state.permission.restricted,
        allowed: state.permission.allowed,
        latestPlan: state.permission.latestPlan,
        earlyAccess: state.permission.earlyAccess,
        searching: state.app.searching,
        downloading: state.app.downloading,
        errors: state.error.errors,
        statuses: state.statuses.data,
        contactPersons: state.contactPersons.data,
        sourcingAnnotationsCandidatesState: state.sourcingAnnotationsCandidates
    };
};
var search_result_mapDispatchToProps = function(dispatch) {
    return {
        handleColmunSetting: function(names) {
            dispatch(updateColumns(names));
        },
        onPageChange: function(offset, page) {
            dispatch(changePage({
                offset: offset,
                page: page
            }));
        },
        onToggleSort: function(name) {
            dispatch(toggleSort(name));
        },
        onDownload: function() {
            dispatch(requestDownload());
        },
        onSelectStatus: function(id, companyId, name, user) {
            dispatch(changeStatus({
                id: id,
                companyId: companyId,
                name: name,
                user: user
            }));
        },
        onSelectContactPerson: function(id, companyId, firstName, lastName, user) {
            dispatch(changeContactPerson({
                id: id,
                companyId: companyId,
                firstName: firstName,
                lastName: lastName,
                user: user
            }));
        },
        onSelectStatusBlank: function(companyId, user) {
            dispatch(deleteCompanyStatus({
                companyId: companyId,
                user: user
            }));
        },
        onSelectContactPersonBlank: function(companyId, user) {
            dispatch(deleteCompanyContactPerson({
                companyId: companyId,
                user: user
            }));
        },
        onUpdateMemo: function(companyId, memo) {
            dispatch(updateCompanyMemo({
                companyId: companyId,
                memo: memo
            }));
        },
        onSelectFirstInterviewDate: function(companyId, firstInterviewDate, user) {
            dispatch(updateCompanyFirstInterviewDate({
                companyId: companyId,
                firstInterviewDate: firstInterviewDate,
                user: user
            }));
        },
        onSelectFirstInterviewDateBlank: function(companyId, user) {
            dispatch(deleteCompanyFirstInterviewDate({
                companyId: companyId,
                user: user
            }));
        },
        onSelectSourcingRoute: function(companyId, sourcingRouteId, sourcingRouteName, user) {
            dispatch(changeSourcingRoute({
                companyId: companyId,
                sourcingRouteId: sourcingRouteId,
                sourcingRouteName: sourcingRouteName,
                user: user
            }));
        },
        onDeselectSourcingRoute: function(companyId, user) {
            dispatch(detouchCompanySourcingRoute({
                companyId: companyId,
                user: user
            }));
        },
        onCreateSourcingRoute: function(sourcingRouteName) {
            dispatch(createSourcingRoute({
                sourcingRouteName: sourcingRouteName
            }));
        },
        onUpdateSourcingRouteName: function(id, name) {
            dispatch(updateSourcingRoute({
                id: id,
                name: name
            }));
        },
        onDeleteSourcingRoute: function(id) {
            dispatch(deleteSourcingRoute({
                id: id
            }));
        },
        onSelectMyLabel: function(companyId, myLabelId, user) {
            dispatch(putCompanyMyLabel({
                companyId: companyId,
                myLabelId: myLabelId,
                user: user
            }));
        },
        onDeselectMyLabel: function(companyId, myLabelId, user) {
            dispatch(deleteCompanyMyLabel({
                companyId: companyId,
                myLabelId: myLabelId,
                user: user
            }));
        },
        onCreateMyLabel: function(name) {
            dispatch(createMyLabel({
                name: name
            }));
        },
        onUpdateMyLabelName: function(id, name) {
            dispatch(updateMyLabel({
                id: id,
                name: name
            }));
        },
        onDeleteMyLabel: function(id) {
            dispatch(deleteMyLabel({
                id: id
            }));
        }
    };
};
/* harmony default export */ var search_result = ((0,es/* connect */.$j)(search_result_mapStateToProps, search_result_mapDispatchToProps)(SearchResult));

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(11201);
;// CONCATENATED MODULE: ./components/pages/companies/reducers/app.ts



var app_init = {
    open: false,
    searching: false,
    downloading: false,
    openingCondition: null
};
var app_toggle = function(prev, next) {
    return prev === next ? null : next;
};
function app() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : app_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case TOGGLE_SELECTOR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                open: !state.open
            });
        case TOGGLE_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                openingCondition: app_toggle(state.openingCondition, action.payload)
            });
        case ADD_CONDITION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                open: false,
                openingCondition: action.payload
            });
        case REQUEST_SEARCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searching: true
            });
        case SUCCESS_SEARCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searching: false
            });
        case FAILURE_SEARCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searching: false
            });
        case REQUEST_DOWNLOAD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                downloading: true
            });
        case SUCCESS_DOWNLOAD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                downloading: false
            });
        case FAILURE_DOWNLOAD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                downloading: false
            });
        case SET_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                searching: false
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/contactPerson.ts



var contactPerson_init = {
    data: []
};
function contactPersons() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : contactPerson_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_FETCH_CONTACT_PERSONS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload.users
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/contactPersonsFilterList.ts



var contactPersonsFilterList_init = {
    data: []
};
function contactPersonsFilterList_contactPersons() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : contactPersonsFilterList_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload.users
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/error.ts
// @flow



var error_init = {
    errors: []
};
function error() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : error_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SET_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errors: action.payload
            });
        case CLEAR_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                errors: []
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/permission.ts
// @flow



var permission_init = {
    role: null,
    latestPlan: false,
    restricted: false,
    allowed: false,
    earlyAccess: false,
    error: false
};
/* harmony default export */ function permission() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : permission_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_FETCH_PERMISSION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                role: action.payload.role,
                latestPlan: action.payload.latestPlan,
                restricted: action.payload.restricted,
                allowed: action.payload.allowed,
                earlyAccess: action.payload.earlyAccess
            });
        case FAIL_FETCH_PERMISSION:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: true
            });
    }
    return state;
};

;// CONCATENATED MODULE: ./components/pages/companies/reducers/result.ts
// @flow





var result_init = {
    count: 0,
    data: [],
    error: false
};
function result() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : result_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_SEARCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, action.payload), {
                error: false
            });
        case FAILURE_SEARCH:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: true
            });
        case SUCCESS_CHANGE_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(d) {
                    var ref, ref1;
                    return d.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                        investingStatus: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.name,
                        investingStatusUpdated: (0,format["default"])(new Date(), "yyyy/MM/dd")
                    }) : d;
                })
            });
        case SUCCESS_CHANGE_CONTACT_PERSON:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(d) {
                    var ref;
                    return d.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                        contactPerson: {
                            firstName: action.payload.firstName,
                            lastName: action.payload.lastName
                        }
                    }) : d;
                })
            });
        case SUCCESS_DELETE_COMPANY_STATUS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(d) {
                    var ref;
                    return d.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                        investingStatus: undefined,
                        investingStatusUpdated: undefined
                    }) : d;
                })
            });
        case SUCCESS_DELETE_COMPANY_CONTACT_PERSON:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(d) {
                    var ref;
                    return d.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                        contactPerson: undefined
                    }) : d;
                })
            });
        case SUCCESS_UPDATE_COMPANY_MEMO:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        memo: {
                            content: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.memo
                        }
                    }) : company;
                })
            });
        case SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        firstInterviewDate: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.firstInterviewDate
                    }) : company;
                })
            });
        case SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        firstInterviewDate: undefined
                    }) : company;
                })
            });
        case SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1, ref2;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        sourcingRoute: {
                            id: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.sourcingRouteId,
                            name: (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.sourcingRouteName
                        }
                    }) : company;
                })
            });
        case SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        sourcingRoute: undefined
                    }) : company;
                })
            });
        case SUCCESS_UPDATE_SOURCING_ROUTE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1, ref2, ref3;
                    return ((ref = company.sourcingRoute) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.id) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        sourcingRoute: {
                            id: (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.id,
                            name: (ref3 = action.payload) === null || ref3 === void 0 ? void 0 : ref3.name
                        }
                    }) : company;
                })
            });
        case SUCCESS_DELETE_SOURCING_ROUTE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1;
                    return ((ref = company.sourcingRoute) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.id) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        sourcingRoute: undefined
                    }) : company;
                })
            });
        case SUCCESS_UPDATE_COMPANY_MY_LABELS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: state.data.map(function(company) {
                    var ref, ref1;
                    return company.companyId === ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.companyId) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                        myLabels: (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.companyMyLabels
                    }) : company;
                })
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/statusPanel.ts
var initialState = {
    statusPanelOpen: false
};
function statusPanel() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "CLOSE_STATUS_PANEL":
            return {
                statusPanelOpen: false
            };
        case "OPEN_STATUS_PANEL":
            return {
                statusPanelOpen: true
            };
        default:
            return state;
    }
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/statuses.ts



var statuses_init = {
    data: []
};
function statuses() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : statuses_init, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_FETCH_STATUSES:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload.statuses
            });
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/sourcingAnnotationCandidates.ts


var sourcingAnnotationCandidates_initialState = {
    sourcingRoutes: [],
    myLabels: []
};
function sourcingAnnotationsCandidates() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : sourcingAnnotationCandidates_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES:
            return (0,_object_spread/* default */.Z)({}, state, action.payload);
    }
    return state;
}

;// CONCATENATED MODULE: ./components/pages/companies/reducers/index.ts
// @flow












var rootReducer = (0,redux/* combineReducers */.UY)({
    app: app,
    condition: condition,
    statusCondition: condition,
    result: result,
    column: column,
    permission: permission,
    error: error,
    statuses: statuses,
    contactPersons: contactPersons,
    contactPersonsFilterList: contactPersonsFilterList_contactPersons,
    statusPanel: statusPanel,
    sourcingAnnotationsCandidates: sourcingAnnotationsCandidates
});
/* harmony default export */ var reducers = (rootReducer);

// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(94500);
;// CONCATENATED MODULE: ./components/pages/companies/stores.ts






function configureStore() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)();
    var middlewares = [
        sagaMiddleware
    ];
    if (false) {}
    var store = (0,redux/* createStore */.MT)(reducers, initialState, redux/* applyMiddleware.apply */.md.apply(void 0, (0,_to_consumable_array/* default */.Z)(middlewares)));
    sagaMiddleware.run(rootSaga);
    return store;
}

;// CONCATENATED MODULE: ./pages/companies/index.tsx














var store = configureStore();
var CompaniesPage = function() {
    var user = (0,AuthContext/* useUser */.a)();
    var router = (0,next_router.useRouter)();
    (0,react.useLayoutEffect)(function() {
        var searchCondition = JSON.parse(sessionStorage.getItem("search_condition"));
        if (searchCondition && window.location.href !== searchCondition.url) {
            router.push(searchCondition.url);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0,lib_user/* isEnterprise */.ko)(user) || (0,lib_user/* isTrial */.pN)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(es/* Provider */.zt, {
            store: store,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* SearchCompaniesHead */.HG, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "plume companies-page",
                        "data-test-id": "companies-page",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overflow-x:hidden;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                className: "search-condition",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:10px 24px 20px;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Breadcrumb/* Breadcrumb */.aG, {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:12px;"),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbLink */.At, {
                                                href: "/",
                                                passHref: true,
                                                children: "ホーム"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbItem */.gN, {
                                                className: "in-breadcrumb-item",
                                                children: "スタートアップ"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_condition, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "search-result",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_result, {})
                            })
                        ]
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseGuide/* EnterpriseGuideTemplate */.P, {});
};
/* harmony default export */ var companies = (CompaniesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,4885,8687,519,8674,8101,9198,5414,535,4769,774,3431,3954,8328,9967,8331,9774,2888,179], function() { return __webpack_exec__(62953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);